/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _SecurityManager = __webpack_require__(1);
	
	var _SecurityManager2 = _interopRequireDefault(_SecurityManager);
	
	var _LegacyStorage = __webpack_require__(2);
	
	var _LegacyStorage2 = _interopRequireDefault(_LegacyStorage);
	
	var _MemoryStorage = __webpack_require__(3);
	
	var _MemoryStorage2 = _interopRequireDefault(_MemoryStorage);
	
	var _DataAccess = __webpack_require__(4);
	
	var _DataAccess2 = _interopRequireDefault(_DataAccess);
	
	var _ModelMapper = __webpack_require__(5);
	
	var _ModelMapper2 = _interopRequireDefault(_ModelMapper);
	
	var _NavigationManager = __webpack_require__(14);
	
	var _NavigationManager2 = _interopRequireDefault(_NavigationManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(78);
	
	var Application = function () {
	  function Application() {
	    _classCallCheck(this, Application);
	
	    this.version = '2.0.0';
	    this.buildTimestamp = 'Sat Nov 07 2020 22:58:20 GMT+0100 (Central European Standard Time)';
	    this.message = function (message) {
	      console.log('Got message', message);
	      dispatchEvent(new Event(message));
	    };
	    this.session = {};
	
	    this.securityManager = new _SecurityManager2.default();
	    this.externalStorage = new _LegacyStorage2.default('/api');
	    this.localStorage = new _MemoryStorage2.default();
	    this.navigationManager = null;
	    this.dataAccess = new _DataAccess2.default(this.securityManager, this.localStorage, this.externalStorage, this.message);
	    this.modelMapper = new _ModelMapper2.default();
	    this.exceptionHandler = function (e) {
	      if (e) {
	        if (e.stack) {
	          console.error(e, e.stack);
	        } else {
	          console.error(e);
	        }
	      } else {
	        console.error('Uncaught exception');
	      }
	    };
	    this.bootMessage = null;
	    this.reloadLink = null;
	    this.indicator = null;
	    this.viewport = null;
	    this.delayedNavigation = false;
	    this.License = null;
	  }
	
	  _createClass(Application, [{
	    key: 'getUtcTimestamp',
	    value: function getUtcTimestamp(date) {
	      return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
	    }
	  }, {
	    key: 'getLocalTimestamp',
	    value: function getLocalTimestamp(date) {
	      return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.viewport = document.getElementById('viewport');
	      var boot = document.getElementById('boot');
	
	      this.bootMessage = document.createElement('div');
	      this.bootMessage.className = 'messages';
	      boot.appendChild(this.bootMessage);
	      this.createReloadLink();
	      boot.appendChild(this.reloadLink);
	      this.createIndicator();
	      document.body.appendChild(this.indicator);
	
	      this.setMessage('Versie: ' + this.version + ' (' + this.buildTimestamp + ')');
	      this.setMessage('Bezig met opstarten...');
	
	      onerror = function onerror() {
	        _this.setMessage('Helaas, door een onbekende fout met uw externe opslag kan PRIM niet gestart worden.');
	        _this.showReloadLink();
	      };
	
	      addEventListener('write', this.showWriteIndicator.bind(this));
	      addEventListener('writePending', this.showWritePendingIndicator.bind(this));
	      addEventListener('writeFailed', this.showWriteFailedIndicator.bind(this));
	      addEventListener('read', this.showReadIndicator.bind(this));
	      addEventListener('readPending', this.showReadPendingIndicator.bind(this));
	
	      this.capabilityCheck();
	    }
	  }, {
	    key: 'writeStatus',
	    value: function writeStatus() {
	      document.body.classList.remove('writeFailed');
	      document.body.classList.add('writing');
	    }
	  }, {
	    key: 'writeFailedStatus',
	    value: function writeFailedStatus() {
	      document.body.classList.remove('writing');
	      document.body.classList.add('writeFailed');
	    }
	  }, {
	    key: 'clearStatus',
	    value: function clearStatus() {
	      document.body.classList.remove('writeFailed');
	      document.body.classList.remove('writing');
	    }
	  }, {
	    key: 'setMessage',
	    value: function setMessage(message) {
	      this.bootMessage.innerHTML += message + '<br />';
	
	      var isScrolledToBottom = this.bootMessage.scrollHeight - this.bootMessage.clientHeight <= this.bootMessage.scrollTop + 1;
	
	      if (isScrolledToBottom) {
	        this.bootMessage.scrollTop = this.bootMessage.scrollHeight - this.bootMessage.clientHeight;
	      }
	    }
	  }, {
	    key: 'showReloadLink',
	    value: function showReloadLink() {
	      this.reloadLink.setAttribute('style', '');
	    }
	  }, {
	    key: 'initApplication',
	    value: function initApplication() {
	      this.initNavigation('/entercredentials/');
	    }
	  }, {
	    key: 'initExternalStorage',
	    value: function initExternalStorage() {
	      var _this2 = this;
	
	      this.setMessage('Controle gegevens uit externe opslag...');
	      this.externalStorage.status().then(function () {
	        _this2.externalStorage.open().then(function () {
	          window.PRIM.navigate('/start/');
	        }, function () {
	          window.PRIM.navigate('/offline/');
	        }).catch(function (e) {
	          window.PRIM.navigate('/offline/');
	        });
	      }, function (status) {
	        switch (status) {
	          case 'invalid':
	            window.PRIM.navigate('/reentercredentials/');
	            break;
	          default:
	            window.PRIM.navigate('/offline/');
	            break;
	        }
	      }).catch(function (e) {
	        window.PRIM.navigate('/offline/');
	      });
	    }
	  }, {
	    key: 'loadCredentials',
	    value: function loadCredentials() {
	      var _this3 = this;
	
	      return new Promise(function (resolve, reject) {
	        _this3.localStorage.get({ name: 'settings' }, 'credentials').then(function (credentials) {
	          if (credentials && credentials.username && credentials.password) {
	            _this3.externalStorage.setCredentials(credentials.username, credentials.password);
	            resolve();
	            return;
	          }
	          console.warn('Failed to retrieve settings from local storage.');
	          reject();
	        }, function () {
	          console.warn('Failed to retrieve settings from local storage.');
	          reject();
	        });
	      });
	    }
	  }, {
	    key: 'saveCredentials',
	    value: function saveCredentials(username, password) {
	      var _this4 = this;
	
	      return new Promise(function (resolve, reject) {
	        _this4.localStorage.put({ name: 'settings' }, { id: 'credentials', username: username, password: password }).then(resolve, function () {
	          console.warn('Failed to persist settings from local storage.');
	          reject();
	        });
	      });
	    }
	  }, {
	    key: 'capabilityCheck',
	    value: function capabilityCheck() {
	      this.setMessage('Controle browser...');
	
	      if (typeof Promise === 'undefined') {
	        this.setMessage('Helaas, uw browser voldoet niet aan de eisen om deze applicatie te kunnen draaien. Promises zijn niet beschikbaar. Werk indien mogelijk uw browser naar een nieuwere versie bij.');
	        this.showReloadLink();
	        return;
	      }
	
	      if (typeof window.crypto === 'undefined' || typeof window.crypto.subtle === 'undefined' && typeof window.crypto.webkitSubtle === 'undefined') {
	        this.setMessage('Helaas, uw browser voldoet niet aan de eisen voor cryptografie. Veiligheid kan niet worden gegarandeerd. Werk indien mogelijk uw browser naar een nieuwere versie bij.');
	        this.showReloadLink();
	        return;
	      }
	
	      this.initApplication();
	    }
	  }, {
	    key: 'createReloadLink',
	    value: function createReloadLink(visible) {
	      this.reloadLink = document.createElement('a');
	      this.reloadLink.href = '/';
	      if (!visible) {
	        this.reloadLink.setAttribute('style', 'display: none');
	      }
	      this.reloadLink.innerHTML = 'Herstarten';
	      this.reloadLink.onclick = function (e) {
	        e.preventDefault();
	        location.reload(true);
	      };
	    }
	  }, {
	    key: 'createIndicator',
	    value: function createIndicator() {
	      this.indicator = document.createElement('div');
	      this.indicator.id = 'loader';
	    }
	  }, {
	    key: 'showWritePendingIndicator',
	    value: function showWritePendingIndicator() {
	      this.indicator.className = 'writePending';
	    }
	  }, {
	    key: 'showWriteFailedIndicator',
	    value: function showWriteFailedIndicator() {
	      this.indicator.className = 'writeFailed';
	    }
	  }, {
	    key: 'showWriteIndicator',
	    value: function showWriteIndicator() {
	      this.indicator.className = 'write';
	    }
	  }, {
	    key: 'showReadPendingIndicator',
	    value: function showReadPendingIndicator() {
	      this.indicator.className = 'readPending';
	    }
	  }, {
	    key: 'showReadIndicator',
	    value: function showReadIndicator() {
	      this.indicator.className = 'read';
	    }
	  }, {
	    key: 'initNavigation',
	    value: function initNavigation(start) {
	      this.setMessage('Initialisatie navigatie...');
	      this.navigationManager = new _NavigationManager2.default(this.viewport);
	      if (!start) {
	        window.PRIM.navigate('/welcome/');
	      } else {
	        window.PRIM.navigate(start);
	      }
	    }
	  }, {
	    key: 'setLicense',
	    value: function setLicense(license) {
	      this.License = license;
	    }
	  }, {
	    key: 'hasReadonlyModuleAccess',
	    value: function hasReadonlyModuleAccess(module) {
	      return !this.License || !this.License.valid || this.License.moduleAccess[module] && this.License.moduleAccess[module] !== 'readwrite' && this.License.moduleAccess[module] !== 'demo';
	    }
	  }, {
	    key: 'navigate',
	    value: function navigate(uri, replace) {
	      if (replace) {
	        history.replaceState(null, document.title, '#' + uri);
	      } else {
	        history.pushState(null, document.title, '#' + uri);
	        this.navigationManager.handleNavigation();
	      }
	    }
	  }, {
	    key: 'cancelDelayedNavigation',
	    value: function cancelDelayedNavigation() {
	      this.delayedNavigation = false;
	    }
	  }, {
	    key: 'initDelayedNavigation',
	    value: function initDelayedNavigation() {
	      this.delayedNavigation = true;
	    }
	  }, {
	    key: 'isDelayedNavigationActive',
	    value: function isDelayedNavigationActive() {
	      return this.delayedNavigation === true;
	    }
	  }, {
	    key: 'getUUID',
	    value: function getUUID() {
	      var buffer = new Uint16Array(8);
	      window.crypto.getRandomValues(buffer);
	
	      var S4 = function S4(num) {
	        var result = num.toString(16);
	        while (result.length < 4) {
	          result = '0' + result;
	        }
	        return result;
	      };
	
	      return S4(buffer[0]) + S4(buffer[1]) + '-' + S4(buffer[2]) + '-' + S4(buffer[3]) + '-' + S4(buffer[4]) + '-' + S4(buffer[5]) + S4(buffer[6]) + S4(buffer[7]);
	    }
	  }]);
	
	  return Application;
	}();
	
	window.PRIM = null;
	
	if (typeof addEventListener === 'function') {
	  addEventListener('load', function () {
	    window.PRIM = new Application();
	    onerror = window.PRIM.exceptionHandler;
	    window.PRIM.init();
	  });
	} else {
	  window.onload = function () {
	    var boot = document.getElementById('boot');
	    var bootMessage = document.createElement('div');
	    bootMessage.innerHTML = 'Helaas, uw browser voldoet niet aan de eisen om deze applicatie te kunnen draaien. Werk indien mogelijk uw browser naar een nieuwere versie bij.';
	    var reloadLink = document.createElement('a');
	    reloadLink.href = '.';
	    reloadLink.setAttribute('style', 'display: none');
	    reloadLink.innerText = 'Herstarten';
	    reloadLink.onclick = function (e) {
	      e.preventDefault();
	      location.reload(true);
	    };
	    boot.appendChild(bootMessage);
	    boot.appendChild(reloadLink);
	  };
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SecurityManager = function () {
	  function SecurityManager() {
	    _classCallCheck(this, SecurityManager);
	
	    this.cryptoSubtle = typeof window.crypto !== 'undefined' ? window.crypto.subtle || window.crypto.webkitSubtle : null;
	    this.textDecoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8') : null;
	    this.textEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : null;
	
	    this.salt = 'aaaabbbbccccdddd This is NOT secret!!';
	    this.passphraseAlgorithm = {
	      name: 'PBKDF2'
	    };
	    this.keyAlgorithm = {
	      name: 'PBKDF2',
	      hash: 'SHA-512',
	      iterations: 1000,
	      salt: this.textEncoder ? this.textEncoder.encode(this.salt) : null
	    };
	    this.encryptionAlgorithm = {
	      name: 'AES-CBC',
	      length: 256
	    };
	    this.decryptionAlgorithm = {
	      name: 'AES-CBC'
	    };
	    this.iv = null;
	    this.key = null;
	  }
	
	  _createClass(SecurityManager, [{
	    key: 'setDataKey',
	    value: function setDataKey(passphrase) {
	      var _this = this;
	
	      return new Promise(function (resolve, reject) {
	        _this.passphraseKey(passphrase).then(function (passphraseKey) {
	          _this.encryptionKey(passphraseKey).then(function (dataKey) {
	            _this.key = dataKey;
	            resolve();
	          }, reject).catch(reject);
	        }, reject).catch(reject);
	      });
	    }
	  }, {
	    key: 'passphraseKey',
	    value: function passphraseKey(passphrase) {
	      return this.cryptoSubtle.importKey('raw', this.textEncoder.encode(passphrase), this.passphraseAlgorithm, false, ['deriveKey']);
	    }
	  }, {
	    key: 'encryptionKey',
	    value: function encryptionKey(key) {
	      return this.cryptoSubtle.deriveKey(this.keyAlgorithm, key, this.encryptionAlgorithm, true, ['encrypt', 'decrypt']);
	    }
	  }, {
	    key: 'encryptData',
	    value: function encryptData(data) {
	      var _this2 = this;
	
	      this.iv = new Uint8Array(16);
	      window.crypto.getRandomValues(this.iv);
	
	      return new Promise(function (resolve, reject) {
	        _this2.encrypt(_this2.textEncoder.encode(data), _this2.key, _this2.iv).then(function (encryptedData) {
	          var result = new Uint8Array(_this2.iv.byteLength + encryptedData.byteLength);
	          result.set(_this2.iv, 0);
	          result.set(new Uint8Array(encryptedData), _this2.iv.byteLength);
	          resolve(result);
	        }, reject).catch(reject);
	      });
	    }
	  }, {
	    key: 'decryptData',
	    value: function decryptData(data) {
	      var _this3 = this;
	
	      return new Promise(function (resolve, reject) {
	        _this3.iv = data.slice(0, 16);
	        var encryptedData = data.slice(16);
	
	        if (encryptedData.byteLength > 0) {
	          _this3.decrypt(encryptedData, _this3.key, _this3.iv).then(function (decryptedData) {
	            resolve(_this3.textDecoder.decode(decryptedData));
	          }, reject).catch(reject);
	        } else {
	          resolve(null);
	        }
	      });
	    }
	  }, {
	    key: 'encrypt',
	    value: function encrypt(data, key, iv) {
	      var algorithm = Object.assign({}, this.encryptionAlgorithm);
	      algorithm.iv = iv;
	
	      return this.cryptoSubtle.encrypt(algorithm, key, data);
	    }
	  }, {
	    key: 'decrypt',
	    value: function decrypt(data, key, iv) {
	      var algorithm = Object.assign({}, this.decryptionAlgorithm);
	      algorithm.iv = iv;
	
	      return this.cryptoSubtle.decrypt(algorithm, key, data);
	    }
	  }]);
	
	  return SecurityManager;
	}();
	
	exports.default = SecurityManager;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LegacyStorage = function () {
	  function LegacyStorage(endpointUri) {
	    _classCallCheck(this, LegacyStorage);
	
	    this.onclose = function () {};
	
	    this.uri = endpointUri;
	    this.username = null;
	    this.password = null;
	
	    this.cache = {};
	    this.models = [{ name: 'people' }, { name: 'relationships' }, { name: 'positions' }, { name: 'locations' }, { name: 'organisations' }, { name: 'logentries' }, { name: 'educations' }, { name: 'settings', volatile: true }];
	  }
	
	  _createClass(LegacyStorage, [{
	    key: 'getAuthorizationValue',
	    value: function getAuthorizationValue(password) {
	      if (this.username && password) {
	        return 'Basic ' + btoa(this.username + ':' + password);
	      }
	
	      if (this.username && this.password) {
	        return 'Basic ' + btoa(this.username + ':' + this.password);
	      }
	
	      return '';
	    }
	  }, {
	    key: 'open',
	    value: function open(username, password) {
	      var _this = this;
	
	      if (username && password) {
	        this.setCredentials(username, password);
	      }
	
	      return new Promise(function (resolve) {
	        var modelCount = 0;
	        _this.models.forEach(function (model) {
	          _this.cache[model.name] = {};
	
	          _this.getUncached(model).then(function (modelData) {
	            window.PRIM.setMessage("Ophalen gegevens '" + model.name + "' (" + (modelCount + 1) + ' van ' + _this.models.length + ')...');
	
	            modelData.forEach(function (modelItem) {
	              _this.cache[model.name][modelItem.id] = modelItem;
	            });
	
	            modelCount++;
	
	            if (modelCount === _this.models.length) {
	              resolve();
	            }
	          });
	        });
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.onclose();
	    }
	  }, {
	    key: 'setCredentials',
	    value: function setCredentials(newUsername, newPassword) {
	      if (newUsername) {
	        this.username = newUsername;
	      }
	
	      this.password = newPassword;
	    }
	  }, {
	    key: 'status',
	    value: function status(password) {
	      var _this2 = this;
	
	      return new Promise(function (resolve, reject) {
	        var request = new XMLHttpRequest();
	
	        request.onreadystatechange = function () {
	          if (request.readyState === 4) {
	            if (request.status === 200) {
	              var contentType = request.getResponseHeader('Content-Type');
	              if (contentType === 'application/json') {
	                resolve(JSON.parse(request.responseText));
	              } else {
	                resolve('invalid');
	              }
	            } else if (request.status === 403) {
	              resolve('invalid');
	            } else if (request.status === 404) {
	              var _contentType = request.getResponseHeader('Content-Type');
	              if (_contentType === 'application/json') {
	                resolve('invalid');
	              } else {
	                reject('offline');
	              }
	            } else {
	              reject('offline');
	            }
	          }
	        };
	
	        var fullUri = _this2.uri + '/status';
	        request.onerror = reject;
	        request.open('GET', fullUri, true);
	        request.setRequestHeader('Authorization', _this2.getAuthorizationValue(password));
	        request.send();
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(model, id) {
	      var _this3 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (model.uncached) {
	          return _this3.getUncached(model, id);
	        }
	
	        if (_this3.cache[model.name]) {
	          if (id && _this3.cache[model.name][id]) {
	            resolve(_this3.cache[model.name][id]);
	          } else {
	            var values = [];
	
	            for (var _key in _this3.cache[model.name]) {
	              values.push(_this3.cache[model.name][_key]);
	            }
	
	            resolve(values);
	          }
	        } else {
	          reject();
	        }
	      });
	    }
	  }, {
	    key: 'getIndexes',
	    value: function getIndexes(model) {
	      var _this4 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (_this4.cache[model.name]) {
	          var indexes = {};
	          var values = [];
	
	          for (var id in _this4.cache[model.name]) {
	            var value = _this4.cache[model.name][id][key];
	
	            if (value && values.indexOf(value) === -1) {
	              values.push(value);
	            }
	          }
	
	          values.sort();
	
	          resolve(values);
	        } else {
	          reject();
	        }
	      });
	    }
	  }, {
	    key: 'changePassword',
	    value: function changePassword(password) {
	      var _this5 = this;
	
	      return new Promise(function (resolve, reject) {
	        var request = new XMLHttpRequest();
	
	        request.onreadystatechange = function () {
	          if (request.readyState === 4) {
	            if (request.status === 200) {
	              resolve();
	            } else {
	              reject();
	            }
	          }
	        };
	
	        var fullUri = _this5.uri + '/password';
	
	        request.onerror = reject;
	        request.open('POST', fullUri, true);
	        request.setRequestHeader('Authorization', _this5.getAuthorizationValue());
	        request.setRequestHeader('Content-Type', 'application/json');
	        request.send(JSON.stringify({ password: password }));
	      });
	    }
	  }, {
	    key: 'getUncached',
	    value: function getUncached(model, id) {
	      var _this6 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (model.volatile) {
	          if (id) {
	            resolve({});
	          } else {
	            resolve([]);
	          }
	          return;
	        }
	
	        var request = new XMLHttpRequest();
	
	        request.onreadystatechange = function () {
	          if (request.readyState === 4) {
	            if (request.status === 200) {
	              var data = JSON.parse(request.responseText);
	
	              resolve(data);
	            } else {
	              reject();
	            }
	          }
	        };
	
	        var fullUri = _this6.uri + '/' + model.name + '/';
	
	        if (id) {
	          fullUri += id;
	        }
	
	        request.onerror = reject;
	        request.open('GET', fullUri, true);
	        request.setRequestHeader('Authorization', _this6.getAuthorizationValue());
	        request.send();
	      });
	    }
	  }, {
	    key: 'put',
	    value: function put(model, data) {
	      var _this7 = this;
	
	      window.PRIM.writeStatus();
	
	      return new Promise(function (resolve, reject) {
	        if (window.PRIM.License.isDemo) {
	          window.PRIM.clearStatus();
	
	          var newData = data;
	
	          if (!newData.id) {
	            newData.id = window.PRIM.getUUID();
	          }
	
	          _this7.cache[model.name][newData.id] = newData;
	          resolve(newData);
	          return;
	        }
	
	        var request = new XMLHttpRequest();
	
	        request.onreadystatechange = function () {
	          if (request.readyState === 4) {
	            if (request.status === 200) {
	              window.PRIM.clearStatus();
	
	              var _newData = JSON.parse(request.responseText);
	
	              _this7.cache[model.name][_newData.id] = _newData;
	              resolve(_newData);
	            } else {
	              window.PRIM.writeFailedStatus();
	
	              reject();
	            }
	          }
	        };
	
	        var fullUri = _this7.uri + '/' + model.name;
	
	        if (data.id) {
	          fullUri += '/' + data.id;
	        } else {
	          delete data.id;
	        }
	
	        request.onerror = reject;
	        request.open(data.id ? 'PUT' : 'POST', fullUri, true);
	        request.setRequestHeader('Authorization', _this7.getAuthorizationValue());
	        request.setRequestHeader('Content-Type', 'application/json');
	        request.send(JSON.stringify(data));
	        data.id = null;
	      }).catch(function (e) {
	        window.PRIM.writeFailedStatus();
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(model, id) {
	      var _this8 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (window.PRIM.License.isDemo) {
	          if (_this8.cache[model.name] && _this8.cache[model.name][id]) {
	            delete _this8.cache[model.name][id];
	          }
	
	          resolve();
	          return;
	        }
	
	        var request = new XMLHttpRequest();
	
	        request.onreadystatechange = function () {
	          if (request.readyState === 4) {
	            if (request.status === 200) {
	              if (_this8.cache[model.name] && _this8.cache[model.name][id]) {
	                delete _this8.cache[model.name][id];
	              }
	              resolve();
	            } else {
	              reject();
	            }
	          }
	        };
	
	        var fullUri = _this8.uri + '/' + model.name + '/' + id;
	        request.onerror = reject;
	        request.open('DELETE', fullUri, true);
	        request.setRequestHeader('Authorization', _this8.getAuthorizationValue());
	        request.send();
	      });
	    }
	  }, {
	    key: 'checkInternet',
	    value: function checkInternet() {
	      var _this9 = this;
	
	      return new Promise(function (resolve, reject) {
	        var request = new XMLHttpRequest();
	
	        request.onreadystatechange = function () {
	          if (request.readyState === 4) {
	            if (request.status === 200) {
	              resolve('exists');
	            } else if (request.status === 401) {
	              resolve('invalid');
	            } else if (request.status === 404) {
	              resolve('new');
	            } else {
	              reject('offline');
	            }
	          }
	        };
	
	        request.onerror = reject;
	        request.open('HEAD', _this9.uri, true);
	        request.setRequestHeader('Authorization', _this9.getAuthorizationValue());
	        request.send();
	      });
	    }
	  }]);
	
	  return LegacyStorage;
	}();
	
	exports.default = LegacyStorage;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MemoryStorage = function () {
	  function MemoryStorage() {
	    _classCallCheck(this, MemoryStorage);
	
	    this.onclose = function () {};
	
	    this.data = {};
	    this.models = [{ name: 'people' }, { name: 'relationships' }, { name: 'positions' }, { name: 'departments' }, { name: 'organisations' }, { name: 'logentries' }, { name: 'educations' }, { name: 'settings' }];
	  }
	
	  _createClass(MemoryStorage, [{
	    key: 'open',
	    value: function open() {
	      var _this = this;
	
	      return new Promise(function (resolve, reject) {
	        var modelCount = 0;
	        _this.models.forEach(function (model) {
	          _this.create(model).then(function () {
	            modelCount++;
	
	            if (modelCount === _this.models.length) {
	              resolve();
	            }
	          }, reject);
	        });
	      });
	    }
	  }, {
	    key: 'status',
	    value: function status() {
	      return new Promise(function (resolve) {
	        resolve('new');
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.onclose();
	    }
	  }, {
	    key: 'create',
	    value: function create(model) {
	      var _this2 = this;
	
	      return new Promise(function (resolve) {
	        _this2.data[model.name] = {};
	        resolve();
	      });
	    }
	  }, {
	    key: 'readModel',
	    value: function readModel(model) {
	      var _this3 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (_this3.data[model.name]) {
	          resolve(_this3.data[model.name]);
	        } else {
	          reject();
	        }
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(model, id) {
	      var _this4 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (_this4.data[model.name] && _this4.data[model.name][id]) {
	          resolve(_this4.data[model.name][id]);
	        } else {
	          reject();
	        }
	      });
	    }
	  }, {
	    key: 'put',
	    value: function put(model, data) {
	      var _this5 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (!_this5.data[model.name]) {
	          reject();
	        }
	
	        if (!data.id) {
	          data.id = window.PRIM.getUUID();
	        }
	
	        _this5.data[model.name][data.id] = data;
	        resolve();
	      });
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(model, id) {
	      var _this6 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (_this6.data[model.name] && _this6.data[model.name][id]) {
	          delete _this6.data[model.name][id];
	          resolve();
	        } else {
	          reject();
	        }
	      });
	    }
	  }, {
	    key: 'writeModel',
	    value: function writeModel(model, data) {
	      var _this7 = this;
	
	      return new Promise(function (resolve) {
	        _this7.data[model.name] = data;
	        resolve();
	      });
	    }
	  }, {
	    key: 'read',
	    value: function read() {
	      var _this8 = this;
	
	      return new Promise(function (resolve, reject) {
	        var data = {};
	        var modelCount = 0;
	
	        _this8.models.forEach(function (model) {
	          _this8.readModel(model).then(function (modelData) {
	            _this8.data[model.name] = modelData;
	
	            modelCount++;
	
	            if (modelCount === _this8.models.length) {
	              resolve(data);
	            }
	          }, reject);
	        });
	      });
	    }
	  }, {
	    key: 'write',
	    value: function write(data) {
	      var _this9 = this;
	
	      return new Promise(function (resolve, reject) {
	        var dataCount = 0;
	
	        _this9.models.forEach(function (model) {
	          var totalCount = Object.keys(data[model.name]).length;
	
	          if (totalCount > 0) {
	            for (var id in data[model.name]) {
	              var entry = data[model.name][id];
	              _this9.writeModel(model, entry).then(function () {
	                dataCount++;
	
	                if (dataCount === totalCount) {
	                  resolve();
	                }
	              }, reject);
	            }
	          } else {
	            resolve();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.data = null;
	      this.init();
	    }
	  }]);
	
	  return MemoryStorage;
	}();
	
	exports.default = MemoryStorage;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DataAccess = function () {
	  function DataAccess(securityManager, localStorage, externalStorage, message) {
	    var _this = this;
	
	    _classCallCheck(this, DataAccess);
	
	    this.timeout = null;
	    this.waitTimeout = 3000;
	    this.externalStorageOnly = true;
	    this.securityManager = securityManager;
	    this.localStorage = localStorage;
	    this.externalStorage = externalStorage;
	    this.message = message;
	
	    this.closed = function () {
	      _this.message('down');
	    };
	
	    this.localStorage.onclose = this.closed;
	    this.localStorage.onblocked = this.closed;
	    this.localStorage.onversionchange = this.closed;
	    this.externalStorage.onclose = this.closed;
	  }
	
	  _createClass(DataAccess, [{
	    key: 'init',
	    value: function init(username, password) {
	      var _this2 = this;
	
	      this.localStorage.open().then(function () {
	        _this2.externalStorage.open(username, password).then(function () {
	          _this2.message('up');
	        }, function () {
	          _this2.message('down');
	        });
	      }, function () {
	        _this2.message('down');
	      });
	    }
	  }, {
	    key: 'setDataKey',
	    value: function setDataKey(passphrase) {
	      var _this3 = this;
	
	      this.securityManager.setDataKey(passphrase).then(function () {
	        _this3.message('dataKeySet');
	      }, function (error) {
	        _this3.message('error', error.stack);
	      });
	    }
	  }, {
	    key: 'setCredentials',
	    value: function setCredentials(username, password) {
	      this.externalStorage.setCredentials(username, password);
	      this.message('credentialsSet');
	    }
	  }, {
	    key: 'isCurrentPassword',
	    value: function isCurrentPassword(password) {
	      return this.externalStorage.status(password);
	    }
	  }, {
	    key: 'externalChangePassword',
	    value: function externalChangePassword(password) {
	      return this.externalStorage.changePassword(password);
	    }
	  }, {
	    key: 'localStatus',
	    value: function localStatus() {
	      return this.localStorage.status();
	    }
	  }, {
	    key: 'externalStatus',
	    value: function externalStatus() {
	      return this.externalStorage.status();
	    }
	  }, {
	    key: 'read',
	    value: function read() {
	      var _this4 = this;
	
	      this.message('readPending');
	
	      this.externalStorage.read().then(function (data) {
	        _this4.securityManager.decryptData(data).then(function (modelData) {
	          if (modelData) {
	            _this4.localStorage.write(JSON.parse(modelData)).then(function () {
	              _this4.message('read');
	            }, function (error) {
	              _this4.message('readFailed', error);
	            });
	          } else {
	            _this4.message('read');
	          }
	        }, function (error) {
	          _this4.message('readFailed', error);
	        });
	      }, function (error) {
	        _this4.message('readFailed', error);
	      });
	    }
	  }, {
	    key: 'write',
	    value: function write() {
	      var _this5 = this;
	
	      this.message('writePending');
	
	      this.localStorage.read().then(function (modelData) {
	        _this5.securityManager.encryptData(JSON.stringify(modelData ? modelData : {})).then(function (data) {
	          _this5.externalStorage.write(data).then(function () {
	            _this5.message('write');
	          }, function (error) {
	            _this5.timeout = setTimeout(_this5.autoWrite, _this5.waitTimeout);
	            _this5.message('writeFailed', error ? error.stack : undefined);
	          });
	        }, function (error) {
	          _this5.message('writeFailed', error ? error.stack : undefined);
	        });
	      }, function (error) {
	        _this5.message('writeFailed', error ? error.stack : undefined);
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(type, uuid) {
	      if (this.externalStorageOnly) {
	        return this.externalStorage.get({ name: type, uncached: type === 'files' }, uuid);
	      }
	
	      return this.localStorage.get({ name: type, uncached: type === 'files' }, uuid);
	    }
	  }, {
	    key: 'put',
	    value: function put(type, data) {
	      clearTimeout(this.timeout);
	
	      if (this.externalStorageOnly) {
	        return this.externalStorage.put({ name: type, uncached: type === 'files' }, data);
	      }
	
	      return this.localStorage.put({ name: type, uncached: type === 'files' }, data);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(type, uuid) {
	      clearTimeout(this.timeout);
	
	      if (this.externalStorageOnly) {
	        return this.externalStorage.delete({ name: type, uncached: type === 'files' }, uuid);
	      }
	
	      return this.localStorage.delete({ name: type, uncached: type === 'files' }, uuid);
	    }
	  }, {
	    key: 'autoWrite',
	    value: function autoWrite() {
	      this.write();
	    }
	  }, {
	    key: 'resolveSingle',
	    value: function resolveSingle(type, data, recursive) {
	      return new Promise(function (resolve, reject) {
	        var model = window.PRIM.modelMapper.initToModel(type, data);
	
	        switch (type) {
	          default:
	            resolve(model);
	            break;
	          case 'positions':
	            if (recursive) {
	              var promises = 0;
	              if (model.values.person_id) {
	                promises++;
	                window.PRIM.dataAccess.resolve('people', model.values.person_id, true).then(function (person) {
	                  model.person = person;
	                  promises--;
	
	                  if (promises === 0) {
	                    resolve(model);
	                  }
	                }, function () {
	                  promises--;
	
	                  if (promises === 0) {
	                    reject();
	                  }
	                });
	              }
	              if (model.values.location_id) {
	                promises++;
	                window.PRIM.dataAccess.resolve('locations', model.values.location_id, true).then(function (location) {
	                  model.location = location;
	                  promises--;
	
	                  if (promises === 0) {
	                    resolve(model);
	                  }
	                }, function () {
	                  promises--;
	
	                  if (promises === 0) {
	                    reject();
	                  }
	                });
	              }
	            } else {
	              resolve(model);
	            }
	            break;
	          case 'educations':
	            if (model.values.location_id && recursive) {
	              window.PRIM.dataAccess.resolve('locations', model.values.location_id, true).then(function (location) {
	                model.location = location;
	                resolve(model);
	              }, reject);
	            } else {
	              resolve(model);
	            }
	            break;
	          case 'organisations':
	            if (model.values.location_id && recursive) {
	              window.PRIM.dataAccess.resolve('locations', model.values.location_id, false).then(function (location) {
	                model.location = location;
	                resolve(model);
	              }, reject);
	            } else {
	              resolve(model);
	            }
	            break;
	          case 'locations':
	            if (model.values.organisation_id && recursive) {
	              window.PRIM.dataAccess.resolve('organisations', model.values.organisation_id, true).then(function (organisation) {
	                model.organisation = organisation;
	                resolve(model);
	              }, reject);
	            } else {
	              resolve(model);
	            }
	            break;
	          case 'relationships':
	            if (recursive) {
	              var _promises = 0;
	              if (model.values.person_id) {
	                _promises++;
	                window.PRIM.dataAccess.resolve('people', model.values.person_id, true).then(function (person) {
	                  model.person = person;
	                  _promises--;
	
	                  if (_promises === 0) {
	                    resolve(model);
	                  }
	                }, function () {
	                  _promises--;
	
	                  if (_promises === 0) {
	                    reject();
	                  }
	                });
	              }
	
	              if (model.values.target_id) {
	                _promises++;
	                window.PRIM.dataAccess.resolve('people', model.values.target_id, true).then(function (target) {
	                  model.target = target;
	                  _promises--;
	
	                  if (_promises === 0) {
	                    resolve(model);
	                  }
	                }, function () {
	                  _promises--;
	
	                  if (_promises === 0) {
	                    reject();
	                  }
	                });
	              }
	            } else {
	              resolve(model);
	            }
	            break;
	        }
	      });
	    }
	  }, {
	    key: 'resolve',
	    value: function resolve(type, id, recursive, indexkey) {
	      var _this6 = this;
	
	      return new Promise(function (resolve, reject) {
	        if (id && !indexkey) {
	          window.PRIM.dataAccess.get(type, id).then(function (data) {
	            _this6.resolveSingle(type, data, recursive).then(resolve, reject);
	          }, reject);
	        } else {
	          window.PRIM.dataAccess.get(type).then(function (data) {
	            var results = void 0;
	
	            if (indexkey) {
	              results = data.filter(function (item) {
	                return item[indexkey] === id;
	              });
	            } else {
	              results = data;
	            }
	
	            var promises = 0;
	            var models = [];
	
	            results.forEach(function (item) {
	              promises++;
	              _this6.resolveSingle(type, item, recursive).then(function (model) {
	                models.push(model);
	
	                promises--;
	                if (promises === 0) {
	                  resolve(models);
	                }
	              }, function () {
	                promises--;
	                if (promises === 0) {
	                  resolve(models);
	                }
	              });
	            });
	          });
	        }
	      });
	    }
	  }]);
	
	  return DataAccess;
	}();
	
	exports.default = DataAccess;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _PersonModel = __webpack_require__(6);
	
	var _PersonModel2 = _interopRequireDefault(_PersonModel);
	
	var _PositionModel = __webpack_require__(7);
	
	var _PositionModel2 = _interopRequireDefault(_PositionModel);
	
	var _EducationModel = __webpack_require__(8);
	
	var _EducationModel2 = _interopRequireDefault(_EducationModel);
	
	var _OrganisationModel = __webpack_require__(9);
	
	var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);
	
	var _LogentryModel = __webpack_require__(10);
	
	var _LogentryModel2 = _interopRequireDefault(_LogentryModel);
	
	var _LocationModel = __webpack_require__(11);
	
	var _LocationModel2 = _interopRequireDefault(_LocationModel);
	
	var _RelationshipModel = __webpack_require__(12);
	
	var _RelationshipModel2 = _interopRequireDefault(_RelationshipModel);
	
	var _FileModel = __webpack_require__(13);
	
	var _FileModel2 = _interopRequireDefault(_FileModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModelMapper = function () {
	  function ModelMapper() {
	    _classCallCheck(this, ModelMapper);
	  }
	
	  _createClass(ModelMapper, [{
	    key: 'mapToModel',
	    value: function mapToModel(data, model) {
	      for (var field in data) {
	        model[field] = data[field];
	      }
	    }
	  }, {
	    key: 'mapToObject',
	    value: function mapToObject(model, data) {
	      for (var field in model) {
	        data[field] = model[field];
	      }
	    }
	  }, {
	    key: 'initToModel',
	    value: function initToModel(type, data) {
	      switch (type) {
	        case 'people':
	          return new _PersonModel2.default(data);
	        case 'positions':
	          return new _PositionModel2.default(data);
	        case 'educations':
	          return new _EducationModel2.default(data);
	        case 'organisations':
	          return new _OrganisationModel2.default(data);
	        case 'logentries':
	          return new _LogentryModel2.default(data);
	        case 'locations':
	          return new _LocationModel2.default(data);
	        case 'relationships':
	          return new _RelationshipModel2.default(data);
	        case 'files':
	          return new _FileModel2.default(data);
	      }
	    }
	  }]);
	
	  return ModelMapper;
	}();
	
	exports.default = ModelMapper;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PersonModel = function () {
	  function PersonModel(data) {
	    _classCallCheck(this, PersonModel);
	
	    this.relationships = [];
	    this.logentries = [];
	
	    this.values = {
	      id: null,
	      image: null,
	      lastname: null,
	      suffix: null,
	      maidenname: null,
	      maidensuffix: null,
	      initials: null,
	      forenames: null,
	      nickname: null,
	      gender: null,
	      address: null,
	      zipcode: null,
	      city: null,
	      country: null,
	      phone: null,
	      mobile: null,
	      email: null,
	      dateofbirth: null,
	      dateofdeath: null,
	      sendbirthdaycard: null,
	      sendbirthdayemail: null,
	      countryoforigin: null,
	      linkedinid: null,
	      twitterid: null,
	      facebookid: null,
	      skypeid: null,
	      religion: null,
	      maritalstatus: null,
	      sendchristmasemail: null,
	      sendchristmascard: null,
	      region: null,
	      nationality: null
	    };
	
	    window.PRIM.modelMapper.mapToModel(data, this.values);
	  }
	
	  _createClass(PersonModel, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      var title = [];
	
	      if (this.values.nickname) {
	        title.push(this.values.nickname);
	      }
	
	      if (this.values.suffix) {
	        title.push(this.values.suffix);
	      }
	
	      if (this.values.lastname) {
	        title.push(this.values.lastname);
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getSubtitle',
	    value: function getSubtitle() {
	      return [this.values.city].join(' ');
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage() {
	      return this.values.image;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      if (this.getCompareString()) {
	        return this.getCompareString().substring(0, 1).toUpperCase();
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getCompareString',
	    value: function getCompareString() {
	      var title = [];
	
	      if (this.values.lastname) {
	        title.push(this.values.lastname);
	      }
	
	      if (this.values.suffix) {
	        title.push(this.values.suffix);
	      }
	
	      if (this.values.nickname) {
	        title.push(this.values.nickname);
	      }
	
	      if (this.values.city) {
	        title.push(this.values.city);
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getJSON',
	    value: function getJSON() {
	      var result = {};
	
	      window.PRIM.modelMapper.mapToObject(this.values, result);
	
	      return result;
	    }
	  }]);
	
	  return PersonModel;
	}();
	
	exports.default = PersonModel;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PositionModel = function () {
	  function PositionModel(data) {
	    _classCallCheck(this, PositionModel);
	
	    this.logentries = [];
	    this.person = null;
	    this.location = null;
	
	    this.values = {
	      id: null,
	      person_id: null,
	      location_id: null,
	      department: null,
	      title: null,
	      phone: null,
	      mobile: null,
	      fax: null,
	      email: null,
	      sendchristmasemail: null,
	      sendchristmascard: null,
	      start: null,
	      end: null
	    };
	
	    window.PRIM.modelMapper.mapToModel(data, this.values);
	  }
	
	  _createClass(PositionModel, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      return [this.values.title].join(' ');
	    }
	  }, {
	    key: 'getSubtitle',
	    value: function getSubtitle() {
	      var title = [];
	
	      if (this.values.department) {
	        title.push(this.values.department);
	      }
	
	      if (this.location) {
	        if (this.location.values.business) {
	          title.push(this.location.values.business);
	        }
	
	        if (this.location.values.visitcity) {
	          title.push(this.location.values.visitcity);
	        }
	
	        if (this.location.organisation && this.location.organisation.values.name) {
	          title.push(this.location.organisation.values.name);
	        }
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage() {
	      var image = null;
	
	      if (this.person && this.person.getImage) {
	        image = this.person.getImage();
	      }
	
	      if (!image && this.location && this.location.getImage) {
	        image = this.location.getImage();
	      }
	
	      return image;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      if (this.getCompareString()) {
	        return this.getCompareString().substring(0, 1).toUpperCase();
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getCompareString',
	    value: function getCompareString() {
	      var title = [];
	
	      if (this.values.title) {
	        title.push(this.values.title);
	      }
	
	      if (this.values.department) {
	        title.push(this.values.department);
	      }
	
	      if (this.location) {
	        if (this.location.values.business) {
	          title.push(this.location.values.business);
	        }
	
	        if (this.location.values.visitcity) {
	          title.push(this.location.values.visitcity);
	        }
	
	        if (this.location.organisation && this.location.organisation.values.name) {
	          title.push(this.location.organisation.values.name);
	        }
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getJSON',
	    value: function getJSON() {
	      var result = {};
	
	      window.PRIM.modelMapper.mapToObject(this.values, result);
	
	      return result;
	    }
	  }]);
	
	  return PositionModel;
	}();
	
	exports.default = PositionModel;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EducationModel = function () {
	  function EducationModel(data) {
	    _classCallCheck(this, EducationModel);
	
	    this.logentries = [];
	    this.person = null;
	    this.location = null;
	    this.values = {
	      id: null,
	      person_id: null,
	      location_id: null,
	      title: null,
	      start: null,
	      end: null
	    };
	
	    window.PRIM.modelMapper.mapToModel(data, this.values);
	  }
	
	  _createClass(EducationModel, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      return [this.values.title].join(' ');
	    }
	  }, {
	    key: 'getSubtitle',
	    value: function getSubtitle() {
	      var title = [];
	
	      if (this.location) {
	        if (this.location.values.business) {
	          title.push(this.location.values.business);
	        }
	
	        if (this.location.values.visitcity) {
	          title.push(this.location.values.visitcity);
	        }
	
	        if (this.location.organisation && this.location.organisation.values.name) {
	          title.push(this.location.organisation.values.name);
	        }
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage() {
	      var image = null;
	
	      if (this.person && this.person.getImage) {
	        image = this.person.getImage();
	      }
	
	      if (!image && this.location && this.location.getImage) {
	        image = this.location.getImage();
	      }
	
	      return image;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      if (this.getCompareString()) {
	        return this.getCompareString().substring(0, 1).toUpperCase();
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getCompareString',
	    value: function getCompareString() {
	      var title = [];
	
	      if (this.values.title) {
	        title.push(this.values.title);
	      }
	
	      if (this.location) {
	        if (this.location.values.business) {
	          title.push(this.location.values.business);
	        }
	
	        if (this.location.values.visitcity) {
	          title.push(this.location.values.visitcity);
	        }
	
	        if (this.location.organisation && this.location.organisation.values.name) {
	          title.push(this.location.organisation.values.name);
	        }
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getJSON',
	    value: function getJSON() {
	      var result = {};
	
	      window.PRIM.modelMapper.mapToObject(this.values, result);
	
	      return result;
	    }
	  }]);
	
	  return EducationModel;
	}();
	
	exports.default = EducationModel;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrganisationModel = function () {
	  function OrganisationModel(data) {
	    _classCallCheck(this, OrganisationModel);
	
	    this.locations = [];
	    this.logentries = [];
	    this.location = null;
	
	    this.values = {
	      id: null,
	      image: null,
	      name: null,
	      location_id: null,
	      vat: null,
	      coc: null
	    };
	
	    window.PRIM.modelMapper.mapToModel(data, this.values);
	  }
	
	  _createClass(OrganisationModel, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      return [this.values.name].join(' ');
	    }
	  }, {
	    key: 'getSubtitle',
	    value: function getSubtitle() {
	      if (this.location) {
	        return [this.location.values.visitcity].join(' ');
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage() {
	      return this.values.image;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      if (this.getCompareString()) {
	        return this.getCompareString().substring(0, 1).toUpperCase();
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getCompareString',
	    value: function getCompareString() {
	      var title = [];
	
	      if (this.values.name) {
	        title.push(this.values.name);
	      }
	
	      if (this.location) {
	        title.push(this.location.values.visitcity);
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getJSON',
	    value: function getJSON() {
	      var result = {};
	
	      window.PRIM.modelMapper.mapToObject(this.values, result);
	
	      return result;
	    }
	  }]);
	
	  return OrganisationModel;
	}();
	
	exports.default = OrganisationModel;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LogentryModel = function () {
	  function LogentryModel(data) {
	    _classCallCheck(this, LogentryModel);
	
	    this.target = null;
	
	    this.values = {
	      id: null,
	      object_type_id: null,
	      target_id: null,
	      description: null,
	      timestamp: null
	    };
	
	    window.PRIM.modelMapper.mapToModel(data, this.values);
	  }
	
	  _createClass(LogentryModel, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      return [this.values.timestamp ? window.PRIM.getUtcTimestamp(new Date(this.values.timestamp)).toISOString().substring(0, 19).replace('T', ' ') : null].join(' ');
	    }
	  }, {
	    key: 'getSubtitle',
	    value: function getSubtitle() {
	      return [this.values.description].join(' ');
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage() {
	      if (this.target && this.target.getImage) {
	        return this.target.getImage();
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      if (this.getCompareString()) {
	        return this.getCompareString().substring(0, 4).toUpperCase();
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getCompareString',
	    value: function getCompareString() {
	      var title = [];
	
	      if (this.values.timestamp) {
	        title.push(this.values.timestamp ? window.PRIM.getUtcTimestamp(new Date(this.values.timestamp)).toISOString().substring(0, 19).replace('T', ' ') : null);
	      }
	
	      if (this.values.description) {
	        title.push(this.values.description);
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getJSON',
	    value: function getJSON() {
	      var result = {};
	
	      window.PRIM.modelMapper.mapToObject(this.values, result);
	
	      return result;
	    }
	  }]);
	
	  return LogentryModel;
	}();
	
	exports.default = LogentryModel;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocationModel = function () {
	  function LocationModel(data) {
	    _classCallCheck(this, LocationModel);
	
	    this.positions = [];
	    this.logentries = [];
	    this.organisation = null;
	
	    this.values = {
	      id: null,
	      organisation_id: null,
	      business: null,
	      postaddress: null,
	      postzipcode: null,
	      postcity: null,
	      postregion: null,
	      postcountry: null,
	      phone: null,
	      email: null,
	      fax: null,
	      website: null,
	      visitaddress: null,
	      visitzipcode: null,
	      visitcity: null,
	      visitregion: null,
	      visitcountry: null
	    };
	
	    window.PRIM.modelMapper.mapToModel(data, this.values);
	  }
	
	  _createClass(LocationModel, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      return [this.values.business].join(' ');
	    }
	  }, {
	    key: 'getSubtitle',
	    value: function getSubtitle() {
	      var subtitle = [];
	
	      if (this.values.visitcity) {
	        subtitle.push(this.values.visitcity);
	      }
	
	      if (this.organisation) {
	        subtitle.push(this.organisation.values.name);
	      }
	
	      return subtitle.join(' ');
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage() {
	      if (this.organisation) {
	        return this.organisation.getImage();
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      if (this.getCompareString()) {
	        return this.getCompareString().substring(0, 1).toUpperCase();
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getCompareString',
	    value: function getCompareString() {
	      var title = [];
	
	      if (this.values.business) {
	        title.push(this.values.business);
	      }
	
	      if (this.values.visitcity) {
	        title.push(this.values.visitcity);
	      }
	
	      if (this.organisation) {
	        title.push(this.organisation.values.name);
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getJSON',
	    value: function getJSON() {
	      var result = {};
	
	      window.PRIM.modelMapper.mapToObject(this.values, result);
	
	      return result;
	    }
	  }]);
	
	  return LocationModel;
	}();
	
	exports.default = LocationModel;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RelationshipModel = function () {
	  function RelationshipModel(data) {
	    _classCallCheck(this, RelationshipModel);
	
	    this.person = null;
	    this.target = null;
	
	    this.values = {
	      id: null,
	      person_id: null,
	      target_id: null,
	      description: null
	    };
	
	    window.PRIM.modelMapper.mapToModel(data, this.values);
	  }
	
	  _createClass(RelationshipModel, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      var title = [];
	
	      if (this.target && this.target.getTitle) {
	        return this.target.getTitle();
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getSubtitle',
	    value: function getSubtitle() {
	      return [this.values.description].join(' ');
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage() {
	      if (this.target && this.target.getImage) {
	        return this.target.getImage();
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex() {
	      if (this.target && this.target.getIndex) {
	        return this.target.getIndex();
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getCompareString',
	    value: function getCompareString() {
	      var title = [];
	
	      if (this.target && this.target.getCompareString) {
	        title.push(this.target.getCompareString());
	      }
	
	      if (this.values.description) {
	        title.push(this.values.description);
	      }
	
	      return title.join(' ');
	    }
	  }, {
	    key: 'getJSON',
	    value: function getJSON() {
	      var result = {};
	
	      window.PRIM.modelMapper.mapToObject(this.values, result);
	
	      return result;
	    }
	  }]);
	
	  return RelationshipModel;
	}();
	
	exports.default = RelationshipModel;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FileModel = function () {
	  function FileModel(data) {
	    _classCallCheck(this, FileModel);
	
	    this.values = {
	      id: null,
	      contents: null
	    };
	
	    window.PRIM.modelMapper.mapToModel(data, this.values);
	  }
	
	  _createClass(FileModel, [{
	    key: "getTitle",
	    value: function getTitle() {
	      return this.values.id;
	    }
	  }, {
	    key: "getSubtitle",
	    value: function getSubtitle() {
	      return this.values.contents.length;
	    }
	  }, {
	    key: "getImage",
	    value: function getImage() {
	      return null;
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex() {
	      if (this.getCompareString()) {
	        return this.getCompareString().substring(0, 1).toUpperCase();
	      }
	
	      return null;
	    }
	  }, {
	    key: "getCompareString",
	    value: function getCompareString() {
	      return this.values.id;
	    }
	  }, {
	    key: "getJSON",
	    value: function getJSON() {
	      var result = {};
	
	      window.PRIM.modelMapper.mapToObject(this.values, result);
	
	      return result;
	    }
	  }]);
	
	  return FileModel;
	}();
	
	exports.default = FileModel;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _About = __webpack_require__(15);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _New = __webpack_require__(18);
	
	var _New2 = _interopRequireDefault(_New);
	
	var _Offline = __webpack_require__(19);
	
	var _Offline2 = _interopRequireDefault(_Offline);
	
	var _Search = __webpack_require__(20);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Start = __webpack_require__(24);
	
	var _Start2 = _interopRequireDefault(_Start);
	
	var _ReportPeople = __webpack_require__(25);
	
	var _ReportPeople2 = _interopRequireDefault(_ReportPeople);
	
	var _Import = __webpack_require__(28);
	
	var _Import2 = _interopRequireDefault(_Import);
	
	var _Export = __webpack_require__(30);
	
	var _Export2 = _interopRequireDefault(_Export);
	
	var _EditPerson = __webpack_require__(31);
	
	var _EditPerson2 = _interopRequireDefault(_EditPerson);
	
	var _EditPosition = __webpack_require__(51);
	
	var _EditPosition2 = _interopRequireDefault(_EditPosition);
	
	var _EditEducation = __webpack_require__(57);
	
	var _EditEducation2 = _interopRequireDefault(_EditEducation);
	
	var _EditOrganisation = __webpack_require__(59);
	
	var _EditOrganisation2 = _interopRequireDefault(_EditOrganisation);
	
	var _EditLocation = __webpack_require__(61);
	
	var _EditLocation2 = _interopRequireDefault(_EditLocation);
	
	var _EditLogentry = __webpack_require__(65);
	
	var _EditLogentry2 = _interopRequireDefault(_EditLogentry);
	
	var _EditRelationship = __webpack_require__(69);
	
	var _EditRelationship2 = _interopRequireDefault(_EditRelationship);
	
	var _EditFile = __webpack_require__(71);
	
	var _EditFile2 = _interopRequireDefault(_EditFile);
	
	var _EnterCredentials = __webpack_require__(73);
	
	var _EnterCredentials2 = _interopRequireDefault(_EnterCredentials);
	
	var _ChangeCredentials = __webpack_require__(75);
	
	var _ChangeCredentials2 = _interopRequireDefault(_ChangeCredentials);
	
	var _Welcome = __webpack_require__(76);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _Sync = __webpack_require__(77);
	
	var _Sync2 = _interopRequireDefault(_Sync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavigationManager = function () {
	  function NavigationManager(element) {
	    _classCallCheck(this, NavigationManager);
	
	    this.element = element;
	    addEventListener('popstate', this.handleNavigation.bind(this));
	  }
	
	  _createClass(NavigationManager, [{
	    key: 'handleNavigation',
	    value: function handleNavigation() {
	      window.PRIM.cancelDelayedNavigation();
	
	      var path = location.hash.split('/');
	
	      if (path.length < 2) {
	        return;
	      }
	
	      this.element.innerHTML = '';
	
	      // split on '/'
	      switch (path[1]) {
	        case 'sync':
	          new _Sync2.default(this.element);
	          break;
	        case 'people':
	          new _EditPerson2.default(this.element, { id: path.length > 2 ? path[2] : undefined });
	          break;
	        case 'files':
	          new _EditFile2.default(this.element, { id: path.length > 2 ? path[2] : undefined });
	          break;
	        case 'positions':
	          new _EditPosition2.default(this.element, {
	            id: path.length === 3 ? path[2] : undefined,
	            person_id: path.length > 3 && path[2] === 'person' ? path[3] : undefined,
	            location_id: path.length > 3 && path[2] === 'location' ? path[3] : undefined
	          });
	          break;
	        case 'educations':
	          new _EditEducation2.default(this.element, {
	            id: path.length === 3 ? path[2] : undefined,
	            location_id: path.length > 3 ? path[3] : undefined
	          });
	          break;
	        case 'organisations':
	          new _EditOrganisation2.default(this.element, { id: path.length > 2 ? path[2] : undefined });
	          break;
	        case 'locations':
	          new _EditLocation2.default(this.element, {
	            id: path.length === 3 ? path[2] : undefined,
	            organisation_id: path.length > 3 ? path[3] : undefined
	          });
	          break;
	        case 'logentries':
	          new _EditLogentry2.default(this.element, {
	            id: path.length === 3 ? path[2] : undefined,
	            object_type: path.length > 3 ? path[2] : undefined,
	            target_id: path.length > 3 ? path[3] : undefined
	          });
	          break;
	        case 'relationships':
	          new _EditRelationship2.default(this.element, {
	            id: path.length === 3 ? path[2] : undefined,
	            person_id: path.length > 3 ? path[3] : undefined
	          });
	          break;
	        case 'about':
	          new _About2.default(this.element);
	          break;
	        case 'reportpeople':
	          new _ReportPeople2.default(this.element);
	          break;
	        case 'import':
	          new _Import2.default(this.element);
	          break;
	        case 'export':
	          new _Export2.default(this.element);
	          break;
	        case 'entercredentials':
	          new _EnterCredentials2.default(this.element);
	          break;
	        case 'changecredentials':
	          new _ChangeCredentials2.default(this.element);
	          break;
	        case 'offline':
	          new _Offline2.default(this.element);
	          break;
	        case 'start':
	          new _Start2.default(this.element);
	          break;
	        case 'new':
	          new _New2.default(this.element);
	          break;
	        case 'search':
	          new _Search2.default(this.element);
	          break;
	        default:
	          new _EnterCredentials2.default(this.element);
	          break;
	      }
	    }
	  }]);
	
	  return NavigationManager;
	}();
	
	exports.default = NavigationManager;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _StaticControl = __webpack_require__(17);
	
	var _StaticControl2 = _interopRequireDefault(_StaticControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var About = function About(element) {
	  _classCallCheck(this, About);
	
	  var displayBoolean = function displayBoolean(value) {
	    if (typeof value === 'undefined') {
	      return 'Nee';
	    }
	
	    return value ? 'Ja' : 'Nee';
	  };
	  var portrait = typeof window.orientation !== 'undefined' && window.orientation !== -90 && window.orientation !== 90;
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Over PRIM',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        location.reload(true);
	      },
	      icon: '\uE0DA',
	      label: 'Applicatie herstarten'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var fieldsetApplication = document.createElement('fieldset');
	  var legendApplication = document.createElement('legend');
	  legendApplication.innerHTML = 'Applicatie';
	  fieldsetApplication.appendChild(legendApplication);
	
	  new _StaticControl2.default(fieldsetApplication, { label: 'PRIM versie nummer', value: window.PRIM.version });
	  new _StaticControl2.default(fieldsetApplication, { label: 'PRIM versie tijdstip', value: window.PRIM.buildTimestamp });
	
	  var fieldsetLicense = document.createElement('fieldset');
	  var legendLicense = document.createElement('legend');
	  legendLicense.innerHTML = 'Abonnement';
	  fieldsetLicense.appendChild(legendLicense);
	
	  if (window.PRIM.License) {
	    if (window.PRIM.License.isDemo) {
	      new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Demonstratieversie, er zullen geen gegevens worden bewaard' });
	    } else if (window.PRIM.License.validThru) {
	      if (window.PRIM.License.valid) {
	        new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Loopt t/m ' + new Date(window.PRIM.License.validThru) });
	      } else {
	        new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Is verlopen op ' + new Date(window.PRIM.License.validThru) + ', beperkingen actief' });
	      }
	    } else if (window.PRIM.License.valid) {
	      new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Loopt onbeperkt' });
	    } else {
	      new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Onbekend, beperkingen actief' });
	    }
	  } else {
	    new _StaticControl2.default(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Onbekend, beperkingen actief' });
	  }
	
	  var fieldsetSpecifications = document.createElement('fieldset');
	  var legendSpecifications = document.createElement('legend');
	  legendSpecifications.innerHTML = 'Specificaties';
	  fieldsetSpecifications.appendChild(legendSpecifications);
	
	  new _StaticControl2.default(fieldsetSpecifications, { label: 'Browser agent', value: navigator.userAgent });
	  new _StaticControl2.default(fieldsetSpecifications, { label: 'Browser platform', value: navigator.platform });
	  new _StaticControl2.default(fieldsetSpecifications, { label: 'Browser taal', value: navigator.language });
	  new _StaticControl2.default(fieldsetSpecifications, { label: 'Browser is online', value: displayBoolean(navigator.onLine) });
	  new _StaticControl2.default(fieldsetSpecifications, { label: 'Scherm ruimte', value: screen.availWidth + '×' + screen.availHeight + '×' + screen.pixelDepth });
	  new _StaticControl2.default(fieldsetSpecifications, { label: 'Scherm orientatie', value: typeof window.orientation !== 'undefined' ? portrait ? 'Portrait' : 'Landscape' : 'Onbekend' });
	
	  div.appendChild(fieldsetApplication);
	  div.appendChild(fieldsetLicense);
	  div.appendChild(fieldsetSpecifications);
	
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = About;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavigationBarControl = function NavigationBarControl(element, args) {
	  _classCallCheck(this, NavigationBarControl);
	
	  var header = document.createElement('header');
	  var h1 = document.createElement('h1');
	  var span = document.createElement('span');
	  span.innerHTML = args.title;
	
	  var addButton = function addButton(button) {
	    var a = document.createElement('a');
	    var spanIcon = document.createElement('span');
	    spanIcon.innerHTML = button.icon;
	    a.className = button.classes ? 'icon ' + button.classes : 'icon';
	    a.onclick = button.onclick;
	    a.appendChild(spanIcon);
	    h1.appendChild(a);
	  };
	
	  if (args.primaryButton) {
	    addButton(args.primaryButton);
	  }
	
	  if (args.leftHandButtons) {
	    args.leftHandButtons.forEach(addButton);
	  }
	
	  if (args.secondaryButton) {
	    addButton(args.secondaryButton);
	  }
	
	  h1.appendChild(span);
	
	  if (args.rightHandButtons) {
	    args.rightHandButtons.forEach(addButton);
	  }
	
	  header.appendChild(h1);
	
	  if (args.contextMenu) {
	    var contextMenuElementButton = document.createElement('a');
	    var contextMenuElementIcon = document.createElement('span');
	    contextMenuElementIcon.innerHTML = '\uE116';
	    var contextMenuElement = document.createElement('nav');
	    contextMenuElement.className = 'contextMenu invisible';
	
	    var closeContextMenu = function closeContextMenu() {
	      contextMenuElement.classList.add('invisible');
	      removeEventListener('click', closeContextMenu, false);
	    };
	
	    var openContextMenu = function openContextMenu(e) {
	      e.stopPropagation();
	      contextMenuElement.classList.remove('invisible');
	      addEventListener('click', closeContextMenu, false);
	    };
	
	    contextMenuElementButton.className = 'icon';
	    contextMenuElementButton.onclick = openContextMenu;
	    contextMenuElementButton.appendChild(contextMenuElementIcon);
	
	    args.contextMenu.forEach(function (item) {
	      var a = document.createElement('a');
	      var spanIcon = document.createElement('span');
	      spanIcon.innerHTML = item.icon;
	      a.className = 'icon';
	      a.onclick = item.onclick;
	      a.innerHTML = item.label ? item.label : '';
	      a.insertBefore(spanIcon, a.childNodes[0]);
	      contextMenuElement.appendChild(a);
	    });
	
	    h1.appendChild(contextMenuElementButton);
	    header.appendChild(contextMenuElement);
	  }
	
	  var fragment = document.createDocumentFragment();
	  fragment.appendChild(header);
	
	  element.appendChild(fragment);
	};
	
	exports.default = NavigationBarControl;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StaticControl = function () {
	  function StaticControl(element, args) {
	    _classCallCheck(this, StaticControl);
	
	    var div = document.createElement('div');
	    this.property = document.createElement('div');
	    this.property.id = window.PRIM.getUUID();
	    this.property.innerHTML = args.value ? args.value : '';
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.property.id;
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.property);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(StaticControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.property.innerHTML;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.property.innerHTML = value ? value : '';
	    }
	  }]);
	
	  return StaticControl;
	}();
	
	exports.default = StaticControl;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var New = function New(element) {
	  _classCallCheck(this, New);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Nieuw',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var a1 = document.createElement('a');
	  a1.className = 'icon button';
	  a1.innerHTML = 'Persoon';
	  a1.onclick = function () {
	    window.PRIM.navigate('/people/');
	  };
	  var span1 = document.createElement('span');
	  span1.innerHTML = '\uE12C';
	  a1.insertBefore(span1, a1.childNodes[0]);
	
	  var a2 = document.createElement('a');
	  a2.className = 'icon button';
	  a2.innerHTML = 'Organisatie';
	  a2.onclick = function () {
	    window.PRIM.navigate('/organisations/');
	  };
	  var span2 = document.createElement('span');
	  span2.innerHTML = '\uE078';
	  a2.insertBefore(span2, a2.childNodes[0]);
	
	  /*let a3 = document.createElement('a')
	  a3.className = 'icon button'
	  a3.innerHTML = 'Bestand'
	  a3.onclick = () => {
	    window.PRIM.navigate('/files/')
	  }
	  let span3 = document.createElement('span')
	  span3.innerHTML = '\ue063'
	  a3.insertBefore(span3, a3.childNodes[0])*/
	
	  div.appendChild(a1);
	  div.appendChild(a2);
	  //div.appendChild(a3)
	
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = New;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Offline = function Offline(element) {
	  _classCallCheck(this, Offline);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Externe opslag niet bereikbaar'
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var p = document.createElement('p');
	  p.innerHTML = 'Helaas kan PRIM de externe opslag niet bereiken en uw gegevens niet ophalen. Zonder externe opslag kunt u niet gebruik maken van deze applicatie. Controleer uw verbinding en probeer opnieuw.';
	
	  var buttonReload = document.createElement('button');
	  buttonReload.innerHTML = 'Herstarten en opnieuw proberen';
	  buttonReload.onclick = function () {
	    location.replace('/');
	  };
	
	  div.appendChild(p);
	  div.appendChild(buttonReload);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = Offline;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _IndexControl = __webpack_require__(21);
	
	var _IndexControl2 = _interopRequireDefault(_IndexControl);
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _PersonModel = __webpack_require__(6);
	
	var _PersonModel2 = _interopRequireDefault(_PersonModel);
	
	var _OrganisationModel = __webpack_require__(9);
	
	var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);
	
	var _LocationModel = __webpack_require__(11);
	
	var _LocationModel2 = _interopRequireDefault(_LocationModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Search = function Search(element) {
	  var _this = this;
	
	  _classCallCheck(this, Search);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Zoeken',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }]
	  });
	
	  var buffer = [];
	
	  var getPeople = function getPeople() {
	    return new Promise(function (resolve, reject) {
	      window.PRIM.dataAccess.get('people').then(function (people) {
	        people.forEach(function (person) {
	          buffer.push(new _PersonModel2.default(person));
	        });
	
	        resolve();
	      }, reject);
	    });
	  };
	
	  var getOrganisations = function getOrganisations() {
	    return new Promise(function (resolve, reject) {
	      window.PRIM.dataAccess.get('organisations').then(function (organisations) {
	        var promises = 0;
	
	        organisations.forEach(function (organisation) {
	          var model = new _OrganisationModel2.default(organisation);
	
	          if (model.values.location_id) {
	            promises++;
	            window.PRIM.dataAccess.get('locations', model.values.location_id).then(function (location) {
	              model.location = new _LocationModel2.default(location);
	              buffer.push(model);
	
	              promises--;
	
	              if (promises === 0) {
	                resolve();
	              }
	            }, function () {
	              buffer.push(model);
	
	              promises--;
	
	              if (promises === 0) {
	                resolve();
	              }
	            });
	          } else {
	            buffer.push(model);
	          }
	        });
	
	        if (promises === 0) {
	          resolve();
	        }
	      }, reject);
	    });
	  };
	
	  /*let getLocations = () => {
	    return new Promise((resolve, reject) => { {
	      PRIM.dataAccess.get('locations').then( (locations) {
	        let promises = 0
	         locations.forEach( (location) {
	          let model = new LocationModel(location)
	           if (model.values.organisation_id) {
	            promises++
	            PRIM.dataAccess.get('organisations', model.values.organisation_id).then( (organisation) {
	              model.organisation = new OrganisationModel(organisation)
	              buffer.push(model)
	               promises--
	               if (promises === 0) {
	                resolve()
	              }
	            }, () => {
	              buffer.push(model)
	               promises--
	               if (promises === 0) {
	                resolve()
	              }
	            })
	          } else {
	            buffer.push(model)
	          }
	        })
	         if (promises === 0) {
	          resolve()
	        }
	      }, reject)
	    })
	  }*/
	
	  getPeople().then(function () {
	    getOrganisations().then(function () {
	      _this.results.setItems(buffer);
	      /*getLocations().then(() {
	          results.setItems(buffer)
	      });*/
	    });
	  });
	
	  var onclick = function onclick(item) {
	    if (item instanceof _PersonModel2.default) {
	      window.PRIM.navigate('/people/' + item.values.id);
	      return;
	    }
	    if (item instanceof _OrganisationModel2.default) {
	      window.PRIM.navigate('/organisations/' + item.values.id);
	      return;
	    }
	    if (item instanceof _LocationModel2.default) {
	      window.PRIM.navigate('/locations/' + item.values.id);
	      return;
	    }
	  };
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  this.results = new _IndexControl2.default(div, { items: [], onclick: onclick });
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = Search;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndexResult = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ImageFrame = __webpack_require__(22);
	
	var _ImageFrame2 = _interopRequireDefault(_ImageFrame);
	
	var _ImagePlaceholderFrame = __webpack_require__(23);
	
	var _ImagePlaceholderFrame2 = _interopRequireDefault(_ImagePlaceholderFrame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IndexResult = exports.IndexResult = function () {
	  function IndexResult(element, args) {
	    _classCallCheck(this, IndexResult);
	
	    var div = document.createElement('div');
	    div.className = 'contact';
	    div.onclick = args.onclick;
	    var image = null;
	
	    if (args.showImage !== false) {
	      if (args.item && args.item.getImage && args.item.getImage()) {
	        image = new _ImageFrame2.default(div, {
	          image: args.item.getImage()
	        });
	      } else {
	        image = new _ImagePlaceholderFrame2.default(div, {
	          title: args.item ? args.item.getTitle() : null
	        });
	      }
	    }
	
	    var dl = document.createElement('dl');
	    this.dt = document.createElement('dt');
	    this.dt.innerHTML = args.title;
	    this.dd = document.createElement('dd');
	    this.dd.innerHTML = args.subtitle;
	
	    dl.appendChild(this.dt);
	    dl.appendChild(this.dd);
	    div.appendChild(dl);
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(IndexResult, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      return this.dt.innerHTML;
	    }
	  }, {
	    key: 'setTitle',
	    value: function setTitle(text) {
	      this.dt.innerHTML = text;
	    }
	  }, {
	    key: 'getSubtitle',
	    value: function getSubtitle() {
	      return this.dd.innerHTML;
	    }
	  }, {
	    key: 'setSubtitle',
	    value: function setSubtitle(text) {
	      this.dd.innerHTML = text;
	    }
	  }]);
	
	  return IndexResult;
	}();
	
	var IndexList = function () {
	  function IndexList(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, IndexList);
	
	    this.div = document.createElement('div');
	    this.div.className = 'index';
	    this.reverse = args.reverse;
	    this.showImage = args.showImage;
	    this.onclick = args.onclick;
	    this.p = document.createElement('p');
	    this.input = document.createElement('input');
	    this.input.placeholder = 'Typ hier om te filteren';
	    this.input.type = 'search';
	    this.input.onkeydown = function (e) {
	      if (event.keyCode === 13) {
	        e.target.blur();
	      }
	    };
	    this.items = [];
	
	    this.input.oninput = function () {
	      _this.refreshResults();
	    };
	
	    this.setItems(args.items);
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(this.div);
	    this.div.appendChild(this.input);
	    this.div.appendChild(this.p);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(IndexList, [{
	    key: 'getFilter',
	    value: function getFilter() {
	      return this.input.value;
	    }
	  }, {
	    key: 'setFilter',
	    value: function setFilter(filter) {
	      this.input.value = filter;
	      this.refreshResults();
	    }
	  }, {
	    key: 'getItems',
	    value: function getItems() {
	      return this.items;
	    }
	  }, {
	    key: 'setItems',
	    value: function setItems(newItems) {
	      var _this2 = this;
	
	      this.div.classList.add('working');
	      this.items = newItems;
	
	      new Promise(function (resolve) {
	        if (_this2.items) {
	          _this2.items.sort(function (item, compareTo) {
	            if (item.getCompareString && compareTo.getCompareString) {
	              return _this2.reverse ? compareTo.getCompareString().localeCompare(item.getCompareString()) : item.getCompareString().localeCompare(compareTo.getCompareString());
	            }
	
	            return 0;
	          });
	
	          resolve();
	        } else {
	          resolve();
	        }
	      }).then(function () {
	        _this2.refreshResults();
	        _this2.div.classList.remove('working');
	      });
	    }
	  }, {
	    key: 'refreshResults',
	    value: function refreshResults() {
	      var _this3 = this;
	
	      var filter = this.getFilter().toLowerCase();
	      var lastLabel = '';
	
	      if (!this.items || !this.items.length) {
	        this.p.innerHTML = 'Geen gegevens beschikbaar';
	        this.input.className = 'invisible';
	        this.input.disabled = true;
	        return;
	      }
	
	      this.input.className = '';
	      this.input.disabled = false;
	
	      var results = [];
	
	      this.p.innerHTML = '';
	
	      this.items.forEach(function (item) {
	        var title = item ? item.getTitle() ? item.getTitle().toLowerCase() : 'onbekend' : '';
	        var subtitle = item ? item.getSubtitle() ? item.getSubtitle().toLowerCase() : 'onbekend' : '';
	
	        if (filter && title.indexOf(filter) === -1 && subtitle.indexOf(filter) === -1) {
	          return;
	        }
	
	        if (lastLabel !== item.getIndex()) {
	          lastLabel = item.getIndex();
	          var label = document.createElement('label');
	          label.innerHTML = lastLabel;
	          _this3.p.appendChild(label);
	        }
	
	        results.push(new IndexResult(_this3.p, {
	          title: item.getTitle(),
	          subtitle: item.getSubtitle(),
	          item: item,
	          showImage: _this3.showImage,
	          onclick: function onclick() {
	            if (_this3.onclick) {
	              _this3.onclick(item);
	            }
	          }
	        }));
	      });
	
	      if (filter && !results.length) {
	        this.p.innerHTML = 'Filter geeft geen resultaten';
	        return;
	      }
	    }
	  }]);
	
	  return IndexList;
	}();
	
	exports.default = IndexList;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImageFrame = function () {
	  function ImageFrame(element, args) {
	    _classCallCheck(this, ImageFrame);
	
	    this.img = document.createElement('img');
	    this.img.src = args.image ? args.image : '';
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(this.img);
	
	    if (element) {
	      element.appendChild(fragment);
	    }
	  }
	
	  _createClass(ImageFrame, [{
	    key: 'getImage',
	    value: function getImage() {
	      return this.img.src;
	    }
	  }, {
	    key: 'setImage',
	    value: function setImage(image) {
	      this.img.src = image ? image : '';
	    }
	  }, {
	    key: 'getElement',
	    value: function getElement() {
	      return this.img;
	    }
	  }]);
	
	  return ImageFrame;
	}();
	
	exports.default = ImageFrame;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImagePlaceholderFrame = function () {
	  function ImagePlaceholderFrame(element, args) {
	    _classCallCheck(this, ImagePlaceholderFrame);
	
	    this.div = document.createElement('div');
	    this.div.className = 'imagePlaceholder';
	
	    this.setTitle(args.title);
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(this.div);
	
	    if (element) {
	      element.appendChild(fragment);
	    }
	  }
	
	  _createClass(ImagePlaceholderFrame, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      return this.div.innerHTML;
	    }
	  }, {
	    key: 'setTitle',
	    value: function setTitle(title) {
	      var display = title;
	
	      if (!display) {
	        display = '?';
	      }
	
	      var pos = 0;
	      var r = Math.floor(display.charCodeAt(pos) % 26 * 10);
	
	      if (display.length > 1) {
	        pos = 1;
	      }
	
	      var g = 192; // Math.floor((title.charCodeAt(pos) % 26) * 7) + 32
	
	      if (display.length > 2) {
	        pos = 2;
	      }
	
	      var b = Math.floor(display.charCodeAt(pos) % 26 * 6);
	
	      this.div.style.backgroundColor = 'rgb(' + r + ', ' + g + ', ' + b + ')';
	      this.div.innerHTML = display.substring(0, 1).toUpperCase();
	    }
	  }, {
	    key: 'getElement',
	    value: function getElement() {
	      return this.div;
	    }
	  }]);
	
	  return ImagePlaceholderFrame;
	}();
	
	exports.default = ImagePlaceholderFrame;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Start = function Start(element) {
	  _classCallCheck(this, Start);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'PRIM',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        window.PRIM.navigate('/new/');
	      },
	      icon: '\uE0CF'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        window.PRIM.navigate('/about/');
	      },
	      icon: '\uE091',
	      label: 'Over PRIM'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/changecredentials/');
	      },
	      icon: '\uE04B',
	      label: 'Wachtwoord wijzigen'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/reportpeople/');
	      },
	      icon: '\uE052',
	      label: 'Personen rapportage'
	    },
	    /*{
	      onclick: () => {
	        window.PRIM.navigate('/import/')
	      },
	      icon: '\ue126',
	      label: 'Gegevens importeren'
	    },*/
	    {
	      onclick: function onclick() {
	        window.PRIM.navigate('/export/');
	      },
	      icon: '\uE065',
	      label: 'Gegevens exporteren'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var button = document.createElement('button');
	  button.innerHTML = 'Zoeken';
	  button.onclick = function () {
	    window.PRIM.navigate('/search/');
	  };
	
	  div.appendChild(button);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = Start;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _CheckboxControl = __webpack_require__(26);
	
	var _CheckboxControl2 = _interopRequireDefault(_CheckboxControl);
	
	var _CsvExporter = __webpack_require__(27);
	
	var _CsvExporter2 = _interopRequireDefault(_CsvExporter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReportPeople = function ReportPeople(element) {
	  var _this = this;
	
	  _classCallCheck(this, ReportPeople);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Personen rapportage',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }]
	  });
	
	  var createReport = function createReport() {
	    if (!_this.sendbirthdaycard.getValue() && !_this.sendbirthdayemail.getValue() && !_this.sendchristmascard.getValue() && !_this.sendchristmasemail.getValue()) {
	      alert('Kies tenminste één optie.');
	      return;
	    }
	
	    window.PRIM.dataAccess.resolve('people').then(function (people) {
	      var filtered = people.filter(function (person) {
	        return _this.sendbirthdayemail.getValue() === true && person.values.sendbirthdayemail === true || _this.sendbirthdaycard.getValue() === true && person.values.sendbirthdaycard === true || _this.sendchristmasemail.getValue() === true && person.values.sendchristmasemail === true || _this.sendchristmascard.getValue() === true && person.values.sendchristmascard === true;
	      });
	
	      if (filtered.length === 0) {
	        alert('Er zijn geen personen die voldoen aan de gekozen opties.');
	        return;
	      }
	
	      var exporter = new _CsvExporter2.default();
	      var csv = exporter.export(['nickname', 'suffix', 'lastname', 'address', 'zipcode', 'city', 'country', 'email', 'phone', 'mobile'], filtered);
	      var blob = new Blob([csv], { type: 'text/csv' });
	      if (navigator.msSaveOrOpenBlob) {
	        navigator.msSaveBlob(blob, 'export.csv');
	      } else {
	        var url = URL.createObjectURL(blob);
	        var tempAnchor = document.createElement('a');
	        tempAnchor.href = url;
	        tempAnchor.download = 'export.csv';
	        tempAnchor.className = 'invisible';
	        document.body.appendChild(tempAnchor);
	        tempAnchor.click();
	        document.body.removeChild(tempAnchor);
	        URL.revokeObjectURL(url);
	      }
	    }, function (e) {
	      alert('Er is iets fout gegaan tijdens het maken van het rapport. Probeer het opnieuw.');
	    });
	  };
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var fieldsetOptions = document.createElement('fieldset');
	  var legendOptions = document.createElement('legend');
	  legendOptions.innerHTML = 'Opties';
	  fieldsetOptions.appendChild(legendOptions);
	
	  this.sendbirthdayemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Verjaardagskaart per e-mail', readonly: window.PRIM.hasReadonlyModuleAccess('people') });
	  this.sendbirthdaycard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Verjaardagskaart per post', readonly: window.PRIM.hasReadonlyModuleAccess('people') });
	  this.sendchristmasemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per e-mail', readonly: window.PRIM.hasReadonlyModuleAccess('people') });
	  this.sendchristmascard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per post', readonly: window.PRIM.hasReadonlyModuleAccess('people') });
	
	  var button = document.createElement('button');
	  button.innerHTML = 'Maak rapport';
	  button.onclick = createReport;
	
	  div.appendChild(fieldsetOptions);
	
	  div.appendChild(button);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = ReportPeople;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CheckboxControl = function () {
	  function CheckboxControl(element, args) {
	    _classCallCheck(this, CheckboxControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.input.checked = args.value ? true : false;
	    this.input.type = 'checkbox';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(CheckboxControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.checked;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.checked = value ? true : false;
	    }
	  }]);
	
	  return CheckboxControl;
	}();
	
	exports.default = CheckboxControl;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CsvExporter = function () {
	  function CsvExporter() {
	    _classCallCheck(this, CsvExporter);
	  }
	
	  _createClass(CsvExporter, [{
	    key: 'header',
	    value: function header(columns) {
	      var result = '"sep=,"\r\n';
	      result += this.line(columns);
	
	      return result;
	    }
	  }, {
	    key: 'value',
	    value: function value(_value) {
	      return "\"" + _value.replace(/"/g, '""') + "\"";
	    }
	  }, {
	    key: 'line',
	    value: function line(values) {
	      return values.map(this.value).join(',') + '\r\n';
	    }
	  }, {
	    key: 'export',
	    value: function _export(columns, data) {
	      var _this = this;
	
	      var result = this.header(columns);
	
	      data.forEach(function (item) {
	        var values = columns.map(function (column) {
	          return item.values[column] ? item.values[column] : '';
	        });
	
	        result += _this.line(values);
	      });
	
	      return result;
	    }
	  }]);
	
	  return CsvExporter;
	}();
	
	exports.default = CsvExporter;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _FileControl = __webpack_require__(29);
	
	var _FileControl2 = _interopRequireDefault(_FileControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Import = function () {
	  function Import(element, args) {
	    _classCallCheck(this, Import);
	
	    this.element = element;
	    this.args = args;
	
	    this.render(element);
	  }
	
	  _createClass(Import, [{
	    key: 'render',
	    value: function render(element) {
	      var fragment = document.createDocumentFragment();
	
	      this.renderNavigation(fragment);
	
	      var div = document.createElement('div');
	      div.className = 'viewport';
	
	      var p = document.createElement('p');
	      p.innerHTML = 'Geef hieronder het import bestand op.';
	
	      div.appendChild(p);
	
	      this.renderForm(div);
	
	      fragment.appendChild(div);
	
	      var button = document.createElement('button');
	      button.innerHTML = 'Importeer bestand';
	      button.onclick = this.onimport;
	
	      fragment.appendChild(button);
	
	      element.appendChild(fragment);
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm(element) {
	      var fieldsetFile = document.createElement('fieldset');
	      var legendFile = document.createElement('legend');
	      legendFile.innerHTML = 'Importeren';
	      fieldsetFile.appendChild(legendFile);
	
	      this.file = new _FileControl2.default(fieldsetFile, { label: 'Import bestand' });
	
	      element.appendChild(fieldsetFile);
	    }
	  }, {
	    key: 'renderNavigation',
	    value: function renderNavigation(element) {
	      new _NavigationBarControl2.default(element, {
	        title: 'Gegevens importeren',
	        leftHandButtons: [{
	          onclick: function onclick() {
	            history.back();
	          },
	          icon: '\uE00D'
	        }]
	      });
	    }
	  }, {
	    key: 'onimport',
	    value: function onimport() {
	      if (this.file.input.files.length === 0) {
	        alert('Kies eerst een import bestand.');
	        return;
	      }
	
	      var reader = new FileReader();
	      reader.onload = function () {
	        var data = JSON.parse(reader.result);
	        var promises = [];
	
	        if (data.people) {
	          data.people.forEach(function (item) {
	            promises.push(window.PRIM.dataAccess.put(item));
	          });
	        }
	
	        Promise.all(promises).then(function () {
	          alert(promises.length + ' item(s) zijn geimporteerd.');
	        }, function () {
	          alert('Er is een fout opgetreden. Niet alle ' + promises.length + ' item(s) zijn geimporteerd.');
	        });
	      };
	      reader.onerror = function () {
	        alert('Er is een fout opgetreden. Het bestand kon niet worden gebruikt als import bestand.');
	      };
	      reader.readAsText(this.file.input.files[0]);
	    }
	  }]);
	
	  return Import;
	}();
	
	exports.default = Import;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FileControl = function () {
	  function FileControl(element, args) {
	    _classCallCheck(this, FileControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.input.value = '';
	    this.input.type = 'file';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(FileControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value;
	    }
	  }]);
	
	  return FileControl;
	}();
	
	exports.default = FileControl;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Export = function () {
	  function Export(element, args) {
	    _classCallCheck(this, Export);
	
	    this.element = element;
	    this.args = args;
	
	    this.render(element);
	  }
	
	  _createClass(Export, [{
	    key: 'render',
	    value: function render(element) {
	      var fragment = document.createDocumentFragment();
	
	      this.renderNavigation(fragment);
	
	      var div = document.createElement('div');
	      div.className = 'viewport';
	
	      var p = document.createElement('p');
	      p.innerHTML = 'Er zal een export bestand gemaakt worden van de gegevens die zich op dit moment in uw apparaat bevinden. Let op: uw gegevens worden hierin onversleuteld opgeslagen.';
	
	      div.appendChild(p);
	
	      fragment.appendChild(div);
	
	      var button = document.createElement('button');
	      button.innerHTML = 'Maak export bestand';
	      button.onclick = this.onexport;
	
	      fragment.appendChild(button);
	
	      element.appendChild(fragment);
	    }
	  }, {
	    key: 'renderNavigation',
	    value: function renderNavigation(element) {
	      new _NavigationBarControl2.default(element, {
	        title: 'Gegevens exporteren',
	        leftHandButtons: [{
	          onclick: function onclick() {
	            history.back();
	          },
	          icon: '\uE00D'
	        }]
	      });
	    }
	  }, {
	    key: 'onexport',
	    value: function onexport() {
	      var data = {};
	
	      Promise.all([window.PRIM.dataAccess.get('people').then(function (people) {
	        data.people = people;
	      }), window.PRIM.dataAccess.get('organisations').then(function (organisations) {
	        data.organisations = organisations;
	      }), window.PRIM.dataAccess.get('relationships').then(function (relationships) {
	        data.relationships = relationships;
	      }), window.PRIM.dataAccess.get('locations').then(function (locations) {
	        data.locations = locations;
	      }), window.PRIM.dataAccess.get('positions').then(function (positions) {
	        data.positions = positions;
	      }), window.PRIM.dataAccess.get('educations').then(function (educations) {
	        data.educations = educations;
	      }), window.PRIM.dataAccess.get('logentries').then(function (logentries) {
	        data.logentries = logentries;
	      })]).then(function () {
	        var blob = new Blob([JSON.stringify(data)], { type: 'text/json' });
	        if (navigator.msSaveOrOpenBlob) {
	          navigator.msSaveBlob(blob, 'export.json');
	        } else {
	          var url = URL.createObjectURL(blob);
	          var tempAnchor = document.createElement('a');
	          tempAnchor.href = url;
	          tempAnchor.download = 'export.json';
	          tempAnchor.className = 'invisible';
	          document.body.appendChild(tempAnchor);
	          tempAnchor.click();
	          document.body.removeChild(tempAnchor);
	          URL.revokeObjectURL(url);
	        }
	      }, function () {
	        alert('Er is iets fout gegaan tijdens het maken van het export bestand. Probeer het opnieuw.');
	      });
	    }
	  }]);
	
	  return Export;
	}();
	
	exports.default = Export;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _IndexControl = __webpack_require__(21);
	
	var _IndexControl2 = _interopRequireDefault(_IndexControl);
	
	var _PersonForm = __webpack_require__(32);
	
	var _PersonForm2 = _interopRequireDefault(_PersonForm);
	
	var _PersonModel = __webpack_require__(6);
	
	var _PersonModel2 = _interopRequireDefault(_PersonModel);
	
	var _OrganisationModel = __webpack_require__(9);
	
	var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);
	
	var _PositionModel = __webpack_require__(7);
	
	var _PositionModel2 = _interopRequireDefault(_PositionModel);
	
	var _EducationModel = __webpack_require__(8);
	
	var _EducationModel2 = _interopRequireDefault(_EducationModel);
	
	var _LogentryModel = __webpack_require__(10);
	
	var _LogentryModel2 = _interopRequireDefault(_LogentryModel);
	
	var _LocationModel = __webpack_require__(11);
	
	var _LocationModel2 = _interopRequireDefault(_LocationModel);
	
	var _RelationshipModel = __webpack_require__(12);
	
	var _RelationshipModel2 = _interopRequireDefault(_RelationshipModel);
	
	var _ObjectTypeMapping = __webpack_require__(49);
	
	var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);
	
	var _VcardExporter = __webpack_require__(50);
	
	var _VcardExporter2 = _interopRequireDefault(_VcardExporter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditPerson = function EditPerson(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, EditPerson);
	
	  this.onchange = function () {
	    _this.data = _this.personForm.getValue();
	    window.PRIM.initDelayedNavigation();
	    window.PRIM.dataAccess.put('people', _this.data.getJSON()).then(function (person) {
	      if (!window.PRIM.isDelayedNavigationActive()) {
	        return;
	      }
	
	      if (args && !args.id && person.id) {
	        window.PRIM.navigate('/people/' + person.id, true);
	      }
	
	      if (person) {
	        _this.data.values.id = person.id;
	        _this.personForm.setValue(_this.data);
	      }
	    }).catch(window.PRIM.exceptionHandler);
	  };
	
	  if (args && args.id) {
	    window.PRIM.dataAccess.resolve('people', args.id, true).then(function (person) {
	      _this.data = person;
	      _this.personForm.setValue(_this.data);
	
	      window.PRIM.dataAccess.get('relationships').then(function (relationships) {
	        var results = relationships.filter(function (relationship) {
	          return relationship.person_id === _this.data.values.id;
	        });
	
	        var promisesToResolve = 0;
	        _this.data.relationships = results.map(function (relationship) {
	          var model = new _RelationshipModel2.default(relationship);
	          model.person = _this.data;
	          if (relationship.target_id) {
	            promisesToResolve++;
	            window.PRIM.dataAccess.get('people', relationship.target_id).then(function (target) {
	              model.target = new _PersonModel2.default(target);
	              promisesToResolve--;
	              if (promisesToResolve === 0) {
	                _this.relationshipIndex.setItems(_this.data.relationships);
	              }
	            }).catch(function (e) {
	              promisesToResolve--;
	              window.PRIM.exceptionHandler(e);
	            });
	          }
	
	          return model;
	        });
	
	        if (promisesToResolve === 0) {
	          _this.relationshipIndex.setItems(_this.data.relationships);
	        }
	      }, function () {}).catch(window.PRIM.exceptionHandler);
	      window.PRIM.dataAccess.get('positions').then(function (positions) {
	        var results = positions.filter(function (position) {
	          return position.person_id === _this.data.values.id;
	        });
	
	        _this.data.positions = results.map(function (position) {
	          var model = new _PositionModel2.default(position);
	          model.person = _this.data;
	          if (position.location_id) {
	            window.PRIM.dataAccess.get('locations', position.location_id).then(function (location) {
	              model.location = new _LocationModel2.default(location);
	              if (location.organisation_id) {
	                window.PRIM.dataAccess.get('organisations', location.organisation_id).then(function (organisation) {
	                  model.location.organisation = new _OrganisationModel2.default(organisation);
	                  _this.positionIndex.setItems(_this.data.positions);
	                }).catch(window.PRIM.exceptionHandler);
	              } else {
	                _this.positionIndex.setItems(_this.data.positions);
	              }
	            }).catch(window.PRIM.exceptionHandler);
	          }
	
	          return model;
	        });
	
	        _this.positionIndex.setItems(_this.data.positions);
	      }, function () {}).catch(window.PRIM.exceptionHandler);
	      window.PRIM.dataAccess.get('educations').then(function (educations) {
	        var results = educations.filter(function (education) {
	          return education.person_id === _this.data.values.id;
	        });
	
	        _this.data.educations = results.map(function (education) {
	          var model = new _EducationModel2.default(education);
	
	          if (education.location_id) {
	            window.PRIM.dataAccess.get('locations', education.location_id).then(function (location) {
	              model.location = new _LocationModel2.default(location);
	              if (location.organisation_id) {
	                window.PRIM.dataAccess.get('organisations', location.organisation_id).then(function (organisation) {
	                  model.location.organisation = new _OrganisationModel2.default(organisation);
	                  _this.educationIndex.setItems(_this.data.educations);
	                }).catch(window.PRIM.exceptionHandler);
	              } else {
	                _this.educationIndex.setItems(_this.data.educations);
	              }
	            }).catch(window.PRIM.exceptionHandler);
	          }
	
	          return model;
	        });
	
	        _this.educationIndex.setItems(_this.data.educations);
	      }, function () {}).catch(window.PRIM.exceptionHandler);
	      window.PRIM.dataAccess.get('logentries').then(function (logentries) {
	        var results = logentries.filter(function (logentry) {
	          return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.person;
	        });
	
	        _this.data.logentries = results.map(function (logentry) {
	          return new _LogentryModel2.default(logentry);
	        });
	
	        _this.logIndex.setItems(_this.data.logentries);
	      }, function () {}).catch(window.PRIM.exceptionHandler);
	    }, function () {
	      if (confirm('Deze persoon bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw persoon aanmaken?')) {
	        window.PRIM.navigate('/people/');
	      } else {
	        history.back();
	      }
	    }).catch(window.PRIM.exceptionHandler);
	  }
	
	  this.data = new _PersonModel2.default();
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Persoon bewerken',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }, {
	      onclick: this.onchange,
	      icon: '\uE020',
	      classes: 'indicator'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          window.PRIM.navigate('/relationships/new/' + _this.data.values.id);
	        } else {
	          alert('Vul eerst gegevens voor deze persoon.');
	        }
	      },
	      icon: '\uE083',
	      label: 'Relatie'
	    }, {
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          window.PRIM.navigate('/positions/person/' + _this.data.values.id);
	        } else {
	          alert('Vul eerst gegevens voor deze persoon.');
	        }
	      },
	      icon: '\uE034',
	      label: 'Functie'
	    }, {
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          window.PRIM.navigate('/logentries/person/' + _this.data.values.id);
	        } else {
	          alert('Vul eerst gegevens voor deze persoon.');
	        }
	      },
	      icon: '\uE032',
	      label: 'Logboekregel'
	    }, {
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          if (confirm('Weet u het zeker dat u deze persoon wilt verwijderen?')) {
	            window.PRIM.dataAccess.delete('people', _this.data.values.id).then(function () {
	              history.back();
	            });
	          }
	        } else {
	          alert('Vul eerst gegevens voor deze persoon.');
	        }
	      },
	      icon: '\uE123',
	      label: 'Verwijderen'
	    }, {
	      onclick: function onclick() {
	        var exporter = new _VcardExporter2.default();
	        var model = _this.personForm.getValue();
	        var vcard = exporter.export(model);
	        var blob = new Blob([vcard], { type: 'text/vcard' });
	        if (navigator.msSaveOrOpenBlob) {
	          navigator.msSaveBlob(blob, 'export.vcf');
	        } else {
	          var url = URL.createObjectURL(blob);
	          var tempAnchor = document.createElement('a');
	          tempAnchor.href = url;
	          tempAnchor.download = 'export.vcf';
	          tempAnchor.className = 'invisible';
	          document.body.appendChild(tempAnchor);
	          tempAnchor.click();
	          document.body.removeChild(tempAnchor);
	          URL.revokeObjectURL(url);
	        }
	      },
	      icon: '\uE052',
	      label: 'Exporteren'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var divContent = document.createElement('div');
	  divContent.className = 'content';
	
	  var primaryData = document.createElement('section');
	  primaryData.className = 'primary';
	  var secondaryData = document.createElement('section');
	  secondaryData.className = 'secondary';
	
	  this.personForm = new _PersonForm2.default(primaryData, { person: this.data, onchange: this.onchange });
	
	  var fieldsetRelationships = document.createElement('fieldset');
	  var legendRelationships = document.createElement('legend');
	  legendRelationships.innerHTML = 'Relaties';
	  fieldsetRelationships.appendChild(legendRelationships);
	
	  var onclickRelationship = function onclickRelationship(item) {
	    window.PRIM.navigate('/relationships/' + item.values.id);
	    return;
	  };
	
	  this.relationshipIndex = new _IndexControl2.default(fieldsetRelationships, { items: this.data.relationships, onclick: onclickRelationship });
	
	  secondaryData.appendChild(fieldsetRelationships);
	
	  var fieldsetPositions = document.createElement('fieldset');
	  var legendPositions = document.createElement('legend');
	  legendPositions.innerHTML = 'Functies';
	  fieldsetPositions.appendChild(legendPositions);
	
	  var onclickPosition = function onclickPosition(item) {
	    window.PRIM.navigate('/positions/' + item.values.id);
	    return;
	  };
	
	  this.positionIndex = new _IndexControl2.default(fieldsetPositions, { items: this.data.positions, onclick: onclickPosition });
	
	  secondaryData.appendChild(fieldsetPositions);
	
	  var fieldsetEducations = document.createElement('fieldset');
	  var legendEducations = document.createElement('legend');
	  legendEducations.innerHTML = 'Opleidingen';
	  fieldsetEducations.appendChild(legendEducations);
	
	  var onclickEducation = function onclickEducation(item) {
	    window.PRIM.navigate('/educations/' + item.values.id);
	    return;
	  };
	
	  this.educationIndex = new _IndexControl2.default(fieldsetEducations, { items: this.data.educations, onclick: onclickEducation });
	
	  secondaryData.appendChild(fieldsetEducations);
	
	  var fieldsetLog = document.createElement('fieldset');
	  var legendLog = document.createElement('legend');
	  legendLog.innerHTML = 'Logboek';
	  fieldsetLog.appendChild(legendLog);
	
	  var onclickLogentry = function onclickLogentry(item) {
	    window.PRIM.navigate('/logentries/' + item.values.id);
	    return;
	  };
	
	  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });
	
	  secondaryData.appendChild(fieldsetLog);
	
	  divContent.appendChild(primaryData);
	  divContent.appendChild(secondaryData);
	  div.appendChild(divContent);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = EditPerson;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _PersonModel = __webpack_require__(6);
	
	var _PersonModel2 = _interopRequireDefault(_PersonModel);
	
	var _PersonGenderOptions = __webpack_require__(33);
	
	var _PersonGenderOptions2 = _interopRequireDefault(_PersonGenderOptions);
	
	var _PersonMaritalStatusOptions = __webpack_require__(34);
	
	var _PersonMaritalStatusOptions2 = _interopRequireDefault(_PersonMaritalStatusOptions);
	
	var _CountryOptions = __webpack_require__(35);
	
	var _CountryOptions2 = _interopRequireDefault(_CountryOptions);
	
	var _ImageSelectControl = __webpack_require__(36);
	
	var _ImageSelectControl2 = _interopRequireDefault(_ImageSelectControl);
	
	var _TextControl = __webpack_require__(39);
	
	var _TextControl2 = _interopRequireDefault(_TextControl);
	
	var _SelectControl = __webpack_require__(40);
	
	var _SelectControl2 = _interopRequireDefault(_SelectControl);
	
	var _DateControl = __webpack_require__(41);
	
	var _DateControl2 = _interopRequireDefault(_DateControl);
	
	var _StaticControl = __webpack_require__(17);
	
	var _StaticControl2 = _interopRequireDefault(_StaticControl);
	
	var _PhonenumberControl = __webpack_require__(42);
	
	var _PhonenumberControl2 = _interopRequireDefault(_PhonenumberControl);
	
	var _EmailControl = __webpack_require__(43);
	
	var _EmailControl2 = _interopRequireDefault(_EmailControl);
	
	var _LinkedinControl = __webpack_require__(44);
	
	var _LinkedinControl2 = _interopRequireDefault(_LinkedinControl);
	
	var _FacebookControl = __webpack_require__(45);
	
	var _FacebookControl2 = _interopRequireDefault(_FacebookControl);
	
	var _SkypeControl = __webpack_require__(46);
	
	var _SkypeControl2 = _interopRequireDefault(_SkypeControl);
	
	var _TwitterControl = __webpack_require__(47);
	
	var _TwitterControl2 = _interopRequireDefault(_TwitterControl);
	
	var _CheckboxControl = __webpack_require__(26);
	
	var _CheckboxControl2 = _interopRequireDefault(_CheckboxControl);
	
	var _GoogleMapsButtonControl = __webpack_require__(48);
	
	var _GoogleMapsButtonControl2 = _interopRequireDefault(_GoogleMapsButtonControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PersonForm = function () {
	  function PersonForm(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, PersonForm);
	
	    var fieldsetPersonal = document.createElement('fieldset');
	    var legendPersonal = document.createElement('legend');
	    legendPersonal.innerHTML = 'Persoonsgegevens';
	    fieldsetPersonal.appendChild(legendPersonal);
	
	    this.id = args.person.values.id;
	    this.image = new _ImageSelectControl2.default(fieldsetPersonal, { label: 'Afbeelding', value: args.person.values.image, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.lastname = new _TextControl2.default(fieldsetPersonal, { label: 'Achternaam', value: args.person.values.lastname, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.suffix = new _TextControl2.default(fieldsetPersonal, { label: 'Tussenvoegsels', value: args.person.values.suffix, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.maidenname = new _TextControl2.default(fieldsetPersonal, { label: 'Meisjesnaam', value: args.person.values.maidenname, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.maidensuffix = new _TextControl2.default(fieldsetPersonal, { label: 'Meisjestussenvoegsels', value: args.person.values.maidensuffix, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.forenames = new _TextControl2.default(fieldsetPersonal, { label: 'Voornamen', value: args.person.values.forenames, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.initials = new _TextControl2.default(fieldsetPersonal, { label: 'Voorletters', value: args.person.values.initials, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.nickname = new _TextControl2.default(fieldsetPersonal, { label: 'Roepnaam', value: args.person.values.nickname, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.gender = new _SelectControl2.default(fieldsetPersonal, { label: 'Geslacht', value: args.person.values.gender, options: _PersonGenderOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	
	    var fieldsetBackground = document.createElement('fieldset');
	    var legendBackground = document.createElement('legend');
	    legendBackground.innerHTML = 'Achtergrond gegevens';
	    fieldsetBackground.appendChild(legendBackground);
	
	    this.calculateAge = function () {
	      if (!_this.dateofbirth.getValue()) {
	        _this.age.setValue('Onbekend');
	        return;
	      }
	
	      var beginDate = new Date(_this.dateofbirth.getValue());
	
	      if (isNaN(beginDate)) {
	        _this.age.setValue('Onbekend');
	        return;
	      }
	
	      var endDate = new Date();
	
	      if (_this.dateofdeath.getValue()) {
	        endDate = new Date(_this.dateofdeath.getValue());
	        if (isNaN(endDate)) {
	          endDate = new Date();
	        }
	      }
	
	      var calculatedAge = endDate.getFullYear() - beginDate.getFullYear();
	
	      var month = endDate.getMonth() - beginDate.getMonth();
	      if (month < 0 || month === 0 && endDate.getDate() < beginDate.getDate()) {
	        calculatedAge--;
	      }
	
	      if (calculatedAge < 0) {
	        calculatedAge = 0;
	      }
	
	      _this.age.setValue(calculatedAge);
	    };
	
	    this.nationality = new _SelectControl2.default(fieldsetBackground, { label: 'Nationaliteit', value: args.person.values.nationality, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.countryoforigin = new _SelectControl2.default(fieldsetBackground, { label: 'Land van herkomst', value: args.person.values.countryoforigin, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.religion = new _TextControl2.default(fieldsetBackground, { label: 'Etniciteit', value: args.person.values.religion, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.maritalstatus = new _SelectControl2.default(fieldsetBackground, { label: 'Burgelijke staat', value: args.person.values.maritalstatus, options: _PersonMaritalStatusOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.dateofbirth = new _DateControl2.default(fieldsetBackground, { label: 'Geboortedatum', value: args.person.values.dateofbirth, onchange: function onchange(e) {
	        _this.calculateAge();
	        if (args.onchange) {
	          args.onchange(e);
	        }
	      } });
	    this.age = new _StaticControl2.default(fieldsetBackground, { label: 'Leeftijd', value: '-', readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.dateofdeath = new _DateControl2.default(fieldsetBackground, { label: 'Sterfdatum', value: args.person.values.dateofdeath, onchange: function onchange(e) {
	        _this.calculateAge();
	        if (args.onchange) {
	          args.onchange(e);
	        }
	      } });
	
	    var fieldsetAddress = document.createElement('fieldset');
	    var legendAddress = document.createElement('legend');
	    legendAddress.innerHTML = 'Woonadres';
	    fieldsetAddress.appendChild(legendAddress);
	
	    this.address = new _TextControl2.default(fieldsetAddress, { label: 'Adres', value: args.person.values.address, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.zipcode = new _TextControl2.default(fieldsetAddress, { label: 'Postcode', value: args.person.values.zipcode, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.city = new _TextControl2.default(fieldsetAddress, { label: 'Plaats', value: args.person.values.city, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.region = new _TextControl2.default(fieldsetAddress, { label: 'Provincie', value: args.person.values.region, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.country = new _SelectControl2.default(fieldsetAddress, { label: 'Land', value: args.person.values.country, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.addressGoogleMaps = new _GoogleMapsButtonControl2.default(fieldsetAddress, { getValues: function getValues() {
	        return [_this.address.getValue(), _this.zipcode.getValue(), _this.city.getValue(), _this.region.getValue(), _this.country.getValue()];
	      } });
	
	    var fieldsetContact = document.createElement('fieldset');
	    var legendContact = document.createElement('legend');
	    legendContact.innerHTML = 'Contact gegevens';
	    fieldsetContact.appendChild(legendContact);
	
	    this.phone = new _PhonenumberControl2.default(fieldsetContact, { label: 'Telefoon', value: args.person.values.phone, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.mobile = new _PhonenumberControl2.default(fieldsetContact, { label: 'Mobiel', value: args.person.values.mobile, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.email = new _EmailControl2.default(fieldsetContact, { label: 'E-mail', value: args.person.values.email, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.linkedinid = new _LinkedinControl2.default(fieldsetContact, { label: 'LinkedIn ID', value: args.person.values.linkedinid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.twitterid = new _TwitterControl2.default(fieldsetContact, { label: 'Twitter ID', value: args.person.values.twitterid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.facebookid = new _FacebookControl2.default(fieldsetContact, { label: 'Facebook ID', value: args.person.values.facebookid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.skypeid = new _SkypeControl2.default(fieldsetContact, { label: 'Skype ID', value: args.person.values.skypeid, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	
	    var fieldsetOptions = document.createElement('fieldset');
	    var legendOptions = document.createElement('legend');
	    legendOptions.innerHTML = 'Opties';
	    fieldsetOptions.appendChild(legendOptions);
	
	    this.sendbirthdayemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Verjaardagskaart per e-mail', value: args.person.values.sendbirthdayemail, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.sendbirthdaycard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Verjaardagskaart per post', value: args.person.values.sendbirthdaycard, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.sendchristmasemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per e-mail', value: args.person.values.sendchristmasemail, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	    this.sendchristmascard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per post', value: args.person.values.sendchristmascard, readonly: window.PRIM.hasReadonlyModuleAccess('people'), onchange: args.onchange });
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(fieldsetPersonal);
	    fragment.appendChild(fieldsetBackground);
	    fragment.appendChild(fieldsetAddress);
	    fragment.appendChild(fieldsetContact);
	    fragment.appendChild(fieldsetOptions);
	
	    this.calculateAge();
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(PersonForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      var person = new _PersonModel2.default();
	      person.values.id = this.id;
	      person.values.image = this.image.getValue();
	      person.values.lastname = this.lastname.getValue();
	      person.values.suffix = this.suffix.getValue();
	      person.values.maidenname = this.maidenname.getValue();
	      person.values.maidensuffix = this.maidensuffix.getValue();
	      person.values.forenames = this.forenames.getValue();
	      person.values.initials = this.initials.getValue();
	      person.values.nickname = this.nickname.getValue();
	      person.values.gender = this.gender.getValue();
	      person.values.nationality = this.nationality.getValue();
	      person.values.countryoforigin = this.countryoforigin.getValue();
	      person.values.religion = this.religion.getValue();
	      person.values.maritalstatus = this.maritalstatus.getValue();
	      person.values.dateofbirth = this.dateofbirth.getValue();
	      person.values.dateofdeath = this.dateofdeath.getValue();
	      person.values.address = this.address.getValue();
	      person.values.zipcode = this.zipcode.getValue();
	      person.values.city = this.city.getValue();
	      person.values.region = this.region.getValue();
	      person.values.country = this.country.getValue();
	      person.values.phone = this.phone.getValue();
	      person.values.mobile = this.mobile.getValue();
	      person.values.email = this.email.getValue();
	      person.values.linkedinid = this.linkedinid.getValue();
	      person.values.twitterid = this.twitterid.getValue();
	      person.values.facebookid = this.facebookid.getValue();
	      person.values.skypeid = this.skypeid.getValue();
	      person.values.sendbirthdayemail = this.sendbirthdayemail.getValue();
	      person.values.sendbirthdaycard = this.sendbirthdaycard.getValue();
	      person.values.sendchristmasemail = this.sendchristmasemail.getValue();
	      person.values.sendchristmascard = this.sendchristmascard.getValue();
	      return person;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(person) {
	      this.id = person.values.id;
	      this.image.setValue(person.values.image);
	      this.lastname.setValue(person.values.lastname);
	      this.suffix.setValue(person.values.suffix);
	      this.maidenname.setValue(person.values.maidenname);
	      this.maidensuffix.setValue(person.values.maidensuffix);
	      this.forenames.setValue(person.values.forenames);
	      this.initials.setValue(person.values.initials);
	      this.nickname.setValue(person.values.nickname);
	      this.gender.setValue(person.values.gender);
	      this.nationality.setValue(person.values.nationality);
	      this.countryoforigin.setValue(person.values.countryoforigin);
	      this.religion.setValue(person.values.religion);
	      this.maritalstatus.setValue(person.values.maritalstatus);
	      this.dateofbirth.setValue(person.values.dateofbirth);
	      this.dateofdeath.setValue(person.values.dateofdeath);
	      this.address.setValue(person.values.address);
	      this.zipcode.setValue(person.values.zipcode);
	      this.city.setValue(person.values.city);
	      this.region.setValue(person.values.region);
	      this.country.setValue(person.values.country);
	      this.phone.setValue(person.values.phone);
	      this.mobile.setValue(person.values.mobile);
	      this.email.setValue(person.values.email);
	      this.linkedinid.setValue(person.values.linkedinid);
	      this.twitterid.setValue(person.values.twitterid);
	      this.facebookid.setValue(person.values.facebookid);
	      this.skypeid.setValue(person.values.skypeid);
	      this.sendbirthdayemail.setValue(person.values.sendbirthdayemail);
	      this.sendbirthdaycard.setValue(person.values.sendbirthdaycard);
	      this.sendchristmasemail.setValue(person.values.sendchristmasemail);
	      this.sendchristmascard.setValue(person.values.sendchristmascard);
	
	      this.calculateAge();
	    }
	  }]);
	
	  return PersonForm;
	}();
	
	exports.default = PersonForm;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = [{"value":"","label":"Onbekend"},{"value":"m","label":"Man"},{"value":"f","label":"Vrouw"}]

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = [{"value":"","label":"Onbekend"},{"value":"single","label":"Alleenstaand"},{"value":"married","label":"Gehuwd"},{"value":"cohabiting","label":"Samenwonend"},{"value":"unmarriedpartners","label":"Ongehuwdmetpartner"},{"value":"divorced","label":"Gescheiden"},{"value":"widowed","label":"Weduwenaar/Weduwe"}]

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = [{"value":"","label":"Onbekend"},{"value":"af","label":"Afghanistan"},{"value":"al","label":"Albanië"},{"value":"dz","label":"Algerije"},{"value":"as","label":"Amerikaans-Samoa"},{"value":"ad","label":"Andorra"},{"value":"ao","label":"Angola"},{"value":"ai","label":"Anguilla"},{"value":"aq","label":"Antarctica"},{"value":"ag","label":"Antigua en Barbuda"},{"value":"ar","label":"Argentinië"},{"value":"am","label":"Armenië"},{"value":"aw","label":"Aruba"},{"value":"au","label":"Australië"},{"value":"at","label":"Oostenrijk"},{"value":"az","label":"Azerbeidzjan"},{"value":"bs","label":"Bahama's"},{"value":"bh","label":"Bahrein"},{"value":"bd","label":"Bangladesh"},{"value":"bb","label":"Barbados"},{"value":"by","label":"Belarus; Wit-Rusland"},{"value":"be","label":"België"},{"value":"bz","label":"Belize"},{"value":"bj","label":"Benin"},{"value":"bm","label":"Bermuda"},{"value":"bt","label":"Bhutan"},{"value":"bo","label":"Bolivia"},{"value":"ba","label":"Bosnië en Herzegovina"},{"value":"bw","label":"Botswana"},{"value":"bv","label":"Bouveteiland"},{"value":"br","label":"Brazilië"},{"value":"io","label":"Brits Territorium in de Indische Oceaan"},{"value":"bn","label":"Brunei"},{"value":"bg","label":"Bulgarije"},{"value":"bf","label":"Burkina Faso"},{"value":"bi","label":"Burundi"},{"value":"kh","label":"Cambodja"},{"value":"cm","label":"Kameroen"},{"value":"ca","label":"Canada"},{"value":"cv","label":"Kaapverdië"},{"value":"ky","label":"Caymaneilanden"},{"value":"cf","label":"Centraal-Afrikaanse Republiek"},{"value":"td","label":"Tsjaad"},{"value":"cl","label":"Chili"},{"value":"cn","label":"China"},{"value":"cx","label":"Christmaseiland"},{"value":"cc","label":"Cocoseilanden"},{"value":"co","label":"Colombia"},{"value":"km","label":"Comoren"},{"value":"cg","label":"Congo"},{"value":"cd","label":"Democratische Republiek Congo"},{"value":"ck","label":"Cookeilanden"},{"value":"cr","label":"Costa Rica"},{"value":"ci","label":"Ivoorkust"},{"value":"hr","label":"Kroatië"},{"value":"cu","label":"Cuba"},{"value":"cy","label":"Cyprus"},{"value":"cz","label":"Tsjechië"},{"value":"dk","label":"Denemarken"},{"value":"dj","label":"Djibouti"},{"value":"dm","label":"Dominica"},{"value":"do","label":"Dominicaanse Republiek"},{"value":"tp","label":"TP"},{"value":"ec","label":"Ecuador"},{"value":"eg","label":"Egypte"},{"value":"sv","label":"El Salvador"},{"value":"gq","label":"Equatoriaal-Guinea"},{"value":"er","label":"Eritrea"},{"value":"ee","label":"Estland"},{"value":"et","label":"Ethiopië"},{"value":"fk","label":"Falklandeilanden"},{"value":"fo","label":"Faeröer"},{"value":"fj","label":"Fiji"},{"value":"fi","label":"Finland"},{"value":"fr","label":"Frankrijk"},{"value":"fx","label":"FX"},{"value":"gf","label":"Frans-Guyana"},{"value":"pf","label":"Frans-Polynesië"},{"value":"tf","label":"Franse Gebieden in de zuidelijke Indische Oceaan"},{"value":"ga","label":"Gabon"},{"value":"gm","label":"Gambia"},{"value":"ge","label":"Georgië"},{"value":"de","label":"Duitsland"},{"value":"gh","label":"Ghana"},{"value":"gi","label":"Gibraltar"},{"value":"gr","label":"Griekenland"},{"value":"gl","label":"Groenland"},{"value":"gd","label":"Grenada"},{"value":"gp","label":"Guadeloupe"},{"value":"gu","label":"Guam"},{"value":"gt","label":"Guatemala"},{"value":"gn","label":"Guinee"},{"value":"gw","label":"Guinee-Bissau"},{"value":"gy","label":"Guyana"},{"value":"ht","label":"Haïti"},{"value":"hm","label":"Heard- en McDonaldeilanden"},{"value":"va","label":"Vaticaanstad"},{"value":"hn","label":"Honduras"},{"value":"hk","label":"Hongkong"},{"value":"hu","label":"Hongarije"},{"value":"is","label":"IJsland"},{"value":"in","label":"India"},{"value":"id","label":"Indonesië"},{"value":"ir","label":"Iran"},{"value":"iq","label":"Irak"},{"value":"ie","label":"Ierland"},{"value":"il","label":"Israël"},{"value":"it","label":"Italië"},{"value":"jm","label":"Jamaica"},{"value":"jp","label":"Japan"},{"value":"jo","label":"Jordanië"},{"value":"kz","label":"Kazachstan"},{"value":"ke","label":"Kenia; Kenya"},{"value":"ki","label":"Kiribati"},{"value":"kp","label":"Noord-Korea"},{"value":"kr","label":"Zuid-Korea"},{"value":"kw","label":"Koeweit"},{"value":"kg","label":"Kirgizië; Kirgizstan"},{"value":"la","label":"Laos"},{"value":"lv","label":"Letland"},{"value":"lb","label":"Libanon"},{"value":"ls","label":"Lesotho"},{"value":"lr","label":"Liberia"},{"value":"ly","label":"Libië"},{"value":"li","label":"Liechtenstein"},{"value":"lt","label":"Litouwen"},{"value":"lu","label":"Luxemburg"},{"value":"mo","label":"Macau"},{"value":"mk","label":"Voormalige Joegoslavische Republiek Macedonië"},{"value":"mg","label":"Madagaskar"},{"value":"mw","label":"Malawi"},{"value":"my","label":"Maleisië"},{"value":"mv","label":"Maldiven"},{"value":"ml","label":"Mali"},{"value":"mt","label":"Malta"},{"value":"mh","label":"Marshalleilanden"},{"value":"mq","label":"Martinique"},{"value":"mr","label":"Mauritanië"},{"value":"mu","label":"Mauritius"},{"value":"yt","label":"Mayotte"},{"value":"mx","label":"Mexico"},{"value":"fm","label":"Micronesia"},{"value":"md","label":"Moldavië"},{"value":"mc","label":"Monaco"},{"value":"mn","label":"Mongolië"},{"value":"ms","label":"Montserrat"},{"value":"ma","label":"Marokko"},{"value":"mz","label":"Mozambique"},{"value":"mm","label":"Myanmar"},{"value":"na","label":"Namibië"},{"value":"nr","label":"Nauru"},{"value":"np","label":"Nepal"},{"value":"nl","label":"Nederland"},{"value":"an","label":"Nederlandse Antillen"},{"value":"nc","label":"Nieuw-Caledonië"},{"value":"nz","label":"Nieuw-Zeeland"},{"value":"ni","label":"Nicaragua"},{"value":"ne","label":"Niger"},{"value":"ng","label":"Nigeria"},{"value":"nu","label":"Niue"},{"value":"nf","label":"Norfolkeiland"},{"value":"mp","label":"Noordelijke Marianen"},{"value":"no","label":"Noorwegen"},{"value":"om","label":"Oman"},{"value":"pk","label":"Pakistan"},{"value":"pw","label":"Palau"},{"value":"ps","label":"PS"},{"value":"pa","label":"Panama"},{"value":"pg","label":"Papoea-Nieuw-Guinea"},{"value":"py","label":"Paraguay"},{"value":"pe","label":"Peru"},{"value":"ph","label":"Filipijnen"},{"value":"pn","label":"Pitcairneilanden"},{"value":"pl","label":"Polen"},{"value":"pt","label":"Portugal"},{"value":"pr","label":"Puerto Rico; Porto Rico"},{"value":"qa","label":"Qatar"},{"value":"re","label":"Réunion"},{"value":"ro","label":"Roemenië"},{"value":"ru","label":"Rusland"},{"value":"rw","label":"Rwanda"},{"value":"kn","label":"Saint Kitts en Nevis"},{"value":"lc","label":"Saint Lucia"},{"value":"vc","label":"Saint Vincent en de Grenadines"},{"value":"ws","label":"Samoa"},{"value":"sm","label":"San Marino"},{"value":"st","label":"Sao Tomé en Principe"},{"value":"sa","label":"Saudi-Arabië; Saoedi-Arabië"},{"value":"sn","label":"Senegal"},{"value":"sc","label":"Seychellen"},{"value":"sl","label":"Sierra Leone"},{"value":"sg","label":"Singapore"},{"value":"sk","label":"Slowakije; Slovakije"},{"value":"si","label":"Slovenië"},{"value":"sb","label":"Salomonseilanden"},{"value":"so","label":"Somalië"},{"value":"za","label":"Zuid-Afrika"},{"value":"gs","label":"Zuid-Georgië en Zuidelijke Sandwicheilanden"},{"value":"es","label":"Spanje"},{"value":"lk","label":"Sri Lanka"},{"value":"sh","label":"Sint-Helena"},{"value":"pm","label":"Saint-Pierre en Miquelon"},{"value":"sd","label":"Sudan; Soedan"},{"value":"sr","label":"Suriname"},{"value":"sj","label":"Svalbard en Jan Mayen"},{"value":"sz","label":"Swaziland"},{"value":"se","label":"Zweden"},{"value":"ch","label":"Zwitserland"},{"value":"sy","label":"Syrië"},{"value":"tw","label":"Taiwan"},{"value":"tj","label":"Tadzjikistan"},{"value":"tz","label":"Tanzania"},{"value":"th","label":"Thailand"},{"value":"tg","label":"Togo"},{"value":"tk","label":"Tokelau-eilanden"},{"value":"to","label":"Tonga"},{"value":"tt","label":"Trinidad en Tobago"},{"value":"tn","label":"Tunesië"},{"value":"tr","label":"Turkije"},{"value":"tm","label":"Turkmenistan"},{"value":"tc","label":"Turks- en Caicoseilanden"},{"value":"tv","label":"Tuvalu"},{"value":"ug","label":"Uganda; Oeganda"},{"value":"ua","label":"Oekraïne"},{"value":"ae","label":"Verenigde Arabische Emiraten"},{"value":"gb","label":"Verenigd Koninkrijk"},{"value":"us","label":"Verenigde Staten"},{"value":"um","label":"Amerikaanse ondergeschikte afgelegen eilanden"},{"value":"uy","label":"Uruguay"},{"value":"uz","label":"Oezbekistan"},{"value":"vu","label":"Vanuatu"},{"value":"ve","label":"Venezuela"},{"value":"vn","label":"Vietnam"},{"value":"vg","label":"Britse Maagdeneilanden"},{"value":"vi","label":"Amerikaanse Maagdeneilanden"},{"value":"wf","label":"Wallis en Futuna"},{"value":"eh","label":"Westelijke Sahara"},{"value":"ye","label":"Jemen"},{"value":"yu","label":"Joegoslavië"},{"value":"zm","label":"Zambia"},{"value":"zw","label":"Zimbabwe"}]

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ImageFrame = __webpack_require__(22);
	
	var _ImageFrame2 = _interopRequireDefault(_ImageFrame);
	
	var _ImagePlaceholderFrame = __webpack_require__(23);
	
	var _ImagePlaceholderFrame2 = _interopRequireDefault(_ImagePlaceholderFrame);
	
	var _SelectImage = __webpack_require__(37);
	
	var _SelectImage2 = _interopRequireDefault(_SelectImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImageSelectControl = function () {
	  function ImageSelectControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, ImageSelectControl);
	
	    var div = document.createElement('div');
	    var label = document.createElement('label');
	    label.innerHTML = args.label;
	    var popup = null;
	    this.value = args.image;
	    this.property = document.createElement('div');
	    this.property.className = 'contact';
	    this.property.onclick = function () {
	      if (args.readonly) {
	        return;
	      }
	      var popupElement = document.getElementById('popup');
	      var viewportElement = document.getElementById('viewport');
	
	      popup = new _SelectImage2.default(popupElement, {
	        onok: function onok(image) {
	          _this.setValue(image);
	          viewportElement.classList.remove('invisible');
	          popupElement.classList.add('invisible');
	          popupElement.innerHTML = '';
	
	          if (_this.onchange) {
	            _this.onchange();
	          }
	        },
	        oncancel: function oncancel() {
	          viewportElement.classList.remove('invisible');
	          popupElement.classList.add('invisible');
	          popupElement.innerHTML = '';
	        },
	        image: _this.value
	      });
	      viewportElement.classList.add('invisible');
	      popupElement.classList.remove('invisible');
	    };
	
	    this.image = undefined;
	    this.placeholder = undefined;
	    this.onchange = args.onchange;
	
	    if (this.value) {
	      this.image = new _ImageFrame2.default(this.property, {
	        image: this.value
	      });
	    } else {
	      this.placeholder = new _ImagePlaceholderFrame2.default(this.property, {
	        title: '?'
	      });
	    }
	
	    div.appendChild(label);
	    div.appendChild(this.property);
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    element.appendChild(fragment);
	  }
	
	  _createClass(ImageSelectControl, [{
	    key: 'getValue',
	    value: function getValue() {
	      return this.value;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(newImage) {
	      this.value = newImage;
	
	      if (!newImage) {
	        if (this.placeholder) {
	          this.placeholder.setTitle('?');
	        } else {
	          this.placeholder = new _ImagePlaceholderFrame2.default(null, { title: '?' });
	          this.property.insertBefore(this.placeholder.getElement(), this.property.childNodes[0]);
	        }
	
	        if (this.image) {
	          this.property.removeChild(this.image.getElement());
	          this.image = undefined;
	        }
	
	        return;
	      }
	
	      if (this.image) {
	        this.image.setImage(newImage);
	      } else {
	        this.image = new _ImageFrame2.default(null, { image: newImage });
	        this.property.insertBefore(this.image.getElement(), this.property.childNodes[0]);
	      }
	
	      if (this.placeholder) {
	        this.property.removeChild(this.placeholder.getElement());
	        this.placeholder = undefined;
	      }
	    }
	  }, {
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }]);
	
	  return ImageSelectControl;
	}();
	
	exports.default = ImageSelectControl;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ImagePickerControl = __webpack_require__(38);
	
	var _ImagePickerControl2 = _interopRequireDefault(_ImagePickerControl);
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectImage = function SelectImage(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, SelectImage);
	
	  var fragment = document.createDocumentFragment();
	
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Kies afbeelding',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        if (args.oncancel) {
	          window.removeEventListener('paste', _this.pasteHandler);
	          args.oncancel();
	        }
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        if (args.onok) {
	          window.removeEventListener('paste', _this.pasteHandler);
	          args.onok(_this.results.getImage());
	        }
	      },
	      icon: '\uE11E'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        if (_this.select) {
	          _this.select();
	        }
	      },
	      icon: '\uE08D',
	      label: 'Kies afbeelding'
	    },
	    /*{
	        onclick: () => {
	            if (this.rotate) {
	                this.rotate()
	            }
	        },
	        icon: '\ue0da',
	        label: 'Afbeelding draaien'
	    },*/
	    {
	      onclick: function onclick() {
	        if (_this.clear) {
	          _this.clear();
	        }
	      },
	      icon: '\uE03D',
	      label: 'Geen afbeelding'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport composer';
	
	  this.results = new _ImagePickerControl2.default(div, { image: args.image });
	  fragment.appendChild(div);
	
	  this.select = this.results.onselect.bind(this.results);
	  //this.rotate = this.results.onrotate.bind(this.results)
	  this.clear = this.results.clearImage.bind(this.results);
	  this.pasteHandler = this.results.pasteHandler.bind(this.results);
	
	  window.addEventListener('paste', this.pasteHandler);
	
	  element.appendChild(fragment);
	};
	
	exports.default = SelectImage;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CanvasContext = function CanvasContext() {
	  _classCallCheck(this, CanvasContext);
	
	  this.x = 0;
	  this.y = 0;
	  this.width = 128;
	  this.height = 128;
	  this.scale = 1;
	  this.rotation = 0;
	};
	
	var CanvasBuffer = function () {
	  function CanvasBuffer(element, args) {
	    _classCallCheck(this, CanvasBuffer);
	
	    var fragment = document.createDocumentFragment();
	
	    this.image = args.image ? args.image : null;
	
	    this.canvas = document.createElement('canvas');
	    this.canvas.width = 128;
	    this.canvas.height = 128;
	
	    this.context = null;
	
	    fragment.appendChild(this.canvas);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(CanvasBuffer, [{
	    key: 'getImage',
	    value: function getImage() {
	      return this.image;
	    }
	  }, {
	    key: 'clearImage',
	    value: function clearImage() {
	      this.context = new CanvasContext();
	
	      var graphicsContext = this.canvas.getContext('2d');
	
	      graphicsContext.fillStyle = '#fff';
	      graphicsContext.fillRect(0, 0, this.canvas.width, this.canvas.height);
	
	      this.image = null;
	    }
	  }, {
	    key: 'setImage',
	    value: function setImage(imageElement) {
	      this.context = new CanvasContext();
	
	      var s = imageElement.width > imageElement.height ? imageElement.width / imageElement.height : imageElement.height / imageElement.width;
	      this.context.width = imageElement.width < imageElement.height ? imageElement.width * s : imageElement.height * s;
	      this.context.height = this.context.width;
	      this.context.x = imageElement.width / 2 - this.context.width / 2;
	      this.context.y = imageElement.height / 2 - this.context.height / 2;
	
	      this.renderImage(imageElement);
	
	      this.image = this.canvas.toDataURL('image/jpeg', 0.9);
	    }
	  }, {
	    key: 'rotateImage',
	    value: function rotateImage(imageElement) {
	      this.context.rotation = (this.context.rotation + Math.PI / 2) % (Math.PI * 2);
	      this.renderImage(imageElement);
	
	      this.image = this.canvas.toDataURL('image/jpeg', 0.9);
	    }
	  }, {
	    key: 'renderImage',
	    value: function renderImage(img) {
	      var graphicsContext = this.canvas.getContext('2d');
	
	      graphicsContext.fillStyle = '#fff';
	      graphicsContext.fillRect(0, 0, this.canvas.width, this.canvas.height);
	      graphicsContext.translate(this.canvas.width / 2, this.canvas.height / 2);
	      graphicsContext.rotate(this.context.rotation);
	      graphicsContext.translate(-this.canvas.width / 2, -this.canvas.height / 2);
	      graphicsContext.drawImage(img, this.context.x, this.context.y, this.context.width, this.context.height, 0, 0, this.canvas.width, this.canvas.height);
	      graphicsContext.setTransform(1, 0, 0, 1, 0, 0);
	    }
	  }]);
	
	  return CanvasBuffer;
	}();
	
	var ImagePickerControl = function () {
	  function ImagePickerControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, ImagePickerControl);
	
	    this.element = element;
	    var fragment = document.createDocumentFragment();
	    this.image = args.image ? args.image : null;
	    this.img = null;
	
	    var dropHandler = function dropHandler(event) {
	      event.preventDefault();
	      if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
	        var result = null;
	        var url = null;
	
	        for (var i = 0; i < event.dataTransfer.items.length; i++) {
	          if (event.dataTransfer.items[i].type.indexOf('image/') === 0) {
	            result = event.dataTransfer.items[i];
	            break;
	          }
	
	          if (!url && event.dataTransfer.items[i].type === 'text/plain') {
	            url = event.dataTransfer.items[i];
	          }
	        }
	
	        if (result) {
	          _this.setImage(URL.createObjectURL(result.getAsFile()));
	        } else if (url) {
	          url.getAsString(function (s) {
	            _this.setImage(s);
	          });
	        }
	      }
	    };
	
	    var dragoverHandler = function dragoverHandler(event) {
	      event.preventDefault();
	    };
	
	    var filePickerChanged = function filePickerChanged(event) {
	      if (event.target.files && event.target.files.length > 0) {
	        _this.setImage(URL.createObjectURL(event.target.files[0]));
	      }
	    };
	
	    this.filePicker = document.createElement('input');
	    this.filePicker.type = 'file';
	    this.filePicker.accept = 'image/*';
	    this.filePicker.className = 'invisible';
	    this.filePicker.onchange = filePickerChanged;
	
	    this.canvas = new CanvasBuffer(fragment, {});
	
	    this.imageLoaded = function () {
	      _this.canvas.setImage(_this.img);
	      _this.image = _this.canvas.getImage();
	    };
	
	    this.imageFailed = function () {
	      if (_this.img) {
	        _this.element.removeChild(_this.img);
	      }
	
	      _this.img = null;
	      alert('Kon afbeelding niet laden. Kies een andere of probeer opnieuw.');
	    };
	
	    if (this.image) {
	      this.img = document.createElement('img');
	      this.img.src = this.image;
	      this.img.className = 'invisible';
	      this.img.crossOrigin = 'anonymous';
	      this.img.onload = this.imageLoaded;
	      this.img.onerror = this.imageFailed;
	
	      fragment.appendChild(this.img);
	    }
	
	    this.element.ondrop = dropHandler;
	    this.element.ondragover = dragoverHandler;
	
	    this.element.appendChild(fragment);
	  }
	
	  _createClass(ImagePickerControl, [{
	    key: 'getImage',
	    value: function getImage() {
	      return this.image;
	    }
	  }, {
	    key: 'setImage',
	    value: function setImage(newImage) {
	      if (this.img) {
	        if (this.img.src) {
	          URL.revokeObjectURL(this.img.src);
	        }
	
	        this.element.removeChild(this.img);
	        this.img = null;
	      }
	
	      this.img = document.createElement('img');
	      this.img.src = newImage;
	      this.img.className = 'invisible';
	      this.img.crossOrigin = 'anonymous';
	      this.img.onload = this.imageLoaded;
	      this.img.onerror = this.imageFailed;
	
	      this.element.appendChild(this.img);
	    }
	  }, {
	    key: 'rotateImage',
	    value: function rotateImage() {
	      if (this.img) {
	        this.canvas.rotateImage(this.img);
	      }
	    }
	  }, {
	    key: 'clearImage',
	    value: function clearImage() {
	      if (this.img) {
	        if (this.img.src) {
	          URL.revokeObjectURL(this.img.src);
	        }
	
	        this.element.removeChild(this.img);
	        this.img = null;
	      }
	
	      this.image = null;
	      this.canvas.clearImage();
	    }
	  }, {
	    key: 'onselect',
	    value: function onselect() {
	      this.filePicker.click();
	    }
	  }, {
	    key: 'pasteHandler',
	    value: function pasteHandler(event) {
	      event.preventDefault();
	      if (event.clipboardData.items && event.clipboardData.items.length > 0) {
	        var result = null;
	
	        for (var i = 0; i < event.clipboardData.items.length; i++) {
	          if (event.clipboardData.items[i].type.indexOf('image/') === 0) {
	            result = event.clipboardData.items[i];
	            break;
	          }
	        }
	
	        if (result) {
	          this.setImage(URL.createObjectURL(result.getAsFile()));
	        }
	      }
	    }
	  }]);
	
	  return ImagePickerControl;
	}();
	
	exports.default = ImagePickerControl;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextControl = function () {
	  function TextControl(element, args) {
	    _classCallCheck(this, TextControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.input.value = args.value ? args.value : '';
	    this.input.type = 'text';
	    this.input.autocapitalize = 'sentences';
	    this.input.autocorrect = 'on';
	    this.input.spellcheck = 'true';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	
	    if (args.datalist) {
	      this.input.setAttribute('list', args.datalist.getId());
	    }
	
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(TextControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value;
	    }
	  }]);
	
	  return TextControl;
	}();
	
	exports.default = TextControl;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectControl = function () {
	  function SelectControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, SelectControl);
	
	    var div = document.createElement('div');
	    this.select = document.createElement('select');
	    this.select.id = window.PRIM.getUUID();
	    this.select.disabled = args.readonly ? 'disabled' : '';
	    this.select.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.select.id;
	
	    if (args.options) {
	      args.options.forEach(function (optionItem) {
	        var option = document.createElement('option');
	        option.innerHTML = optionItem.label;
	        option.value = optionItem.value;
	        _this.select.appendChild(option);
	      });
	    }
	
	    this.select.value = args.value ? args.value : '';
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.select);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(SelectControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.select.value ? this.select.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.select.value = value ? value : '';
	    }
	  }]);
	
	  return SelectControl;
	}();
	
	exports.default = SelectControl;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DateControl = function () {
	  function DateControl(element, args) {
	    _classCallCheck(this, DateControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.setValue(args.value);
	    this.input.type = 'date';
	    this.input.placeholder = 'jjjj-mm-dd';
	    this.input.pattern = '\d{4}(-\d{2}(-\d{2}?)?)?';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(DateControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? new Date(this.input.value) : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value ? window.PRIM.getUtcTimestamp(new Date(value)).toISOString().substring(0, 10) : '';
	    }
	  }]);
	
	  return DateControl;
	}();
	
	exports.default = DateControl;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PhonenumberControl = function () {
	  function PhonenumberControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, PhonenumberControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.input.value = args.value ? args.value : '';
	    this.input.type = 'tel';
	    this.input.autocapitalize = 'off';
	    this.input.autocorrect = 'off';
	    this.input.spellcheck = 'false';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var onclick = function onclick() {
	      if (_this.input.value) {
	        var parsedPhonenumber = _this.input.value.trim().replace(/ *\([^)]*\) */g, '').replace(/[^+0-9.]/g, '');
	
	        if (parsedPhonenumber) {
	          if (parsedPhonenumber.length < 4) {
	            alert('Telefoonummers korter dan 4 cijfers zijn zeer waarschijnlijk noodnummers. U kunt geen noodnummers bellen vanuit deze applicatie.');
	            return;
	          }
	
	          location.href = 'tel:' + parsedPhonenumber;
	        }
	      }
	    };
	
	    var button = document.createElement('button');
	    button.className = 'icon';
	    button.innerHTML = '\uE0C5';
	    button.onclick = onclick;
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	    div.appendChild(button);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(PhonenumberControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value;
	    }
	  }]);
	
	  return PhonenumberControl;
	}();
	
	exports.default = PhonenumberControl;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EmailControl = function () {
	  function EmailControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, EmailControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.input.value = args.value ? args.value : '';
	    this.input.type = 'email';
	    this.input.autocapitalize = 'off';
	    this.input.autocorrect = 'off';
	    this.input.spellcheck = 'false';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var onclick = function onclick() {
	      if (_this.input.value) {
	        var parsedEmailaddress = _this.input.value.trim();
	        if (parsedEmailaddress) {
	          location.href = 'mailto:' + parsedEmailaddress;
	        }
	      }
	    };
	
	    var button = document.createElement('button');
	    button.className = 'icon';
	    button.innerHTML = '\uE0A5';
	    button.onclick = onclick;
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	    div.appendChild(button);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(EmailControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value;
	    }
	  }]);
	
	  return EmailControl;
	}();
	
	exports.default = EmailControl;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LinkedinControl = function () {
	  function LinkedinControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, LinkedinControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.value = args.value ? args.value : '';
	    this.input.id = window.PRIM.getUUID();
	    this.input.type = 'text';
	    this.input.autocapitalize = 'off';
	    this.input.autocorrect = 'off';
	    this.input.spellcheck = 'false';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var onclick = function onclick() {
	      if (_this.input.value) {
	        var parsedUsername = _this.input.value.trim();
	        if (parsedUsername) {
	          open('https://www.linkedin.com/in/' + parsedUsername);
	        }
	      }
	    };
	
	    this.button = document.createElement('button');
	    this.button.className = 'icon';
	    this.button.onclick = onclick;
	    this.button.innerHTML = '\uE0F1';
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	    div.appendChild(this.button);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(LinkedinControl, [{
	    key: 'click',
	    value: function click() {
	      this.button.click();
	    }
	  }, {
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value ? value : '';
	    }
	  }]);
	
	  return LinkedinControl;
	}();
	
	exports.default = LinkedinControl;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FacebookControl = function () {
	  function FacebookControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, FacebookControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.value = args.value ? args.value : '';
	    this.input.id = window.PRIM.getUUID();
	    this.input.type = 'text';
	    this.input.autocapitalize = 'off';
	    this.input.autocorrect = 'off';
	    this.input.spellcheck = 'false';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var onclick = function onclick() {
	      if (_this.input.value) {
	        var parsedUsername = _this.input.value.trim();
	        if (parsedUsername) {
	          open('https://www.facebook.com/' + parsedUsername);
	        }
	      }
	    };
	
	    this.button = document.createElement('button');
	    this.button.className = 'icon';
	    this.button.onclick = onclick;
	    this.button.innerHTML = '\uE0E5';
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	    div.appendChild(this.button);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(FacebookControl, [{
	    key: 'click',
	    value: function click() {
	      this.button.click();
	    }
	  }, {
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value ? value : '';
	    }
	  }]);
	
	  return FacebookControl;
	}();
	
	exports.default = FacebookControl;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SkypeControl = function () {
	  function SkypeControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, SkypeControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.value = args.value ? args.value : '';
	    this.input.id = window.PRIM.getUUID();
	    this.input.type = 'text';
	    this.input.autocapitalize = 'off';
	    this.input.autocorrect = 'off';
	    this.input.spellcheck = 'false';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var onclick = function onclick() {
	      if (_this.input.value) {
	        var parsedUsername = _this.input.value.trim();
	        if (parsedUsername) {
	          location.href = 'skype:' + parsedUsername + '?call';
	        }
	      }
	    };
	
	    this.button = document.createElement('button');
	    this.button.className = 'icon';
	    this.button.onclick = onclick;
	    this.button.innerHTML = '\uE0F5';
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	    div.appendChild(this.button);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(SkypeControl, [{
	    key: 'click',
	    value: function click() {
	      this.button.click();
	    }
	  }, {
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value ? value : '';
	    }
	  }]);
	
	  return SkypeControl;
	}();
	
	exports.default = SkypeControl;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TwitterControl = function () {
	  function TwitterControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, TwitterControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.value = args.value ? args.value : '';
	    this.input.id = window.PRIM.getUUID();
	    this.input.type = 'text';
	    this.input.autocapitalize = 'off';
	    this.input.autocorrect = 'off';
	    this.input.spellcheck = 'false';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var onclick = function onclick() {
	      if (_this.input.value) {
	        var parsedUsername = _this.input.value.trim();
	        if (parsedUsername) {
	          open('https://twitter.com/' + parsedUsername);
	        }
	      }
	    };
	
	    this.button = document.createElement('button');
	    this.button.className = 'icon';
	    this.button.onclick = onclick;
	    this.button.innerHTML = '\uE0F9';
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	    div.appendChild(this.button);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(TwitterControl, [{
	    key: 'click',
	    value: function click() {
	      this.button.click();
	    }
	  }, {
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value ? value : '';
	    }
	  }]);
	
	  return TwitterControl;
	}();
	
	exports.default = TwitterControl;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GoogleMapsButtonControl = function GoogleMapsButtonControl(element, args) {
	  _classCallCheck(this, GoogleMapsButtonControl);
	
	  var onclick = function onclick() {
	    if (!args.getValues) {
	      return;
	    }
	
	    var values = args.getValues();
	    var data = values.filter(function (value) {
	      return value && value.trim && value.trim() !== '';
	    });
	
	    if (args.getValues().length === 0) {
	      return;
	    }
	
	    var locationString = data.join(', ');
	
	    if (locationString) {
	      open('//maps.google.com/?q=' + encodeURIComponent(locationString));
	    } else {
	      alert('Vul een geldig adres in.');
	    }
	  };
	
	  var button = document.createElement('button');
	  button.className = 'icon';
	  button.innerHTML = '\uE0A6';
	  button.onclick = onclick;
	  var fragment = document.createDocumentFragment();
	  fragment.appendChild(button);
	
	  element.appendChild(fragment);
	};
	
	exports.default = GoogleMapsButtonControl;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = {"person":0,"position":1,"location":2,"department":3,"organisation":4,"education":5}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CountryOptions = __webpack_require__(35);
	
	var _CountryOptions2 = _interopRequireDefault(_CountryOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VcardExporter = function () {
	  function VcardExporter() {
	    _classCallCheck(this, VcardExporter);
	  }
	
	  _createClass(VcardExporter, [{
	    key: 'header',
	    value: function header() {
	      var result = this.line(['BEGIN'], ['VCARD']);
	      result += this.line(['VERSION'], ['2.1']);
	
	      return result;
	    }
	  }, {
	    key: 'footer',
	    value: function footer() {
	      var result = this.line(['REV'], [this.date()]);
	      result += this.line(['END'], ['VCARD']);
	
	      return result;
	    }
	  }, {
	    key: 'date',
	    value: function date() {
	      return new Date().toISOString().replace(/[-:]/g, '').substring(0, 15) + 'Z';
	    }
	  }, {
	    key: 'collection',
	    value: function collection(items) {
	      return items.join(';');
	    }
	  }, {
	    key: 'line',
	    value: function line(field, value) {
	      return this.collection(field) + ':' + this.collection(value) + '\r\n';
	    }
	  }, {
	    key: 'export',
	    value: function _export(model) {
	      var countries = _CountryOptions2.default.filter(function (option) {
	        return option.value === model.values.country;
	      });
	      var country = countries ? countries[0] : null;
	
	      var result = this.header();
	
	      result += this.line(['N'], [[model.values.lastname, model.values.suffix].join(' '), model.values.forenames, '', '', model.values.nickname]);
	      result += this.line(['FN'], [model.getTitle()]);
	      // result += this.line(['PHOTO', 'ENCODING=b', 'TYPE=JPEG'], [ model.getImage() ])
	      result += this.line(['TEL', 'HOME', 'VOICE'], [model.values.phone]);
	      result += this.line(['TEL', 'HOME', 'CELL'], [model.values.mobile]);
	      result += this.line(['ADR', 'HOME'], ['', model.values.address, '', model.values.city, model.values.region, model.values.zipcode, country ? country.label : '']);
	      result += this.line(['EMAIL'], [model.values.email]);
	
	      result += this.footer();
	
	      return result;
	    }
	  }]);
	
	  return VcardExporter;
	}();
	
	exports.default = VcardExporter;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _IndexControl = __webpack_require__(21);
	
	var _IndexControl2 = _interopRequireDefault(_IndexControl);
	
	var _PositionForm = __webpack_require__(52);
	
	var _PositionForm2 = _interopRequireDefault(_PositionForm);
	
	var _PositionModel = __webpack_require__(7);
	
	var _PositionModel2 = _interopRequireDefault(_PositionModel);
	
	var _LogentryModel = __webpack_require__(10);
	
	var _LogentryModel2 = _interopRequireDefault(_LogentryModel);
	
	var _ObjectTypeMapping = __webpack_require__(49);
	
	var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditPosition = function EditPosition(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, EditPosition);
	
	  this.onchange = function () {
	    _this.data = _this.positionForm.getValue();
	    window.PRIM.initDelayedNavigation();
	    window.PRIM.dataAccess.put('positions', _this.data.getJSON()).then(function (position) {
	      if (!window.PRIM.isDelayedNavigationActive()) {
	        return;
	      }
	
	      if (args && !args.id && position.id) {
	        window.PRIM.navigate('/positions/' + position.id, true);
	      }
	
	      if (position) {
	        _this.data.values.id = position.id;
	        _this.positionForm.setValue(_this.data);
	      }
	    });
	  };
	
	  if (args) {
	    if (args.id) {
	      window.PRIM.dataAccess.resolve('positions', args.id, true).then(function (position) {
	        _this.data = position;
	
	        window.PRIM.dataAccess.get('logentries').then(function (logentries) {
	          var results = logentries.filter(function (logentry) {
	            return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.position;
	          });
	
	          _this.data.logentries = results.map(function (logentry) {
	            return new _LogentryModel2.default(logentry);
	          });
	
	          _this.logIndex.setItems(_this.data.logentries);
	          _this.positionForm.setValue(_this.data);
	        }, function () {
	          _this.positionForm.setValue(_this.data);
	        }).catch(function () {});
	      }, function () {
	        if (confirm('Deze functie bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe functie aanmaken?')) {
	          window.PRIM.navigate('/positions/');
	        } else {
	          history.back();
	        }
	      }).catch(function () {});
	    } else if (args.person_id) {
	      window.PRIM.dataAccess.resolve('people', args.person_id, true).then(function (person) {
	        _this.data = new _PositionModel2.default();
	        _this.data.values.person_id = person.values.id;
	        _this.data.person = person;
	        _this.positionForm.setValue(_this.data);
	      });
	    } else if (args.location_id) {
	      window.PRIM.dataAccess.resolve('locations', args.location_id, true).then(function (location) {
	        _this.data = new _PositionModel2.default();
	        _this.data.values.location_id = location.values.id;
	        _this.data.location = location;
	        _this.positionForm.setValue(_this.data);
	      });
	    }
	  }
	
	  this.data = new _PositionModel2.default();
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Functie bewerken',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }, {
	      onclick: this.onchange,
	      icon: '\uE020',
	      classes: 'indicator'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          window.PRIM.navigate('/logentries/position/' + _this.data.values.id);
	        } else {
	          alert('Vul eerst gegevens voor deze functie.');
	        }
	      },
	      icon: '\uE032',
	      label: 'Logboekregel'
	    }, {
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          if (confirm('Weet u het zeker dat u deze functie wilt verwijderen?')) {
	            window.PRIM.dataAccess.delete('positions', _this.data.values.id).then(function () {
	              history.back();
	            });
	          }
	        } else {
	          alert('Vul eerst gegevens voor deze functie.');
	        }
	      },
	      icon: '\uE123',
	      label: 'Verwijderen'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var divContent = document.createElement('div');
	  divContent.className = 'content';
	
	  var primaryData = document.createElement('section');
	  primaryData.className = 'primary';
	  var secondaryData = document.createElement('section');
	  secondaryData.className = 'secondary';
	
	  this.positionForm = new _PositionForm2.default(primaryData, { position: this.data, onchange: this.onchange });
	
	  var fieldsetLog = document.createElement('fieldset');
	  var legendLog = document.createElement('legend');
	  legendLog.innerHTML = 'Logboek';
	  fieldsetLog.appendChild(legendLog);
	
	  var onclickLogentry = function onclickLogentry(item) {
	    window.PRIM.navigate('/logentries/' + item.values.id);
	    return;
	  };
	
	  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });
	
	  secondaryData.appendChild(fieldsetLog);
	
	  divContent.appendChild(primaryData);
	  divContent.appendChild(secondaryData);
	  div.appendChild(divContent);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = EditPosition;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _PositionModel = __webpack_require__(7);
	
	var _PositionModel2 = _interopRequireDefault(_PositionModel);
	
	var _TextControl = __webpack_require__(39);
	
	var _TextControl2 = _interopRequireDefault(_TextControl);
	
	var _PickerControl = __webpack_require__(53);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	var _SelectPerson = __webpack_require__(54);
	
	var _SelectPerson2 = _interopRequireDefault(_SelectPerson);
	
	var _SelectLocation = __webpack_require__(55);
	
	var _SelectLocation2 = _interopRequireDefault(_SelectLocation);
	
	var _PhonenumberControl = __webpack_require__(42);
	
	var _PhonenumberControl2 = _interopRequireDefault(_PhonenumberControl);
	
	var _FaxnumberControl = __webpack_require__(56);
	
	var _FaxnumberControl2 = _interopRequireDefault(_FaxnumberControl);
	
	var _EmailControl = __webpack_require__(43);
	
	var _EmailControl2 = _interopRequireDefault(_EmailControl);
	
	var _CheckboxControl = __webpack_require__(26);
	
	var _CheckboxControl2 = _interopRequireDefault(_CheckboxControl);
	
	var _DateControl = __webpack_require__(41);
	
	var _DateControl2 = _interopRequireDefault(_DateControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PositionForm = function () {
	  function PositionForm(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, PositionForm);
	
	    var fieldsetPosition = document.createElement('fieldset');
	    var legendPosition = document.createElement('legend');
	    legendPosition.innerHTML = 'Functie';
	    fieldsetPosition.appendChild(legendPosition);
	    var popup = null;
	
	    this.id = args.position.values.id;
	    this.person = new _PickerControl2.default(fieldsetPosition, { label: 'Persoon', value: args.position.values.person_id,
	      onchange: args.onchange,
	      onselect: function onselect(item) {
	        if (item.values.id) {
	          window.PRIM.navigate('/people/' + item.values.id);
	        }
	      },
	      onclick: function onclick() {
	        var popupElement = document.getElementById('popup');
	        var viewportElement = document.getElementById('viewport');
	
	        popup = new _SelectPerson2.default(popupElement, {
	          onok: function onok(item) {
	            if (item && item.values.id) {
	              _this.person.setValue(item.values.id, item);
	            } else {
	              _this.person.setValue(null, null);
	            }
	
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	            _this.person.onchange();
	          },
	          oncancel: function oncancel() {
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	          }
	        });
	        viewportElement.classList.add('invisible');
	        popupElement.classList.remove('invisible');
	      }
	    });
	    this.location = new _PickerControl2.default(fieldsetPosition, { label: 'Vestiging', value: args.position.values.location_id,
	      onchange: args.onchange,
	      onselect: function onselect(item) {
	        if (item.values.id) {
	          window.PRIM.navigate('/locations/' + item.values.id);
	        }
	      },
	      onclick: function onclick() {
	        var popupElement = document.getElementById('popup');
	        var viewportElement = document.getElementById('viewport');
	
	        popup = new _SelectLocation2.default(popupElement, {
	          onok: function onok(item) {
	            if (item && item.values.id) {
	              _this.location.setValue(item.values.id, item);
	            } else {
	              _this.location.setValue(null, null);
	            }
	
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	            _this.person.onchange();
	          },
	          oncancel: function oncancel() {
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	          }
	        });
	        viewportElement.classList.add('invisible');
	        popupElement.classList.remove('invisible');
	      }
	    });
	    this.title = new _TextControl2.default(fieldsetPosition, { label: 'Titel', value: args.position.values.title, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	    this.department = new _TextControl2.default(fieldsetPosition, { label: 'Afdeling', value: args.position.values.department, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	    this.start = new _DateControl2.default(fieldsetPosition, { label: 'Start', value: args.position.values.start, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	    this.end = new _DateControl2.default(fieldsetPosition, { label: 'Einde', value: args.position.values.end, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	
	    var fieldsetContact = document.createElement('fieldset');
	    var legendContact = document.createElement('legend');
	    legendContact.innerHTML = 'Contact gegevens';
	    fieldsetContact.appendChild(legendContact);
	
	    this.phone = new _PhonenumberControl2.default(fieldsetContact, { label: 'Telefoon', value: args.position.values.phone, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	    this.mobile = new _PhonenumberControl2.default(fieldsetContact, { label: 'Mobiel', value: args.position.values.mobile, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	    this.fax = new _FaxnumberControl2.default(fieldsetContact, { label: 'Fax', value: args.position.values.fax, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	    this.email = new _EmailControl2.default(fieldsetContact, { label: 'E-mail', value: args.position.values.email, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	
	    var fieldsetOptions = document.createElement('fieldset');
	    var legendOptions = document.createElement('legend');
	    legendOptions.innerHTML = 'Opties';
	    fieldsetOptions.appendChild(legendOptions);
	
	    this.sendchristmasemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per e-mail', value: args.position.values.sendchristmasemail, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	    this.sendchristmascard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per post', value: args.position.values.sendchristmascard, readonly: window.PRIM.hasReadonlyModuleAccess('positions'), onchange: args.onchange });
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(fieldsetPosition);
	    fragment.appendChild(fieldsetContact);
	    fragment.appendChild(fieldsetOptions);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(PositionForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      var position = new _PositionModel2.default();
	      position.person = this.person.getItem();
	      position.location = this.location.getItem();
	      position.values.id = this.id;
	      position.values.person_id = this.person.getValue();
	      position.values.location_id = this.location.getValue();
	      position.values.title = this.title.getValue();
	      position.values.department = this.department.getValue();
	      position.values.start = this.start.getValue();
	      position.values.end = this.end.getValue();
	      position.values.phone = this.phone.getValue();
	      position.values.mobile = this.mobile.getValue();
	      position.values.fax = this.fax.getValue();
	      position.values.email = this.email.getValue();
	      position.values.sendchristmasemail = this.sendchristmasemail.getValue();
	      position.values.sendchristmascard = this.sendchristmascard.getValue();
	      return position;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(position) {
	      this.id = position.values.id;
	      this.person.setValue(position.values.person_id, position.person);
	      this.location.setValue(position.values.location_id, position.location);
	      this.title.setValue(position.values.title);
	      this.department.setValue(position.values.department);
	      this.start.setValue(position.values.start);
	      this.end.setValue(position.values.end);
	      this.phone.setValue(position.values.phone);
	      this.mobile.setValue(position.values.mobile);
	      this.fax.setValue(position.values.fax);
	      this.email.setValue(position.values.email);
	      this.sendchristmasemail.setValue(position.values.sendchristmasemail);
	      this.sendchristmascard.setValue(position.values.sendchristmascard);
	    }
	  }]);
	
	  return PositionForm;
	}();
	
	exports.default = PositionForm;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ImageFrame = __webpack_require__(22);
	
	var _ImageFrame2 = _interopRequireDefault(_ImageFrame);
	
	var _ImagePlaceholderFrame = __webpack_require__(23);
	
	var _ImagePlaceholderFrame2 = _interopRequireDefault(_ImagePlaceholderFrame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PickerControl = function () {
	  function PickerControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, PickerControl);
	
	    var div = document.createElement('div');
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.property = document.createElement('div');
	    this.property.className = 'contact';
	    this.property.onclick = args.readonly ? null : args.onclick;
	    this.value = args.value;
	    this.item = args.item;
	    this.image = undefined;
	    this.placeholder = undefined;
	    this.onchange = args.onchange;
	
	    if (this.item && this.item.getImage()) {
	      this.image = new _ImageFrame2.default(this.property, {
	        image: this.item.getImage()
	      });
	    } else {
	      this.placeholder = new _ImagePlaceholderFrame2.default(this.property, {
	        title: this.item ? this.item.getTitle() : null
	      });
	    }
	
	    var dl = document.createElement('dl');
	    this.dt = document.createElement('dt');
	    this.dt.innerHTML = this.item ? this.item.getTitle() : 'Onbekend';
	    this.dd = document.createElement('dd');
	    this.dd.innerHTML = this.item ? this.item.getSubtitle() : '';
	
	    dl.appendChild(this.dt);
	    dl.appendChild(this.dd);
	    this.property.appendChild(dl);
	
	    var button = document.createElement('button');
	    button.className = 'icon';
	    button.innerHTML = '\uE06D';
	    button.onclick = function () {
	      if (args.onselect) {
	        args.onselect(_this.item);
	      }
	    };
	
	    div.appendChild(this.label);
	    div.appendChild(this.property);
	    div.appendChild(button);
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(PickerControl, [{
	    key: 'getTitle',
	    value: function getTitle() {
	      return this.dt.innerHTML;
	    }
	  }, {
	    key: 'setTitle',
	    value: function setTitle(text) {
	      this.dt.innerHTML = text;
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage() {
	      if (this.image) {
	        return this.image.getImage();
	      }
	    }
	  }, {
	    key: 'setImage',
	    value: function setImage(newImage) {
	      if (!newImage) {
	        if (this.placeholder) {
	          this.placeholder.setTitle(this.item ? this.item.getTitle() : null);
	        } else {
	          this.placeholder = new _ImagePlaceholderFrame2.default(null, { title: this.item ? this.item.getTitle() : null });
	          this.property.insertBefore(this.placeholder.getElement(), this.property.childNodes[0]);
	        }
	
	        if (this.image) {
	          this.property.removeChild(this.image.getElement());
	          this.image = undefined;
	        }
	
	        return;
	      }
	
	      if (this.image) {
	        this.image.setImage(newImage);
	      } else {
	        this.image = new _ImageFrame2.default(null, { image: newImage });
	        this.property.insertBefore(this.image.getElement(), this.property.childNodes[0]);
	      }
	
	      if (this.placeholder) {
	        this.property.removeChild(this.placeholder.getElement());
	        this.placeholder = undefined;
	      }
	    }
	  }, {
	    key: 'getSubtitle',
	    value: function getSubtitle() {
	      return this.dd.innerHTML;
	    }
	  }, {
	    key: 'setSubtitle',
	    value: function setSubtitle(text) {
	      this.dd.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.value;
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      return this.item;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(newValue, newItem) {
	      this.value = newValue;
	      this.item = newItem;
	      this.setImage(this.item && this.item.getImage ? this.item.getImage() : null);
	      this.setTitle(this.item && this.item.getTitle ? this.item.getTitle() : 'Onbekend');
	      this.setSubtitle(this.item && this.item.getSubtitle ? this.item.getSubtitle() : '');
	    }
	  }, {
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }]);
	
	  return PickerControl;
	}();
	
	exports.default = PickerControl;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _IndexControl = __webpack_require__(21);
	
	var _IndexControl2 = _interopRequireDefault(_IndexControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectPerson = function SelectPerson(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, SelectPerson);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Kies persoon',
	    leftHandButtons: [{
	      onclick: args.oncancel,
	      icon: '\uE00D'
	    }, {
	      onclick: args.onok,
	      icon: '\uE03D',
	      label: 'Geen selectie'
	    }]
	  });
	
	  window.PRIM.dataAccess.resolve('people', null, true).then(function (items) {
	    _this.results.setItems(items);
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  this.results = new _IndexControl2.default(div, { items: [], onclick: args.onok });
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = SelectPerson;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _IndexControl = __webpack_require__(21);
	
	var _IndexControl2 = _interopRequireDefault(_IndexControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectLocation = function SelectLocation(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, SelectLocation);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Kies vestiging',
	    leftHandButtons: [{
	      onclick: args.oncancel,
	      icon: '\uE00D'
	    }, {
	      onclick: args.onok,
	      icon: '\uE03D',
	      label: 'Geen selectie'
	    }]
	  });
	
	  window.PRIM.dataAccess.resolve('locations', null, true).then(function (items) {
	    _this.results.setItems(items);
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  this.results = new _IndexControl2.default(div, { items: [], onclick: args.onok });
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = SelectLocation;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FaxnumberControl = function () {
	  function FaxnumberControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, FaxnumberControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.input.value = args.value ? args.value : '';
	    this.input.type = 'tel';
	    this.input.autocapitalize = 'off';
	    this.input.autocorrect = 'off';
	    this.input.spellcheck = 'false';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var onclick = function onclick() {
	      if (_this.input.value) {
	        var parsedPhonenumber = _this.input.value.trim().replace(/ *\([^)]*\) */g, '').replace(/[^+0-9.]/g, '');
	
	        if (parsedPhonenumber) {
	          if (parsedPhonenumber.length < 4) {
	            alert('Telefoonummers korter dan 4 cijfers zijn zeer waarschijnlijk noodnummers. U kunt geen noodnummers bellen vanuit deze applicatie.');
	            return;
	          }
	
	          if (confirm('Dit is een faxnummer. Weet u zeker dat u naar dit nummer wilt bellen?')) {
	            location.href = 'tel:' + parsedPhonenumber;
	          }
	        }
	      }
	    };
	
	    var button = document.createElement('button');
	    button.innerHTML = '\uE0D4';
	    button.className = 'icon';
	    button.onclick = onclick;
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	    div.appendChild(button);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(FaxnumberControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value;
	    }
	  }]);
	
	  return FaxnumberControl;
	}();
	
	exports.default = FaxnumberControl;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _IndexControl = __webpack_require__(21);
	
	var _IndexControl2 = _interopRequireDefault(_IndexControl);
	
	var _EducationForm = __webpack_require__(58);
	
	var _EducationForm2 = _interopRequireDefault(_EducationForm);
	
	var _LogentryModel = __webpack_require__(10);
	
	var _LogentryModel2 = _interopRequireDefault(_LogentryModel);
	
	var _PersonModel = __webpack_require__(6);
	
	var _PersonModel2 = _interopRequireDefault(_PersonModel);
	
	var _EducationModel = __webpack_require__(8);
	
	var _EducationModel2 = _interopRequireDefault(_EducationModel);
	
	var _ObjectTypeMapping = __webpack_require__(49);
	
	var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditEducation = function EditEducation(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, EditEducation);
	
	  this.onchange = function () {
	    _this.data = _this.educationForm.getValue();
	
	    window.PRIM.initDelayedNavigation();
	    window.PRIM.dataAccess.put('educations', _this.data.getJSON()).then(function (education) {
	      if (!window.PRIM.isDelayedNavigationActive()) {
	        return;
	      }
	
	      if (args && !args.id && education.id) {
	        window.PRIM.navigate('/educations/' + education.id, true);
	      }
	
	      if (education) {
	        _this.data.values.id = education.id;
	        _this.educationForm.setValue(_this.data);
	      }
	    });
	  };
	
	  if (args) {
	    if (args.id) {
	      window.PRIM.dataAccess.resolve('educations', args.id, true).then(function (education) {
	        _this.data = education;
	        _this.educationForm.setValue(_this.data);
	
	        window.PRIM.dataAccess.get('logentries').then(function (logentries) {
	          var results = logentries.filter(function (logentry) {
	            return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.education;
	          });
	
	          _this.data.logentries = results.map(function (logentry) {
	            return new _LogentryModel2.default(logentry);
	          });
	
	          _this.logIndex.setItems(_this.data.logentries);
	        }, function () {}).catch(function () {});
	      }, function () {
	        if (confirm('Deze opleiding bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe functie aanmaken?')) {
	          window.PRIM.navigate('/educations/');
	        } else {
	          history.back();
	        }
	      }).catch(function () {});
	    } else if (args.person_id) {
	      window.PRIM.dataAccess.resolve('people', args.person_id, true).then(function (person) {
	        _this.data = new _PersonModel2.default();
	        _this.data.values.person_id = person.values.id;
	        _this.data.person = person;
	        _this.educationForm.setValue(_this.data);
	      });
	    }
	  }
	
	  this.data = new _EducationModel2.default();
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Opleiding bewerken',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }, {
	      onclick: this.onchange,
	      icon: '\uE020',
	      classes: 'indicator'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          window.PRIM.navigate('/logentries/education/' + _this.data.values.id);
	        } else {
	          alert('Vul eerst gegevens voor deze opleiding.');
	        }
	      },
	      icon: '\uE032',
	      label: 'Logboekregel'
	    }, {
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          if (confirm('Weet u het zeker dat u deze opleiding wilt verwijderen?')) {
	            window.PRIM.dataAccess.delete('educations', _this.data.values.id).then(function () {
	              history.back();
	            });
	          }
	        } else {
	          alert('Vul eerst gegevens voor deze opleiding.');
	        }
	      },
	      icon: '\uE123',
	      label: 'Verwijderen'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var divContent = document.createElement('div');
	  divContent.className = 'content';
	
	  var primaryData = document.createElement('section');
	  primaryData.className = 'primary';
	  var secondaryData = document.createElement('section');
	  secondaryData.className = 'secondary';
	
	  this.educationForm = new _EducationForm2.default(primaryData, { education: this.data, onchange: this.onchange });
	
	  var fieldsetLog = document.createElement('fieldset');
	  var legendLog = document.createElement('legend');
	  legendLog.innerHTML = 'Logboek';
	  fieldsetLog.appendChild(legendLog);
	
	  var onclickLogentry = function onclickLogentry(item) {
	    window.PRIM.navigate('/logentries/' + item.values.id);
	  };
	
	  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });
	
	  secondaryData.appendChild(fieldsetLog);
	
	  divContent.appendChild(primaryData);
	  divContent.appendChild(secondaryData);
	  div.appendChild(divContent);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = EditEducation;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _EducationModel = __webpack_require__(8);
	
	var _EducationModel2 = _interopRequireDefault(_EducationModel);
	
	var _TextControl = __webpack_require__(39);
	
	var _TextControl2 = _interopRequireDefault(_TextControl);
	
	var _PickerControl = __webpack_require__(53);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	var _SelectPerson = __webpack_require__(54);
	
	var _SelectPerson2 = _interopRequireDefault(_SelectPerson);
	
	var _SelectLocation = __webpack_require__(55);
	
	var _SelectLocation2 = _interopRequireDefault(_SelectLocation);
	
	var _DateControl = __webpack_require__(41);
	
	var _DateControl2 = _interopRequireDefault(_DateControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EducationForm = function () {
	  function EducationForm(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, EducationForm);
	
	    var fieldsetEducation = document.createElement('fieldset');
	    var legendEducation = document.createElement('legend');
	    legendEducation.innerHTML = 'Opleiding';
	    fieldsetEducation.appendChild(legendEducation);
	    var popup = null;
	
	    this.id = args.education.values.id;
	    this.person = new _PickerControl2.default(fieldsetEducation, { label: 'Persoon', value: args.education.values.person_id,
	      onchange: args.onchange,
	      onselect: function onselect(item) {
	        if (item.values.id) {
	          window.PRIM.navigate('/people/' + item.values.id);
	        }
	      },
	      onclick: function onclick() {
	        var popupElement = document.getElementById('popup');
	        var viewportElement = document.getElementById('viewport');
	
	        popup = new _SelectPerson2.default(popupElement, {
	          onok: function onok(item) {
	            if (item && item.values.id) {
	              _this.person.setValue(item.values.id, item);
	            } else {
	              _this.person.setValue(null, null);
	            }
	
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	            _this.person.onchange();
	          },
	          oncancel: function oncancel() {
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	          }
	        });
	        viewportElement.classList.add('invisible');
	        popupElement.classList.remove('invisible');
	      }
	    });
	    this.location = new _PickerControl2.default(fieldsetEducation, { label: 'Locatie', value: args.education.values.location_id,
	      onchange: args.onchange,
	      onselect: function onselect(item) {
	        if (item.values.id) {
	          window.PRIM.navigate('/locations/' + item.values.id);
	        }
	      },
	      onclick: function onclick() {
	        var popupElement = document.getElementById('popup');
	        var viewportElement = document.getElementById('viewport');
	
	        popup = new _SelectLocation2.default(popupElement, {
	          onok: function onok(item) {
	            if (item && item.values.id) {
	              _this.location.setValue(item.values.id, item);
	            } else {
	              _this.location.setValue(null, null);
	            }
	
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	            _this.location.onchange();
	          },
	          oncancel: function oncancel() {
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	          }
	        });
	        viewportElement.classList.add('invisible');
	        popupElement.classList.remove('invisible');
	      }
	    });
	    this.title = new _TextControl2.default(fieldsetEducation, { label: 'Titel', value: args.education.values.title, readonly: window.PRIM.hasReadonlyModuleAccess('educations'), onchange: args.onchange });
	    this.start = new _DateControl2.default(fieldsetEducation, { label: 'Start', value: args.education.values.start, readonly: window.PRIM.hasReadonlyModuleAccess('educations'), onchange: args.onchange });
	    this.end = new _DateControl2.default(fieldsetEducation, { label: 'Einde', value: args.education.values.end, readonly: window.PRIM.hasReadonlyModuleAccess('educations'), onchange: args.onchange });
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(fieldsetEducation);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(EducationForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      var education = new _EducationModel2.default();
	      education.person = this.person.getItem();
	      education.location = this.location.getItem();
	      education.values.id = this.id;
	      education.values.location_id = this.education.getValue();
	      education.values.title = this.title.getValue();
	      education.values.start = this.start.getValue();
	      education.values.end = this.end.getValue();
	      return education;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(education) {
	      this.id = education.values.id;
	      this.person.setValue(education.values.person_id, education.person);
	      this.location.setValue(education.values.location_id, education.location);
	      this.title.setValue(education.values.title);
	      this.start.setValue(education.values.start);
	      this.end.setValue(education.values.end);
	    }
	  }]);
	
	  return EducationForm;
	}();
	
	exports.default = EducationForm;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _IndexControl = __webpack_require__(21);
	
	var _IndexControl2 = _interopRequireDefault(_IndexControl);
	
	var _OrganisationForm = __webpack_require__(60);
	
	var _OrganisationForm2 = _interopRequireDefault(_OrganisationForm);
	
	var _LogentryModel = __webpack_require__(10);
	
	var _LogentryModel2 = _interopRequireDefault(_LogentryModel);
	
	var _OrganisationModel = __webpack_require__(9);
	
	var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);
	
	var _ObjectTypeMapping = __webpack_require__(49);
	
	var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditOrganisation = function EditOrganisation(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, EditOrganisation);
	
	  this.onchange = function () {
	    _this.data = _this.organisationForm.getValue();
	    window.PRIM.initDelayedNavigation();
	    window.PRIM.dataAccess.put('organisations', _this.data.getJSON()).then(function (organisation) {
	      if (!window.PRIM.isDelayedNavigationActive()) {
	        return;
	      }
	
	      if (args && !args.id && organisation.id) {
	        window.PRIM.navigate('/organisations/' + organisation.id, true);
	      }
	
	      if (organisation) {
	        _this.data.values.id = organisation.id;
	        _this.organisationForm.setValue(_this.data);
	      }
	    });
	  };
	
	  if (args && args.id) {
	    window.PRIM.dataAccess.resolve('organisations', args.id, true).then(function (organisation) {
	      _this.data = organisation;
	      _this.organisationForm.setValue(_this.data);
	
	      window.PRIM.dataAccess.resolve('locations', _this.data.values.id, true, 'organisation_id').then(function (locations) {
	        for (var i = 0; i < locations.length; i++) {
	          if (locations[i].values.id === _this.data.values.location_id) {
	            _this.data.location = locations[i];
	            _this.organisationForm.setValue(_this.data);
	            break;
	          }
	        }
	
	        _this.data.locations = locations;
	        _this.locationIndex.setItems(_this.data.locations);
	      }, function () {}).catch(function () {});
	
	      window.PRIM.dataAccess.get('logentries').then(function (logentries) {
	        var results = logentries.filter(function (logentry) {
	          return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.organisation;
	        });
	
	        _this.data.logentries = results.map(function (logentry) {
	          return new _LogentryModel2.default(logentry);
	        });
	
	        _this.logIndex.setItems(_this.data.logentries);
	      }, function () {}).catch(function () {});
	    }, function () {
	      if (confirm('Deze organisatie bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe organisatie aanmaken?')) {
	        window.PRIM.navigate('/organisations/');
	      } else {
	        history.back();
	      }
	    }).catch(function () {});
	  }
	
	  this.data = new _OrganisationModel2.default();
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Organisatie bewerken',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }, {
	      onclick: this.onchange,
	      icon: '\uE020',
	      classes: 'indicator'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          window.PRIM.navigate('/locations/new/' + _this.data.values.id);
	        } else {
	          alert('Vul eerst gegevens voor deze organisatie.');
	        }
	      },
	      icon: '\uE0A0',
	      label: 'Vestiging'
	    }, {
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          window.PRIM.navigate('/logentries/organisation/' + _this.data.values.id);
	        } else {
	          alert('Vul eerst gegevens voor deze organisatie.');
	        }
	      },
	      icon: '\uE032',
	      label: 'Logboekregel'
	    }, {
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          if (confirm('Weet u het zeker dat u deze organisatie wilt verwijderen?')) {
	            window.PRIM.dataAccess.delete('organisations', _this.data.values.id).then(function () {
	              history.back();
	            });
	          }
	        } else {
	          alert('Vul eerst gegevens voor deze organisatie.');
	        }
	      },
	      icon: '\uE123',
	      label: 'Verwijderen'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var divContent = document.createElement('div');
	  divContent.className = 'content';
	
	  var primaryData = document.createElement('section');
	  primaryData.className = 'primary';
	  var secondaryData = document.createElement('section');
	  secondaryData.className = 'secondary';
	
	  this.organisationForm = new _OrganisationForm2.default(primaryData, { organisation: this.data, onchange: this.onchange });
	
	  var fieldsetLocations = document.createElement('fieldset');
	  var legendLocations = document.createElement('legend');
	  legendLocations.innerHTML = 'Vestigingen';
	  fieldsetLocations.appendChild(legendLocations);
	
	  var onclickLocation = function onclickLocation(item) {
	    window.PRIM.navigate('/locations/' + item.values.id);
	  };
	
	  this.locationIndex = new _IndexControl2.default(fieldsetLocations, { items: this.data.locations, onclick: onclickLocation });
	
	  secondaryData.appendChild(fieldsetLocations);
	
	  var fieldsetLog = document.createElement('fieldset');
	  var legendLog = document.createElement('legend');
	  legendLog.innerHTML = 'Logboek';
	  fieldsetLog.appendChild(legendLog);
	
	  var onclickLogentry = function onclickLogentry(item) {
	    window.PRIM.navigate('/logentries/' + item.values.id);
	  };
	
	  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });
	
	  secondaryData.appendChild(fieldsetLog);
	
	  divContent.appendChild(primaryData);
	  divContent.appendChild(secondaryData);
	  div.appendChild(divContent);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = EditOrganisation;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _OrganisationModel = __webpack_require__(9);
	
	var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);
	
	var _TextControl = __webpack_require__(39);
	
	var _TextControl2 = _interopRequireDefault(_TextControl);
	
	var _PickerControl = __webpack_require__(53);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	var _ImageSelectControl = __webpack_require__(36);
	
	var _ImageSelectControl2 = _interopRequireDefault(_ImageSelectControl);
	
	var _SelectLocation = __webpack_require__(55);
	
	var _SelectLocation2 = _interopRequireDefault(_SelectLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var OrganisationForm = function () {
	  function OrganisationForm(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, OrganisationForm);
	
	    var fieldsetOrganisation = document.createElement('fieldset');
	    var legendOrganisation = document.createElement('legend');
	    legendOrganisation.innerHTML = 'Organisatie';
	    fieldsetOrganisation.appendChild(legendOrganisation);
	    var popup = null;
	    this.id = args.organisation.values.id;
	    this.image = new _ImageSelectControl2.default(fieldsetOrganisation, { label: 'Afbeelding', value: args.organisation.values.image, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange });
	    this.name = new _TextControl2.default(fieldsetOrganisation, { label: 'Naam', value: args.organisation.values.name, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange });
	    this.location = new _PickerControl2.default(fieldsetOrganisation, { label: 'Hoofdvestiging', value: args.organisation.values.location_id,
	      onchange: args.onchange,
	      onselect: function onselect(item) {
	        if (item.values.id) {
	          window.PRIM.navigate('/locations/' + item.values.id);
	        }
	      },
	      onclick: function onclick() {
	        var popupElement = document.getElementById('popup');
	        var viewportElement = document.getElementById('viewport');
	
	        popup = new _SelectLocation2.default(popupElement, {
	          onok: function onok(item) {
	            if (item && item.values.id) {
	              _this.location.setValue(item.values.id, item);
	            } else {
	              _this.location.setValue(null, null);
	            }
	
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	            _this.location.onchange();
	          },
	          oncancel: function oncancel() {
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	          }
	        });
	        viewportElement.classList.add('invisible');
	        popupElement.classList.remove('invisible');
	      }
	    });
	    this.vat = new _TextControl2.default(fieldsetOrganisation, { label: 'BTW nummer', value: args.organisation.values.vat, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange });
	    this.coc = new _TextControl2.default(fieldsetOrganisation, { label: 'KVK nummer', value: args.organisation.values.coc, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange });
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(fieldsetOrganisation);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(OrganisationForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      var organisation = new _OrganisationModel2.default();
	      organisation.values.image = this.image.getValue();
	      organisation.location = this.location.getItem();
	      organisation.values.id = this.id;
	      organisation.values.name = this.name.getValue();
	      organisation.values.location_id = this.location.getValue();
	      organisation.values.vat = this.vat.getValue();
	      organisation.values.coc = this.coc.getValue();
	      return organisation;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(organisation) {
	      this.id = organisation.values.id;
	      this.image.setValue(organisation.values.image);
	      this.name.setValue(organisation.values.name);
	      this.location.setValue(organisation.values.location_id, organisation.location);
	      this.vat.setValue(organisation.values.vat);
	      this.coc.setValue(organisation.values.coc);
	    }
	  }]);
	
	  return OrganisationForm;
	}();
	
	exports.default = OrganisationForm;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _IndexControl = __webpack_require__(21);
	
	var _IndexControl2 = _interopRequireDefault(_IndexControl);
	
	var _LocationForm = __webpack_require__(62);
	
	var _LocationForm2 = _interopRequireDefault(_LocationForm);
	
	var _LogentryModel = __webpack_require__(10);
	
	var _LogentryModel2 = _interopRequireDefault(_LogentryModel);
	
	var _LocationModel = __webpack_require__(11);
	
	var _LocationModel2 = _interopRequireDefault(_LocationModel);
	
	var _ObjectTypeMapping = __webpack_require__(49);
	
	var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditLocation = function EditLocation(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, EditLocation);
	
	  this.onchange = function () {
	    _this.data = _this.locationForm.getValue();
	    window.PRIM.initDelayedNavigation();
	    window.PRIM.dataAccess.put('locations', _this.data.getJSON()).then(function (location) {
	      if (!window.PRIM.isDelayedNavigationActive()) {
	        return;
	      }
	
	      if (args && !args.id && location.id) {
	        window.PRIM.navigate('/locations/' + location.id, true);
	      }
	
	      if (location) {
	        _this.data.values.id = location.id;
	        _this.locationForm.setValue(_this.data);
	      }
	    });
	  };
	
	  if (args) {
	    if (args.id) {
	      window.PRIM.dataAccess.resolve('locations', args.id, true).then(function (location) {
	        _this.data = location;
	        _this.locationForm.setValue(_this.data);
	
	        window.PRIM.dataAccess.resolve('positions', _this.data.values.id, true, 'location_id').then(function (positions) {
	          _this.data.positions = positions;
	          _this.positionIndex.setItems(_this.data.positions);
	        }, function () {}).catch(function () {});
	
	        window.PRIM.dataAccess.get('logentries').then(function (logentries) {
	          var results = logentries.filter(function (logentry) {
	            return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.location;
	          });
	
	          _this.data.logentries = results.map(function (logentry) {
	            return new _LogentryModel2.default(logentry);
	          });
	
	          _this.logIndex.setItems(_this.data.logentries);
	          _this.locationForm.setValue(_this.data);
	        }, function () {
	          _this.locationForm.setValue(_this.data);
	        }).catch(function () {});
	      }, function () {
	        if (confirm('Deze vestiging bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe vestiging aanmaken?')) {
	          window.PRIM.navigate('/locations/');
	        } else {
	          history.back();
	        }
	      }).catch(function () {});
	    } else if (args.organisation_id) {
	      window.PRIM.dataAccess.resolve('organisations', args.organisation_id, true).then(function (organisation) {
	        _this.data = new _LocationModel2.default();
	        _this.data.values.organisation_id = organisation.values.id;
	        _this.data.organisation = organisation;
	        _this.locationForm.setValue(_this.data);
	      });
	    }
	  }
	
	  this.data = new _LocationModel2.default();
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Vestiging bewerken',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }, {
	      onclick: this.onchange,
	      icon: '\uE020',
	      classes: 'indicator'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          window.PRIM.navigate('/positions/location/' + _this.data.values.id);
	        } else {
	          alert('Vul eerst gegevens voor deze afdeling.');
	        }
	      },
	      icon: '\uE034',
	      label: 'Functie'
	    }, {
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          window.PRIM.navigate('/logentries/location/' + _this.data.values.id);
	        } else {
	          alert('Vul eerst gegevens voor deze vestiging.');
	        }
	      },
	      icon: '\uE032',
	      label: 'Logboekregel'
	    }, {
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          if (confirm('Weet u het zeker dat u deze vestiging wilt verwijderen?')) {
	            window.PRIM.dataAccess.delete('locations', _this.data.values.id).then(function () {
	              history.back();
	            });
	          }
	        } else {
	          alert('Vul eerst gegevens voor deze vestiging.');
	        }
	      },
	      icon: '\uE123',
	      label: 'Verwijderen'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var divContent = document.createElement('div');
	  divContent.className = 'content';
	
	  var primaryData = document.createElement('section');
	  primaryData.className = 'primary';
	  var secondaryData = document.createElement('section');
	  secondaryData.className = 'secondary';
	
	  this.locationForm = new _LocationForm2.default(primaryData, { location: this.data, onchange: this.onchange });
	
	  var fieldsetPositions = document.createElement('fieldset');
	  var legendPositions = document.createElement('legend');
	  legendPositions.innerHTML = 'Functies';
	  fieldsetPositions.appendChild(legendPositions);
	
	  var onclickPositions = function onclickPositions(item) {
	    window.PRIM.navigate('/positions/' + item.values.id);
	  };
	
	  this.positionIndex = new _IndexControl2.default(fieldsetPositions, { items: this.data.positions, onclick: onclickPositions });
	
	  secondaryData.appendChild(fieldsetPositions);
	
	  var fieldsetLog = document.createElement('fieldset');
	  var legendLog = document.createElement('legend');
	  legendLog.innerHTML = 'Logboek';
	  fieldsetLog.appendChild(legendLog);
	
	  var onclickLogentry = function onclickLogentry(item) {
	    window.PRIM.navigate('/logentries/' + item.values.id);
	  };
	
	  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });
	
	  secondaryData.appendChild(fieldsetLog);
	
	  divContent.appendChild(primaryData);
	  divContent.appendChild(secondaryData);
	  div.appendChild(divContent);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = EditLocation;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LocationModel = __webpack_require__(11);
	
	var _LocationModel2 = _interopRequireDefault(_LocationModel);
	
	var _TextControl = __webpack_require__(39);
	
	var _TextControl2 = _interopRequireDefault(_TextControl);
	
	var _UrlControl = __webpack_require__(63);
	
	var _UrlControl2 = _interopRequireDefault(_UrlControl);
	
	var _PickerControl = __webpack_require__(53);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	var _PhonenumberControl = __webpack_require__(42);
	
	var _PhonenumberControl2 = _interopRequireDefault(_PhonenumberControl);
	
	var _FaxnumberControl = __webpack_require__(56);
	
	var _FaxnumberControl2 = _interopRequireDefault(_FaxnumberControl);
	
	var _EmailControl = __webpack_require__(43);
	
	var _EmailControl2 = _interopRequireDefault(_EmailControl);
	
	var _SelectOrganisation = __webpack_require__(64);
	
	var _SelectOrganisation2 = _interopRequireDefault(_SelectOrganisation);
	
	var _SelectControl = __webpack_require__(40);
	
	var _SelectControl2 = _interopRequireDefault(_SelectControl);
	
	var _GoogleMapsButtonControl = __webpack_require__(48);
	
	var _GoogleMapsButtonControl2 = _interopRequireDefault(_GoogleMapsButtonControl);
	
	var _CountryOptions = __webpack_require__(35);
	
	var _CountryOptions2 = _interopRequireDefault(_CountryOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocationForm = function () {
	  function LocationForm(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, LocationForm);
	
	    var fieldsetLocation = document.createElement('fieldset');
	    var legendLocation = document.createElement('legend');
	    legendLocation.innerHTML = 'Vestiging';
	    fieldsetLocation.appendChild(legendLocation);
	
	    this.id = args.location.values.id;
	    var popup = null;
	
	    this.organisation = new _PickerControl2.default(fieldsetLocation, { label: 'Organisatie', value: args.location.values.organisation_id,
	      onchange: args.onchange,
	      onselect: function onselect(item) {
	        if (item.values.id) {
	          window.PRIM.navigate('/organisations/' + item.values.id);
	        }
	      },
	      onclick: function onclick() {
	        var popupElement = document.getElementById('popup');
	        var viewportElement = document.getElementById('viewport');
	
	        popup = new _SelectOrganisation2.default(popupElement, {
	          onok: function onok(item) {
	            if (item && item.values.id) {
	              _this.organisation.setValue(item.values.id, item);
	            } else {
	              _this.organisation.setValue(null, null);
	            }
	
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	            _this.organisation.onchange();
	          },
	          oncancel: function oncancel() {
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	          }
	        });
	        viewportElement.classList.add('invisible');
	        popupElement.classList.remove('invisible');
	      }
	    });
	    this.business = new _TextControl2.default(fieldsetLocation, { label: 'Business', value: args.location.values.business, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	
	    var fieldsetContact = document.createElement('fieldset');
	    var legendContact = document.createElement('legend');
	    legendContact.innerHTML = 'Contact gegevens';
	    fieldsetContact.appendChild(legendContact);
	
	    this.phone = new _PhonenumberControl2.default(fieldsetContact, { label: 'Telefoon', value: args.location.values.phone, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.fax = new _FaxnumberControl2.default(fieldsetContact, { label: 'Fax', value: args.location.values.fax, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.email = new _EmailControl2.default(fieldsetContact, { label: 'E-mail', value: args.location.values.email, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.website = new _UrlControl2.default(fieldsetContact, { label: 'Website', value: args.location.values.website, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	
	    var fieldsetPost = document.createElement('fieldset');
	    var legendPost = document.createElement('legend');
	    legendPost.innerHTML = 'Postadres';
	    fieldsetPost.appendChild(legendPost);
	
	    this.postaddress = new _TextControl2.default(fieldsetPost, { label: 'Adres', value: args.location.values.postaddress, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.postzipcode = new _TextControl2.default(fieldsetPost, { label: 'Postcode', value: args.location.values.postzipcode, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.postcity = new _TextControl2.default(fieldsetPost, { label: 'Plaats', value: args.location.values.postcity, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.postregion = new _TextControl2.default(fieldsetPost, { label: 'Provincie', value: args.location.values.postregion, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.postcountry = new _SelectControl2.default(fieldsetPost, { label: 'Land', value: args.location.values.postcountry, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	
	    var fieldsetAddress = document.createElement('fieldset');
	    var legendAddress = document.createElement('legend');
	    legendAddress.innerHTML = 'Bezoekersadres';
	    fieldsetAddress.appendChild(legendAddress);
	
	    this.address = new _TextControl2.default(fieldsetAddress, { label: 'Adres', value: args.location.values.visitaddress, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.zipcode = new _TextControl2.default(fieldsetAddress, { label: 'Postcode', value: args.location.values.visitzipcode, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.city = new _TextControl2.default(fieldsetAddress, { label: 'Plaats', value: args.location.values.visitcity, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.region = new _TextControl2.default(fieldsetAddress, { label: 'Provincie', value: args.location.values.visitregion, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.country = new _SelectControl2.default(fieldsetAddress, { label: 'Land', value: args.location.values.visitcountry, options: _CountryOptions2.default, readonly: window.PRIM.hasReadonlyModuleAccess('locations'), onchange: args.onchange });
	    this.addressGoogleMaps = new _GoogleMapsButtonControl2.default(fieldsetAddress, { getValues: function getValues() {
	        return [_this.address.getValue(), _this.zipcode.getValue(), _this.city.getValue(), _this.region.getValue(), _this.country.getValue()];
	      } });
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(fieldsetLocation);
	    fragment.appendChild(fieldsetContact);
	    fragment.appendChild(fieldsetPost);
	    fragment.appendChild(fieldsetAddress);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(LocationForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      var location = new _LocationModel2.default();
	      location.organisation = this.organisation.getItem();
	      location.values.id = this.id;
	      location.values.organisation_id = this.organisation.getValue();
	      location.values.business = this.business.getValue();
	      location.values.postaddress = this.postaddress.getValue();
	      location.values.postzipcode = this.postzipcode.getValue();
	      location.values.postcity = this.postcity.getValue();
	      location.values.postregion = this.postregion.getValue();
	      location.values.postcountry = this.postcountry.getValue();
	      location.values.phone = this.phone.getValue();
	      location.values.email = this.email.getValue();
	      location.values.fax = this.fax.getValue();
	      location.values.website = this.website.getValue();
	      location.values.visitaddress = this.address.getValue();
	      location.values.visitzipcode = this.zipcode.getValue();
	      location.values.visitcity = this.city.getValue();
	      location.values.visitregion = this.region.getValue();
	      location.values.visitcountry = this.country.getValue();
	      return location;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(location) {
	      this.id = location.values.id;
	      this.organisation.setValue(location.values.organisation_id, location.organisation);
	      this.business.setValue(location.values.business);
	      this.postaddress.setValue(location.values.postaddress);
	      this.postzipcode.setValue(location.values.postzipcode);
	      this.postcity.setValue(location.values.postcity);
	      this.postregion.setValue(location.values.postregion);
	      this.postcountry.setValue(location.values.postcountry);
	      this.phone.setValue(location.values.phone);
	      this.email.setValue(location.values.email);
	      this.fax.setValue(location.values.fax);
	      this.website.setValue(location.values.website);
	      this.address.setValue(location.values.visitaddress);
	      this.zipcode.setValue(location.values.visitzipcode);
	      this.city.setValue(location.values.visitcity);
	      this.region.setValue(location.values.visitregion);
	      this.country.setValue(location.values.visitcountry);
	    }
	  }]);
	
	  return LocationForm;
	}();
	
	exports.default = LocationForm;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UrlControl = function () {
	  function UrlControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, UrlControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.input.value = args.value ? args.value : '';
	    this.input.type = 'url';
	    this.input.autocapitalize = 'off';
	    this.input.autocorrect = 'off';
	    this.input.spellcheck = 'false';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var onclick = function onclick() {
	      if (_this.input.value) {
	        var parsedUrl = _this.input.value.trim();
	
	        if (parsedUrl) {
	          open(parsedUrl);
	        }
	      }
	    };
	
	    var button = document.createElement('button');
	    button.className = 'icon';
	    button.innerHTML = '\uE06D';
	    button.onclick = onclick;
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	    div.appendChild(button);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(UrlControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value;
	    }
	  }]);
	
	  return UrlControl;
	}();
	
	exports.default = UrlControl;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _IndexControl = __webpack_require__(21);
	
	var _IndexControl2 = _interopRequireDefault(_IndexControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SelectOrganisation = function SelectOrganisation(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, SelectOrganisation);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Kies organisatie',
	    leftHandButtons: [{
	      onclick: args.oncancel,
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        if (args.onok) {
	          args.onok();
	        }
	      },
	      icon: '\uE03D',
	      label: 'Geen selectie'
	    }]
	  });
	
	  window.PRIM.dataAccess.resolve('organisations', null, true).then(function (items) {
	    _this.results.setItems(items);
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  this.results = new _IndexControl2.default(div, { items: [], onclick: args.onok });
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = SelectOrganisation;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _LogentryForm = __webpack_require__(66);
	
	var _LogentryForm2 = _interopRequireDefault(_LogentryForm);
	
	var _LogentryModel = __webpack_require__(10);
	
	var _LogentryModel2 = _interopRequireDefault(_LogentryModel);
	
	var _ObjectTypeMapping = __webpack_require__(49);
	
	var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditLogentry = function EditLogentry(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, EditLogentry);
	
	  this.onchange = function () {
	    _this.data = _this.logentryForm.getValue();
	    window.PRIM.initDelayedNavigation();
	    window.PRIM.dataAccess.put('logentries', _this.data.getJSON()).then(function (logentry) {
	      if (!window.PRIM.isDelayedNavigationActive()) {
	        return;
	      }
	
	      if (args && !args.id && logentry.id) {
	        window.PRIM.navigate('/logentries/' + logentry.id, true);
	      }
	
	      if (logentry) {
	        _this.data.values.id = logentry.id;
	        _this.logentryForm.setValue(_this.data);
	      }
	    });
	  };
	
	  this.data = new _LogentryModel2.default();
	
	  if (args) {
	    if (args.id) {
	      window.PRIM.dataAccess.resolve('logentries', args.id, false).then(function (logentry) {
	        _this.data = logentry;
	        _this.logentryForm.setValue(_this.data);
	      }, function () {
	        if (confirm('Deze logregel bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw logregel aanmaken?')) {
	          window.PRIM.navigate('/logentries/');
	        } else {
	          history.back();
	        }
	      }).catch(function () {});
	    } else if (args.target_id && args.object_type) {
	      this.data.values.target_id = args.target_id;
	      this.data.values.object_type_id = _ObjectTypeMapping2.default[args.object_type];
	
	      var now = new Date();
	      now = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
	
	      this.data.values.timestamp = now.toISOString().substring(0, 19).replace('T', ' ');
	    }
	  } else {
	    var _now = new Date();
	    _now = new Date(_now.getTime() - _now.getTimezoneOffset() * 60000);
	
	    this.data.values.timestamp = _now.toISOString().substring(0, 19).replace('T', ' ');
	  }
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Logregel bewerken',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }, {
	      onclick: this.onchange,
	      icon: '\uE020',
	      classes: 'indicator'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          if (confirm('Weet u het zeker dat u deze logregel wilt verwijderen?')) {
	            window.PRIM.dataAccess.delete('logentries', _this.data.values.id).then(function () {
	              history.back();
	            });
	          }
	        } else {
	          alert('Vul eerst gegevens voor deze logregel.');
	        }
	      },
	      icon: '\uE123',
	      label: 'Verwijderen'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var divContent = document.createElement('div');
	  divContent.className = 'content';
	
	  this.logentryForm = new _LogentryForm2.default(divContent, { logentry: this.data, onchange: this.onchange });
	
	  div.appendChild(divContent);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = EditLogentry;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _LogentryModel = __webpack_require__(10);
	
	var _LogentryModel2 = _interopRequireDefault(_LogentryModel);
	
	var _TimestampControl = __webpack_require__(67);
	
	var _TimestampControl2 = _interopRequireDefault(_TimestampControl);
	
	var _TextAreaControl = __webpack_require__(68);
	
	var _TextAreaControl2 = _interopRequireDefault(_TextAreaControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LogentryForm = function () {
	  function LogentryForm(element, args) {
	    _classCallCheck(this, LogentryForm);
	
	    var fieldsetLogentry = document.createElement('fieldset');
	    var legendLogentry = document.createElement('legend');
	    legendLogentry.innerHTML = 'Logboekregel';
	    fieldsetLogentry.appendChild(legendLogentry);
	
	    this.id = args.logentry.values.id;
	    this.target_id = args.logentry.values.target_id;
	    this.object_type_id = args.logentry.values.object_type_id;
	
	    this.timestamp = new _TimestampControl2.default(fieldsetLogentry, { label: 'Tijdstempel', value: args.logentry.values.timestamp, readonly: window.PRIM.hasReadonlyModuleAccess('logentries'), onchange: args.onchange });
	    this.description = new _TextAreaControl2.default(fieldsetLogentry, { label: 'Omschrijving', value: args.logentry.values.description, readonly: window.PRIM.hasReadonlyModuleAccess('logentries'), onchange: args.onchange });
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(fieldsetLogentry);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(LogentryForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      var logentry = new _LogentryModel2.default();
	      logentry.values.id = this.id;
	      logentry.values.target_id = this.target_id;
	      logentry.values.object_type_id = this.object_type_id;
	      logentry.values.timestamp = this.timestamp.getValue();
	      logentry.values.description = this.description.getValue();
	      return logentry;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(logentry) {
	      this.id = logentry.values.id;
	      this.target_id = logentry.values.target_id;
	      this.object_type_id = logentry.values.object_type_id;
	      this.timestamp.setValue(logentry.values.timestamp);
	      this.description.setValue(logentry.values.description);
	    }
	  }]);
	
	  return LogentryForm;
	}();
	
	exports.default = LogentryForm;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TimestampControl = function () {
	  function TimestampControl(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, TimestampControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.setValue(args.value);
	    this.input.type = 'text';
	    this.input.autocapitalize = 'off';
	    this.input.autocorrect = 'off';
	    this.input.spellcheck = 'false';
	    this.input.pattern = '\d{4}(-\d{2}(-\d{2}( \d{2}(:\d{2}(:\d{2})?)?)?)?)?';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	
	    var onclick = function onclick() {
	      if (args.readonly) {
	        return;
	      }
	      _this.setValue(new Date());
	      _this.input.dispatchEvent(new Event('change', { bubbles: true }));
	    };
	
	    var button = document.createElement('button');
	    button.className = 'icon';
	    button.innerHTML = '\uE138';
	    button.onclick = onclick;
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	    div.appendChild(button);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(TimestampControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? new Date(this.input.value).toISOString() : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value ? window.PRIM.getUtcTimestamp(new Date(value)).toISOString().substring(0, 19).replace('T', ' ') : '';
	    }
	  }]);
	
	  return TimestampControl;
	}();
	
	exports.default = TimestampControl;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TextAreaControl = function () {
	  function TextAreaControl(element, args) {
	    _classCallCheck(this, TextAreaControl);
	
	    var div = document.createElement('div');
	    this.textarea = document.createElement('textarea');
	    this.textarea.id = window.PRIM.getUUID();
	    this.textarea.value = args.value ? args.value : '';
	    this.textarea.rows = 8;
	    this.textarea.autocapitalize = 'sentences';
	    this.textarea.autocorrect = 'on';
	    this.textarea.spellcheck = 'true';
	    this.textarea.disabled = args.readonly ? 'disabled' : '';
	    this.textarea.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.textarea.id;
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.textarea);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(TextAreaControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.textarea.value ? this.textarea.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.textarea.value = value;
	    }
	  }]);
	
	  return TextAreaControl;
	}();
	
	exports.default = TextAreaControl;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _RelationshipModel = __webpack_require__(12);
	
	var _RelationshipModel2 = _interopRequireDefault(_RelationshipModel);
	
	var _RelationshipForm = __webpack_require__(70);
	
	var _RelationshipForm2 = _interopRequireDefault(_RelationshipForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditRelationship = function EditRelationship(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, EditRelationship);
	
	  this.onchange = function () {
	    _this.data = _this.relationshipForm.getValue();
	    window.PRIM.initDelayedNavigation();
	    window.PRIM.dataAccess.put('relationships', _this.data.getJSON()).then(function (relationship) {
	      if (!window.PRIM.isDelayedNavigationActive()) {
	        return;
	      }
	
	      if (args && !args.id && relationship.id) {
	        window.PRIM.navigate('/relationships/' + relationship.id, true);
	      }
	
	      if (relationship) {
	        _this.data.values.id = relationship.id;
	        _this.relationshipForm.setValue(_this.data);
	      }
	    });
	  };
	
	  this.data = new _RelationshipModel2.default();
	
	  if (args) {
	    if (args.id) {
	      window.PRIM.dataAccess.resolve('relationships', args.id, true).then(function (relationship) {
	        _this.data = relationship;
	        _this.relationshipForm.setValue(_this.data);
	      }, function () {
	        if (confirm('Deze relatie bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw relatie aanmaken?')) {
	          window.PRIM.navigate('/relationships/');
	        } else {
	          history.back();
	        }
	      }).catch(function () {
	        alert('Fout');
	      });
	    } else if (args.person_id) {
	      window.PRIM.dataAccess.resolve('people', args.person_id, true).then(function (person) {
	        _this.data.values.person_id = person.values.id;
	        _this.data.person = person;
	        _this.relationshipForm.setValue(_this.data);
	      });
	    }
	  }
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Relatie bewerken',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }, {
	      onclick: this.onchange,
	      icon: '\uE020',
	      classes: 'indicator'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          if (confirm('Weet u het zeker dat u deze relatie wilt verwijderen?')) {
	            window.PRIM.dataAccess.delete('relationships', _this.data.values.id).then(function () {
	              history.back();
	            });
	          }
	        } else {
	          alert('Vul eerst gegevens voor deze relatie.');
	        }
	      },
	      icon: '\uE123',
	      label: 'Verwijderen'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var divContent = document.createElement('div');
	  divContent.className = 'content';
	
	  this.relationshipForm = new _RelationshipForm2.default(divContent, { relationship: this.data, onchange: this.onchange });
	
	  div.appendChild(divContent);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = EditRelationship;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RelationshipModel = __webpack_require__(12);
	
	var _RelationshipModel2 = _interopRequireDefault(_RelationshipModel);
	
	var _PickerControl = __webpack_require__(53);
	
	var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	var _TextControl = __webpack_require__(39);
	
	var _TextControl2 = _interopRequireDefault(_TextControl);
	
	var _SelectPerson = __webpack_require__(54);
	
	var _SelectPerson2 = _interopRequireDefault(_SelectPerson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RelationshipForm = function () {
	  function RelationshipForm(element, args) {
	    var _this = this;
	
	    _classCallCheck(this, RelationshipForm);
	
	    var fieldsetRelationship = document.createElement('fieldset');
	    var legendRelationship = document.createElement('legend');
	    legendRelationship.innerHTML = 'Relatie';
	    fieldsetRelationship.appendChild(legendRelationship);
	
	    this.id = args.relationship.values.id;
	    var popup = null;
	
	    this.person = new _PickerControl2.default(fieldsetRelationship, { label: 'Deze persoon', value: args.relationship.values.person_id,
	      onchange: args.onchange,
	      onselect: function onselect(item) {
	        if (item.values.id) {
	          window.PRIM.navigate('/people/' + item.values.id);
	        }
	      },
	      onclick: function onclick() {
	        var popupElement = document.getElementById('popup');
	        var viewportElement = document.getElementById('viewport');
	
	        popup = new _SelectPerson2.default(popupElement, {
	          onok: function onok(item) {
	            if (item && item.values.id) {
	              _this.person.setValue(item.values.id, item);
	            } else {
	              _this.person.setValue(null, null);
	            }
	
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	            _this.person.onchange();
	          },
	          oncancel: function oncancel() {
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	          }
	        });
	        viewportElement.classList.add('invisible');
	        popupElement.classList.remove('invisible');
	      }
	    });
	    this.target = new _PickerControl2.default(fieldsetRelationship, { label: 'De andere persoon', value: args.relationship.values.target_id,
	      onchange: args.onchange,
	      onselect: function onselect(item) {
	        if (item.values.id) {
	          window.PRIM.navigate('/people/' + item.values.id);
	        }
	      },
	      onclick: function onclick() {
	        var popupElement = document.getElementById('popup');
	        var viewportElement = document.getElementById('viewport');
	
	        popup = new _SelectPerson2.default(popupElement, {
	          onok: function onok(item) {
	            if (item && item.values.id) {
	              _this.target.setValue(item.values.id, item);
	            } else {
	              _this.target.setValue(null, null);
	            }
	
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	            _this.person.onchange();
	          },
	          oncancel: function oncancel() {
	            viewportElement.classList.remove('invisible');
	            popupElement.classList.add('invisible');
	            popupElement.innerHTML = '';
	          }
	        });
	        viewportElement.classList.add('invisible');
	        popupElement.classList.remove('invisible');
	      }
	    });
	    this.description = new _TextControl2.default(fieldsetRelationship, { label: 'Omschrijving', value: args.relationship.values.description, readonly: window.PRIM.hasReadonlyModuleAccess('relationships'), onchange: args.onchange });
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(fieldsetRelationship);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(RelationshipForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      var relationship = new _RelationshipModel2.default();
	      relationship.person = this.person.getItem();
	      relationship.target = this.target.getItem();
	      relationship.values.id = this.id;
	      relationship.values.person_id = this.person.getValue();
	      relationship.values.target_id = this.target.getValue();
	      relationship.values.description = this.description.getValue();
	      return relationship;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(relationship) {
	      this.id = relationship.values.id;
	      this.person.setValue(relationship.values.person_id, relationship.person);
	      this.target.setValue(relationship.values.target_id, relationship.target);
	      this.description.setValue(relationship.values.description);
	    }
	  }]);
	
	  return RelationshipForm;
	}();
	
	exports.default = RelationshipForm;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _FileForm = __webpack_require__(72);
	
	var _FileForm2 = _interopRequireDefault(_FileForm);
	
	var _FileModel = __webpack_require__(13);
	
	var _FileModel2 = _interopRequireDefault(_FileModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EditFile = function EditFile(element, args) {
	  var _this = this;
	
	  _classCallCheck(this, EditFile);
	
	  this.onchange = function () {
	    _this.data = _this.fileForm.getValue();
	    window.PRIM.initDelayedNavigation();
	    window.PRIM.dataAccess.put('files', _this.data.getJSON()).then(function (file) {
	      if (!window.PRIM.isDelayedNavigationActive()) {
	        return;
	      }
	
	      if (args && !args.id && file.id) {
	        window.PRIM.navigate('/files/' + file.id);
	        return;
	      }
	
	      _this.data.values.id = file.id;
	      _this.fileForm.setValue(_this.data);
	    }).catch(window.PRIM.exceptionHandler);
	  };
	
	  if (args && args.id) {
	    window.PRIM.dataAccess.resolve('files', args.id, true).then(function (file) {
	      _this.data = file;
	      _this.fileForm.setValue(_this.data);
	    }, function () {
	      if (confirm('Dit bestand bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw bestand aanmaken?')) {
	        window.PRIM.navigate('/files/');
	      } else {
	        history.back();
	      }
	    }).catch(window.PRIM.exceptionHandler);
	  }
	
	  this.data = new _FileModel2.default();
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Bestand bewerken',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }, {
	      onclick: function onclick() {
	        history.forward();
	      },
	      icon: '\uE01A'
	    }, {
	      onclick: function onclick() {
	        window.PRIM.navigate('/start/');
	      },
	      icon: '\uE08A'
	    }, {
	      onclick: this.onchange,
	      icon: '\uE020',
	      classes: 'indicator'
	    }],
	    contextMenu: [{
	      onclick: function onclick() {
	        if (_this.data.values.id) {
	          if (confirm('Weet u het zeker dat u  bestand wilt verwijderen?')) {
	            window.PRIM.dataAccess.delete('files', _this.data.values.id).then(function () {
	              history.back();
	            });
	          }
	        } else {
	          alert('Vul eerst gegevens voor dit bestand.');
	        }
	      },
	      icon: '\uE123',
	      label: 'Verwijderen'
	    }]
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var divContent = document.createElement('div');
	  divContent.className = 'content';
	
	  this.fileForm = new _FileForm2.default(divContent, { file: this.data, onchange: this.onchange });
	
	  div.appendChild(divContent);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = EditFile;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FileModel = __webpack_require__(13);
	
	var _FileModel2 = _interopRequireDefault(_FileModel);
	
	var _ImageSelectControl = __webpack_require__(36);
	
	var _ImageSelectControl2 = _interopRequireDefault(_ImageSelectControl);
	
	var _TextControl = __webpack_require__(39);
	
	var _TextControl2 = _interopRequireDefault(_TextControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FileForm = function () {
	  function FileForm(element, args) {
	    _classCallCheck(this, FileForm);
	
	    var fieldsetFile = document.createElement('fieldset');
	    var legendFile = document.createElement('legend');
	    legendFile.innerHTML = 'Bestandsgegevens';
	    fieldsetFile.appendChild(legendFile);
	
	    this.id = new _TextControl2.default(fieldsetFile, { label: 'Id', value: args.file.values.id, onchange: args.onchange });
	    this.contents = new _TextControl2.default(fieldsetFile, { label: 'Inhoud', value: args.file.values.contents, onchange: args.onchange });
	
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(fieldsetFile);
	    element.appendChild(fragment);
	  }
	
	  _createClass(FileForm, [{
	    key: 'getValue',
	    value: function getValue() {
	      var file = new _FileModel2.default();
	      file.values.id = this.id.getValue();
	      file.values.contents = this.contents.getValue();
	      return file;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(file) {
	      this.id.setValue(file.values.id);
	      this.contents.setValue(file.values.contents);
	    }
	  }]);
	
	  return FileForm;
	}();
	
	exports.default = FileForm;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _TextControl = __webpack_require__(39);
	
	var _TextControl2 = _interopRequireDefault(_TextControl);
	
	var _PasswordControl = __webpack_require__(74);
	
	var _PasswordControl2 = _interopRequireDefault(_PasswordControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EnterCredentials = function EnterCredentials(element) {
	  var _this = this;
	
	  _classCallCheck(this, EnterCredentials);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Uw PRIM account'
	  });
	
	  var checkCredentials = function checkCredentials() {
	    if (!_this.username.getValue() || !_this.password.getValue()) {
	      alert('Vul uw gebruikersnaam en wachtwoord in.');
	      return;
	    }
	
	    window.PRIM.dataAccess.setCredentials(_this.username.getValue(), _this.password.getValue());
	    window.PRIM.dataAccess.externalStatus().then(function (status) {
	      switch (status) {
	        case 'invalid':
	          alert('PRIM account gegevens zijn niet correct. Probeer het opnieuw.');
	          break;
	        case 'exists':
	          //alert('PRIM account gegevens zijn correct en zullen voortaan gebruikt worden. Deze kunt u later wijzigen bij instellingen.')
	          //window.PRIM.saveCredentials(this.username.getValue(), this.password.getValue())
	          window.PRIM.navigate('/sync/');
	          break;
	        default:
	          window.PRIM.setLicense(status);
	          //alert('PRIM account gegevens zijn correct en zullen voortaan gebruikt worden. Deze kunt u later wijzigen bij instellingen.')
	          //window.PRIM.saveCredentials(this.username.getValue(), this.password.getValue())
	          window.PRIM.session.password = _this.password.getValue();
	
	          if (window.PRIM.License.isDemo) {
	            alert('U logt in met een PRIM demonstratie account. Dit account biedt u de mogelijkheid om PRIM uit te proberen. Er zullen echter geen gegevens worden bewaard. Voer daarom geen gegevens die belangrijk voor u zijn.');
	            addEventListener('beforeunload', function (e) {
	              e.returnValue = 'U verlaat de demonstratieversie van PRIM. Eventuele ingevoerde gegevens zijn niet opgeslagen. Weet u het zeker?';
	              return e.returnValue;
	            });
	          }
	
	          window.PRIM.navigate('/sync/');
	          break;
	      }
	    }, function (e) {
	      alert('PRIM account gegevens konden niet gecontroleerd worden. De server is tijdelijk niet bereikbaar. Probeer het opnieuw.');
	    });
	  };
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var p = document.createElement('p');
	  p.innerHTML = 'Om in te loggen, voer hieronder uw PRIM account gegevens in.';
	
	  var fieldset = document.createElement('fieldset');
	  var legend = document.createElement('legend');
	  legend.innerHTML = 'Account gegevens';
	  fieldset.appendChild(legend);
	
	  this.username = new _TextControl2.default(fieldset, { label: 'PRIM gebruikersnaam' });
	  this.password = new _PasswordControl2.default(fieldset, { label: 'PRIM wachtwoord' });
	
	  var button = document.createElement('button');
	  button.innerHTML = 'Inloggen';
	  button.onclick = checkCredentials;
	
	  /*let buttonPrevious = document.createElement('button')
	  buttonPrevious.innerHTML = 'Vorige'
	  buttonPrevious.onclick = () => {
	    window.PRIM.navigate('/welcome/')
	  }*/
	
	  div.appendChild(p);
	  div.appendChild(fieldset);
	
	  div.appendChild(button);
	  //div.appendChild(buttonPrevious)
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = EnterCredentials;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PasswordControl = function () {
	  function PasswordControl(element, args) {
	    _classCallCheck(this, PasswordControl);
	
	    var div = document.createElement('div');
	    this.input = document.createElement('input');
	    this.input.id = window.PRIM.getUUID();
	    this.input.value = args.value ? args.value : '';
	    this.input.type = 'password';
	    this.input.disabled = args.readonly ? 'disabled' : '';
	    this.input.onchange = args.onchange;
	    this.label = document.createElement('label');
	    this.label.innerHTML = args.label;
	    this.label.htmlFor = this.input.id;
	    var fragment = document.createDocumentFragment();
	    fragment.appendChild(div);
	    div.appendChild(this.label);
	    div.appendChild(this.input);
	
	    element.appendChild(fragment);
	  }
	
	  _createClass(PasswordControl, [{
	    key: 'setLabel',
	    value: function setLabel(text) {
	      this.label.innerHTML = text;
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input.value ? this.input.value : null;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.input.value = value;
	    }
	  }]);
	
	  return PasswordControl;
	}();
	
	exports.default = PasswordControl;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	var _PasswordControl = __webpack_require__(74);
	
	var _PasswordControl2 = _interopRequireDefault(_PasswordControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ChangeCredentials = function ChangeCredentials(element) {
	  var _this = this;
	
	  _classCallCheck(this, ChangeCredentials);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Uw PRIM wachtwoord wijzigen',
	    leftHandButtons: [{
	      onclick: function onclick() {
	        history.back();
	      },
	      icon: '\uE00D'
	    }]
	  });
	
	  var checkCredentials = function checkCredentials() {
	    if (!_this.oldpassword.getValue() || !_this.password1.getValue() || !_this.password2.getValue()) {
	      alert('Vul uw oude en nieuwe wachtwoord in.');
	      return;
	    }
	
	    if (_this.password1.getValue() !== _this.password2.getValue()) {
	      alert('Uw nieuwe wachtwoorden komen niet overeen. Corrigeer uw invoer en probeer het opnieuw.');
	      return;
	    }
	
	    if (_this.oldpassword.getValue() === _this.password1.getValue()) {
	      alert('Uw oude en nieuwe wachtwoord mogen niet overeen komen. Kies een ander wachtwoord.');
	      return;
	    }
	
	    if (_this.password1.getValue().length < 12) {
	      alert('Uw nieuwe wachtwoord moet tenminste 12 tekens lang zijn vanwege veiligheid. Kies een langer wachtwoord.');
	      return;
	    }
	
	    var lowercase = new RegExp(/[a-z]/g);
	
	    if (!lowercase.test(_this.password1.getValue())) {
	      alert('Uw nieuwe wachtwoord moet tenminste 1 kleine letter bevatten. Probeer opnieuw.');
	      return;
	    }
	
	    var uppercase = new RegExp(/[A-Z]/g);
	
	    if (!uppercase.test(_this.password1.getValue())) {
	      alert('Uw nieuwe wachtwoord moet tenminste 1 hoofdletter bevatten. Probeer opnieuw.');
	      return;
	    }
	
	    var digits = new RegExp(/\d/g);
	
	    if (!digits.test(_this.password1.getValue())) {
	      alert('Uw nieuwe wachtwoord moet tenminste 1 cijfer bevatten. Probeer opnieuw.');
	      return;
	    }
	
	    var special = new RegExp(/\W/g);
	
	    if (!special.test(_this.password1.getValue())) {
	      alert('Uw nieuwe wachtwoord moet tenminste 1 speciaal teken bevatten. Probeer opnieuw.');
	      return;
	    }
	
	    window.PRIM.dataAccess.isCurrentPassword(_this.oldpassword.getValue()).then(function (status) {
	      switch (status) {
	        case 'invalid':
	          alert('Uw oude wachtwoord is onjuist. Probeer het opnieuw.');
	          return;
	        default:
	          window.PRIM.dataAccess.setCredentials(null, _this.oldpassword.getValue());
	          window.PRIM.dataAccess.externalChangePassword(_this.password1.getValue()).then(function (status) {
	            switch (status) {
	              default:
	                alert('Uw PRIM account wachtwoord is gewijzigd. Log voortaan in met dit nieuw gekozen wachtwoord.');
	                window.PRIM.dataAccess.setCredentials(null, _this.password1.getValue());
	                window.PRIM.session.password = _this.password1.getValue();
	                break;
	            }
	          }, function (e) {
	            alert('Uw PRIM account wachtwoord kon niet gewijzigd worden. De server is tijdelijk niet bereikbaar. Probeer het opnieuw.');
	          });
	      }
	    }, function (e) {
	      alert('Uw PRIM account wachtwoord kon niet gewijzigd worden. De server is tijdelijk niet bereikbaar. Probeer het opnieuw.');
	    });
	  };
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var p = document.createElement('p');
	
	  if (window.PRIM.License.isDemo) {
	    p.innerHTML = 'In de demonstratieversie van PRIM is het niet mogelijk om het wachtwoord te wijzigen.';
	  } else {
	    p.innerHTML = 'Om uw wachtwoord te wijzigen, voer hieronder uw oude wachtwoord en 2 maal het nieuwe wachtwoord in. Het nieuwe wachtwoord moet vanwege veiligheid:';
	  }
	
	  div.appendChild(p);
	
	  if (!window.PRIM.License.isDemo) {
	    var ul = document.createElement('ul');
	    var li = document.createElement('li');
	    li.innerHTML = 'tenminste 12 tekens lang zijn';
	    ul.appendChild(li);
	    li = document.createElement('li');
	    li.innerHTML = 'tenminste 1 cijfer bevatten';
	    ul.appendChild(li);
	    li = document.createElement('li');
	    li.innerHTML = 'tenminste 1 hoofdletter bevatten';
	    ul.appendChild(li);
	    li = document.createElement('li');
	    li.innerHTML = 'tenminste 1 kleine letter bevatten';
	    ul.appendChild(li);
	    li = document.createElement('li');
	    li.innerHTML = 'tenminste 1 speciaal teken bevatten';
	    ul.appendChild(li);
	
	    div.appendChild(ul);
	
	    p = document.createElement('p');
	    p.innerHTML = 'Het gebruik van jaartalen, adres gegevens en namen is af te raden. Woorden zijn te gebruiken zolang ze onderling met elkaar en met u persoonlijk geen verband hebben. Dit zat niet gecontroleerd worden en u dient dit zelf na te gaan.';
	
	    div.appendChild(p);
	
	    var fieldset = document.createElement('fieldset');
	    var legend = document.createElement('legend');
	    legend.innerHTML = 'Uw PRIM account wachtwoord';
	    fieldset.appendChild(legend);
	
	    this.oldpassword = new _PasswordControl2.default(fieldset, { label: 'Oud wachtwoord' });
	    this.password1 = new _PasswordControl2.default(fieldset, { label: 'Nieuw wachtwoord' });
	    this.password2 = new _PasswordControl2.default(fieldset, { label: 'Nieuw wachtwoord herhalen' });
	
	    var button = document.createElement('button');
	    button.innerHTML = 'Account wachtwoord wijzigen';
	    button.onclick = checkCredentials;
	
	    div.appendChild(fieldset);
	
	    div.appendChild(button);
	  }
	
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = ChangeCredentials;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Welcome = function Welcome(element) {
	  _classCallCheck(this, Welcome);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Welkom'
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var p = document.createElement('p');
	  p.innerHTML = 'Hartelijk dank voor het gebruik van PRIM. Wij zullen in de volgende stappen u een aantal beveiligingsvragen stellen. Hierna kunt u beginnen met werken.';
	
	  var button = document.createElement('button');
	  button.innerHTML = 'Volgende';
	  button.onclick = function () {
	    window.PRIM.navigate('/entercredentials/');
	  };
	
	  div.appendChild(p);
	  div.appendChild(button);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	};
	
	exports.default = Welcome;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavigationBarControl = __webpack_require__(16);
	
	var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Sync = function Sync(element) {
	  _classCallCheck(this, Sync);
	
	  var fragment = document.createDocumentFragment();
	  new _NavigationBarControl2.default(fragment, {
	    title: 'Synchroniseren'
	  });
	
	  var div = document.createElement('div');
	  div.className = 'viewport';
	
	  var p = document.createElement('p');
	  p.innerHTML = 'Een ogenblik geduld alstublieft. Uw apparaat synchroniseert uw laatste gegevens, dit kan enkele seconden duren...';
	
	  window.PRIM.bootMessage = document.createElement('p');
	
	  div.appendChild(p);
	  div.appendChild(window.PRIM.bootMessage);
	  fragment.appendChild(div);
	
	  element.appendChild(fragment);
	
	  window.PRIM.initExternalStorage();
	};
	
	exports.default = Sync;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js